[
  {
    "name" : "CUSTOMS OFFICE SANT JULIÀ DE LÒRIA",
    "unCode" : "AD000001",
    "ics" : false
  },
  {
    "name" : "DCNJ PORTA",
    "unCode" : "AD000002",
    "ics" : false
  },
  {
    "name" : "CENTRAL CUSTOMS OFFICE",
    "unCode" : "AD000003",
    "ics" : false
  },
  {
    "name" : "Wien",
    "unCode" : "AT100000",
    "ics" : true
  },
  {
    "name" : "Hafen Wien",
    "unCode" : "AT100200",
    "ics" : true
  },
  {
    "name" : "St. Pölten",
    "unCode" : "AT230000",
    "ics" : true
  },
  {
    "name" : "Mistelbach",
    "unCode" : "AT230200",
    "ics" : true
  },
  {
    "name" : "Krems",
    "unCode" : "AT240000",
    "ics" : true
  },
  {
    "name" : "Hafen Krems",
    "unCode" : "AT240100",
    "ics" : true
  },
  {
    "name" : "Amstetten",
    "unCode" : "AT240200",
    "ics" : true
  },
  {
    "name" : "Gmünd-Nagelberg",
    "unCode" : "AT240400",
    "ics" : true
  },
  {
    "name" : "Hollabrunn",
    "unCode" : "AT240500",
    "ics" : true
  },
  {
    "name" : "Wiener Neustadt",
    "unCode" : "AT250000",
    "ics" : true
  },
  {
    "name" : "Wiener Neudorf",
    "unCode" : "AT250100",
    "ics" : true
  },
  {
    "name" : "Wr. Neudorf Außenstelle Abfertigung",
    "unCode" : "AT250101",
    "ics" : true
  },
  {
    "name" : "Eisenstadt",
    "unCode" : "AT320000",
    "ics" : true
  },
  {
    "name" : "Eisenstadt/Strasse",
    "unCode" : "AT320200",
    "ics" : true
  },
  {
    "name" : "Nickelsdorf",
    "unCode" : "AT320300",
    "ics" : true
  },
  {
    "name" : "Heiligenkreuz",
    "unCode" : "AT320400",
    "ics" : true
  },
  {
    "name" : "Oberwart",
    "unCode" : "AT320600",
    "ics" : true
  },
  {
    "name" : "Flughafen Wien Güterabfertigung",
    "unCode" : "AT330100",
    "ics" : true
  },
  {
    "name" : "Flughafen Wien Reisendenabfertigung",
    "unCode" : "AT330200",
    "ics" : true
  },
  {
    "name" : "Maria Lanzendorf",
    "unCode" : "AT330300",
    "ics" : true
  },
  {
    "name" : "Flughafen Wien Cargo Center Nord",
    "unCode" : "AT330400",
    "ics" : true
  },
  {
    "name" : "Klagenfurt",
    "unCode" : "AT420000",
    "ics" : true
  },
  {
    "name" : "Klagenfurt Flughafen/Strasse",
    "unCode" : "AT420100",
    "ics" : true
  },
  {
    "name" : "Villach",
    "unCode" : "AT430000",
    "ics" : true
  },
  {
    "name" : "Bahnhof Villach Süd",
    "unCode" : "AT430100",
    "ics" : true
  },
  {
    "name" : "Linz",
    "unCode" : "AT520000",
    "ics" : true
  },
  {
    "name" : "Flughafen Linz",
    "unCode" : "AT520100",
    "ics" : true
  },
  {
    "name" : "Hafen Enns",
    "unCode" : "AT520300",
    "ics" : true
  },
  {
    "name" : "Wels",
    "unCode" : "AT530000",
    "ics" : true
  },
  {
    "name" : "Suben",
    "unCode" : "AT530200",
    "ics" : true
  },
  {
    "name" : "Salzburg",
    "unCode" : "AT600000",
    "ics" : true
  },
  {
    "name" : "Flughafen Salzburg",
    "unCode" : "AT600200",
    "ics" : true
  },
  {
    "name" : "Zollstelle Güterverkehr Straße",
    "unCode" : "AT600300",
    "ics" : true
  },
  {
    "name" : "Liefering/Bahn",
    "unCode" : "AT600400",
    "ics" : true
  },
  {
    "name" : "Graz",
    "unCode" : "AT700000",
    "ics" : true
  },
  {
    "name" : "Flughafen Graz",
    "unCode" : "AT700100",
    "ics" : true
  },
  {
    "name" : "Containerterminal Werndorf",
    "unCode" : "AT700200",
    "ics" : true
  },
  {
    "name" : "Leoben",
    "unCode" : "AT700300",
    "ics" : true
  },
  {
    "name" : "Spielfeld",
    "unCode" : "AT700400",
    "ics" : true
  },
  {
    "name" : "Innsbruck",
    "unCode" : "AT800000",
    "ics" : true
  },
  {
    "name" : "Flughafen Innsbruck",
    "unCode" : "AT800200",
    "ics" : true
  },
  {
    "name" : "Hall",
    "unCode" : "AT800300",
    "ics" : true
  },
  {
    "name" : "Lienz",
    "unCode" : "AT800600",
    "ics" : true
  },
  {
    "name" : "Kufstein",
    "unCode" : "AT800700",
    "ics" : true
  },
  {
    "name" : "Martinsbruck",
    "unCode" : "AT800900",
    "ics" : true
  },
  {
    "name" : "Pfunds Spiss",
    "unCode" : "AT801000",
    "ics" : true
  },
  {
    "name" : "Feldkirch",
    "unCode" : "AT920000",
    "ics" : true
  },
  {
    "name" : "Buchs/Bahnhof",
    "unCode" : "AT920100",
    "ics" : true
  },
  {
    "name" : "Tisis",
    "unCode" : "AT920400",
    "ics" : true
  },
  {
    "name" : "Meiningen",
    "unCode" : "AT920700",
    "ics" : true
  },
  {
    "name" : "Mäder",
    "unCode" : "AT920900",
    "ics" : true
  },
  {
    "name" : "Wolfurt",
    "unCode" : "AT930000",
    "ics" : true
  },
  {
    "name" : "Wolfurt/Post",
    "unCode" : "AT930100",
    "ics" : true
  },
  {
    "name" : "Wolfurt/Post Selbstverzollung",
    "unCode" : "AT930101",
    "ics" : true
  },
  {
    "name" : "Hohenems",
    "unCode" : "AT930200",
    "ics" : true
  },
  {
    "name" : "Lustenau",
    "unCode" : "AT930300",
    "ics" : true
  },
  {
    "name" : "Höchst",
    "unCode" : "AT930600",
    "ics" : true
  },
  {
    "name" : "Seehafen Bregenz",
    "unCode" : "AT930800",
    "ics" : true
  },
  {
    "name" : "St. Margrethen",
    "unCode" : "AT930900",
    "ics" : true
  },
  {
    "name" : "ANTWERPEN DAE",
    "unCode" : "BE101000",
    "ics" : true
  },
  {
    "name" : "BRUXELLES DE",
    "unCode" : "BE204000",
    "ics" : true
  },
  {
    "name" : "ZAVENTEM D",
    "unCode" : "BE212000",
    "ics" : true
  },
  {
    "name" : "GENT DAE",
    "unCode" : "BE312000",
    "ics" : true
  },
  {
    "name" : "ZEEBRUGGE D",
    "unCode" : "BE343000",
    "ics" : true
  },
  {
    "name" : "HASSELT DA",
    "unCode" : "BE408000",
    "ics" : true
  },
  {
    "name" : "TIENEN DAE",
    "unCode" : "BE424000",
    "ics" : true
  },
  {
    "name" : "GEEL DAE",
    "unCode" : "BE432000",
    "ics" : true
  },
  {
    "name" : "ARLON DA",
    "unCode" : "BE501000",
    "ics" : true
  },
  {
    "name" : "EYNATTEN (RAEREN) Z",
    "unCode" : "BE514000",
    "ics" : true
  },
  {
    "name" : "BIERSET (GRACE-HOLLOGNE) DE",
    "unCode" : "BE532000",
    "ics" : true
  },
  {
    "name" : "LA LOUVIERE DAE",
    "unCode" : "BE632000",
    "ics" : true
  },
  {
    "name" : "NAMUR DA",
    "unCode" : "BE648000",
    "ics" : true
  },
  {
    "name" : "GOSSELIES (CHARLEROI) DAE",
    "unCode" : "BE680000",
    "ics" : true
  },
  {
    "name" : "MP Letishte Burgas",
    "unCode" : "BG001002",
    "ics" : true
  },
  {
    "name" : "MP M.Tarnovo",
    "unCode" : "BG001003",
    "ics" : true
  },
  {
    "name" : "CB Petrochemical plant",
    "unCode" : "BG001005",
    "ics" : true
  },
  {
    "name" : "MP Pristanishte Burgas tsentar",
    "unCode" : "BG001007",
    "ics" : true
  },
  {
    "name" : "MB Svobodna Zona",
    "unCode" : "BG001008",
    "ics" : true
  },
  {
    "name" : "CB Sliven",
    "unCode" : "BG001009",
    "ics" : true
  },
  {
    "name" : "MB Yambol",
    "unCode" : "BG001010",
    "ics" : true
  },
  {
    "name" : "MP Lesovo",
    "unCode" : "BG001011",
    "ics" : true
  },
  {
    "name" : "CP Tsarevo",
    "unCode" : "BG001012",
    "ics" : true
  },
  {
    "name" : "CP Neftopristanishte",
    "unCode" : "BG001013",
    "ics" : true
  },
  {
    "name" : "CP Zh.P. Gara Svilengrad",
    "unCode" : "BG001014",
    "ics" : true
  },
  {
    "name" : "MP Kapitan Andreevo",
    "unCode" : "BG001015",
    "ics" : true
  },
  {
    "name" : "CP Varna-West",
    "unCode" : "BG002002",
    "ics" : true
  },
  {
    "name" : "CP Varna Airport",
    "unCode" : "BG002003",
    "ics" : true
  },
  {
    "name" : "CP Varna Port",
    "unCode" : "BG002005",
    "ics" : true
  },
  {
    "name" : "CP Lesport Port",
    "unCode" : "BG002006",
    "ics" : true
  },
  {
    "name" : "CP Varna-Ferry",
    "unCode" : "BG002007",
    "ics" : true
  },
  {
    "name" : "CB Shumen",
    "unCode" : "BG002008",
    "ics" : true
  },
  {
    "name" : "MB Dobrich",
    "unCode" : "BG002009",
    "ics" : true
  },
  {
    "name" : "CP Balchik",
    "unCode" : "BG002010",
    "ics" : true
  },
  {
    "name" : "MB Kazanlak",
    "unCode" : "BG003001",
    "ics" : true
  },
  {
    "name" : "MP Letishte Plovdiv",
    "unCode" : "BG003002",
    "ics" : true
  },
  {
    "name" : "MB Pazardzhik",
    "unCode" : "BG003004",
    "ics" : true
  },
  {
    "name" : "MB Svobodna zona Plovdiv",
    "unCode" : "BG003005",
    "ics" : true
  },
  {
    "name" : "MB Smolyan",
    "unCode" : "BG003006",
    "ics" : true
  },
  {
    "name" : "MB Karlovo",
    "unCode" : "BG003007",
    "ics" : true
  },
  {
    "name" : "MB Stara Zagora",
    "unCode" : "BG003008",
    "ics" : true
  },
  {
    "name" : "MB Plovdiv",
    "unCode" : "BG003009",
    "ics" : true
  },
  {
    "name" : "MB Svilengrad",
    "unCode" : "BG003010",
    "ics" : true
  },
  {
    "name" : "MB Kardzhali",
    "unCode" : "BG003011",
    "ics" : true
  },
  {
    "name" : "MB Haskovo",
    "unCode" : "BG003012",
    "ics" : true
  },
  {
    "name" : "MB Intermodalen terminal",
    "unCode" : "BG003013",
    "ics" : true
  },
  {
    "name" : "MB Razgrad",
    "unCode" : "BG004002",
    "ics" : true
  },
  {
    "name" : "CP Pristanishte",
    "unCode" : "BG004006",
    "ics" : true
  },
  {
    "name" : "MB Targovishte",
    "unCode" : "BG004011",
    "ics" : true
  },
  {
    "name" : "Customs Point Silistra",
    "unCode" : "BG004014",
    "ics" : true
  },
  {
    "name" : "MB Vratsa",
    "unCode" : "BG004201",
    "ics" : true
  },
  {
    "name" : "MP Oryahovо",
    "unCode" : "BG004203",
    "ics" : true
  },
  {
    "name" : "MP Pristanishte Lom",
    "unCode" : "BG004205",
    "ics" : true
  },
  {
    "name" : "MB Montana",
    "unCode" : "BG004210",
    "ics" : true
  },
  {
    "name" : "MB Vidin",
    "unCode" : "BG004211",
    "ics" : true
  },
  {
    "name" : "MP Bregovo",
    "unCode" : "BG004212",
    "ics" : true
  },
  {
    "name" : "MP Vrashka chuka",
    "unCode" : "BG004213",
    "ics" : true
  },
  {
    "name" : "CustBorderPoint Svishtov",
    "unCode" : "BG004300",
    "ics" : true
  },
  {
    "name" : "MB Gabrovo",
    "unCode" : "BG004301",
    "ics" : true
  },
  {
    "name" : "MP Letishte Gorna Oryahovitsa",
    "unCode" : "BG004303",
    "ics" : true
  },
  {
    "name" : "MB Lovech",
    "unCode" : "BG004304",
    "ics" : true
  },
  {
    "name" : "MB Pleven",
    "unCode" : "BG004306",
    "ics" : true
  },
  {
    "name" : "MP Somovit",
    "unCode" : "BG004307",
    "ics" : true
  },
  {
    "name" : "MB Sevlievo",
    "unCode" : "BG004309",
    "ics" : true
  },
  {
    "name" : "CB Troyan",
    "unCode" : "BG004311",
    "ics" : true
  },
  {
    "name" : "CustOffice Airport Sofia",
    "unCode" : "BG005100",
    "ics" : true
  },
  {
    "name" : "MP Letishte Sofia - patnitsi",
    "unCode" : "BG005106",
    "ics" : true
  },
  {
    "name" : "MP Aerogara Sofia - tovari",
    "unCode" : "BG005107",
    "ics" : true
  },
  {
    "name" : "CustOffice Blagoevgrad",
    "unCode" : "BG005700",
    "ics" : true
  },
  {
    "name" : "MB Gotse Delchev",
    "unCode" : "BG005701",
    "ics" : true
  },
  {
    "name" : "MP Gyueshevo",
    "unCode" : "BG005702",
    "ics" : true
  },
  {
    "name" : "MP Zlatarevo",
    "unCode" : "BG005703",
    "ics" : true
  },
  {
    "name" : "MB Kulata",
    "unCode" : "BG005704",
    "ics" : true
  },
  {
    "name" : "MB Kyustendil",
    "unCode" : "BG005705",
    "ics" : true
  },
  {
    "name" : "MP Logodazh",
    "unCode" : "BG005706",
    "ics" : true
  },
  {
    "name" : "MP Oltomantsi",
    "unCode" : "BG005707",
    "ics" : true
  },
  {
    "name" : "MB Botevgrad",
    "unCode" : "BG005801",
    "ics" : true
  },
  {
    "name" : "MB Dragoman",
    "unCode" : "BG005803",
    "ics" : true
  },
  {
    "name" : "MP Kalotina",
    "unCode" : "BG005804",
    "ics" : true
  },
  {
    "name" : "MB Pernik",
    "unCode" : "BG005805",
    "ics" : true
  },
  {
    "name" : "MB Sofia-Zapad",
    "unCode" : "BG005807",
    "ics" : true
  },
  {
    "name" : "MB Sofia-Iztok",
    "unCode" : "BG005808",
    "ics" : true
  },
  {
    "name" : "MP Strezimirovtsi",
    "unCode" : "BG005809",
    "ics" : true
  },
  {
    "name" : "MB BRSC",
    "unCode" : "BG005810",
    "ics" : true
  },
  {
    "name" : "MB Slatina",
    "unCode" : "BG005811",
    "ics" : true
  },
  {
    "name" : "Douane Centre - Boncourt/Delle-Auto",
    "unCode" : "CH001141",
    "ics" : true
  },
  {
    "name" : "Douane Centre - Boncourt Intérieur",
    "unCode" : "CH001142",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Mitte",
    "unCode" : "CH001251",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Mitte Konv.",
    "unCode" : "CH001252",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Messe",
    "unCode" : "CH001454",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Rheinhäfen",
    "unCode" : "CH001471",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Riehen",
    "unCode" : "CH001501",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Grenzacherstrasse",
    "unCode" : "CH001551",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Umschlagbahnhof",
    "unCode" : "CH001571",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Stein/Bad Säckingen",
    "unCode" : "CH001591",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Laufenburg",
    "unCode" : "CH001601",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Brugg",
    "unCode" : "CH001631",
    "ics" : true
  },
  {
    "name" : "Zoll Mitte - Bern",
    "unCode" : "CH001661",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Flughafen Fracht",
    "unCode" : "CH001711",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel Flughafen Kurier",
    "unCode" : "CH001712",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Pratteln",
    "unCode" : "CH001731",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel/Weil Rhein-Autoba",
    "unCode" : "CH001801",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Basel/St.Louis Autobahn",
    "unCode" : "CH001841",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Rheinfelden Autobahn",
    "unCode" : "CH001921",
    "ics" : true
  },
  {
    "name" : "Zoll Nord - Koblenz",
    "unCode" : "CH002041",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Trasadingen",
    "unCode" : "CH002091",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Schleitheim",
    "unCode" : "CH002151",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Rafz-Solgen",
    "unCode" : "CH002261",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Neuhausen",
    "unCode" : "CH002291",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Bargen",
    "unCode" : "CH002311",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Ramsen",
    "unCode" : "CH002411",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Thayngen",
    "unCode" : "CH002471",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Kreuzlingen Autobahn",
    "unCode" : "CH002621",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Romanshorn",
    "unCode" : "CH002671",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich",
    "unCode" : "CH002711",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich 1",
    "unCode" : "CH002751",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich 2",
    "unCode" : "CH002752",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich 3",
    "unCode" : "CH002753",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich Kurier",
    "unCode" : "CH002754",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich Messe",
    "unCode" : "CH002755",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Mülligen",
    "unCode" : "CH002756",
    "ics" : true
  },
  {
    "name" : "Zoll Nordost - Zürich-Flughafen",
    "unCode" : "CH002771",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - St. Gallen",
    "unCode" : "CH003011",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Wolfurt",
    "unCode" : "CH003031",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Altenrhein-Flughafen",
    "unCode" : "CH003041",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - St. Margrethen Strasse",
    "unCode" : "CH003071",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Au",
    "unCode" : "CH003081",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - St. Margrethen Freilager",
    "unCode" : "CH003091",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Kriessern",
    "unCode" : "CH003121",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Buchs",
    "unCode" : "CH003140",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Oberriet",
    "unCode" : "CH003151",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Schaanwald",
    "unCode" : "CH003201",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Martina",
    "unCode" : "CH003261",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Müstair",
    "unCode" : "CH003301",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - La Drossa",
    "unCode" : "CH003331",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Campocologno",
    "unCode" : "CH003361",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Castasegna",
    "unCode" : "CH003401",
    "ics" : true
  },
  {
    "name" : "Zoll Ost - Diepoldsau",
    "unCode" : "CH003451",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Vedeggio",
    "unCode" : "CH004011",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Gandria",
    "unCode" : "CH004031",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Ponte Tresa",
    "unCode" : "CH004101",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Aeroporto Agno",
    "unCode" : "CH004131",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Mendrisio SDA DDA",
    "unCode" : "CH004162",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Mendrisio Confine",
    "unCode" : "CH004163",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Mendrisio DFD",
    "unCode" : "CH004164",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Chiasso-Strada",
    "unCode" : "CH004181",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Brogeda Autostrada",
    "unCode" : "CH004182",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Chiasso Viaggiatori",
    "unCode" : "CH004183",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Madonna di Ponte",
    "unCode" : "CH004421",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Luino",
    "unCode" : "CH004491",
    "ics" : true
  },
  {
    "name" : "Dogana Sud - Bissone",
    "unCode" : "CH004581",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Chavornay",
    "unCode" : "CH005031",
    "ics" : true
  },
  {
    "name" : "Zoll West - Domo 2",
    "unCode" : "CH005040",
    "ics" : true
  },
  {
    "name" : "Zoll West - Gamsen",
    "unCode" : "CH005051",
    "ics" : true
  },
  {
    "name" : "Zoll West - Gondo",
    "unCode" : "CH005081",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - St. Gingolph",
    "unCode" : "CH005121",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Vallorbe",
    "unCode" : "CH005441",
    "ics" : true
  },
  {
    "name" : "Douane Centre - Les Verrières",
    "unCode" : "CH005491",
    "ics" : true
  },
  {
    "name" : "Douane Centre - Le Crêt-du-Locle",
    "unCode" : "CH005551",
    "ics" : true
  },
  {
    "name" : "Douane Centre - Col France",
    "unCode" : "CH005561",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Martigny",
    "unCode" : "CH005691",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Gd-St-Bernard T Sud",
    "unCode" : "CH005701",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Genève Port Franc",
    "unCode" : "CH006021",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Thônex-Vallard",
    "unCode" : "CH006221",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Bardonnex",
    "unCode" : "CH006251",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Bardonnex Primeurs",
    "unCode" : "CH006252",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Ferney-Voltaire",
    "unCode" : "CH006451",
    "ics" : true
  },
  {
    "name" : "Douane Ouest - Genève-Aéroport Fret",
    "unCode" : "CH006521",
    "ics" : true
  },
  {
    "name" : "LARNACA PORT",
    "unCode" : "CY000410",
    "ics" : true
  },
  {
    "name" : "VASILICO-ZYGI",
    "unCode" : "CY000412",
    "ics" : true
  },
  {
    "name" : "LARNACA AIRPORT",
    "unCode" : "CY000440",
    "ics" : true
  },
  {
    "name" : "LIMASSOL PORT",
    "unCode" : "CY000510",
    "ics" : true
  },
  {
    "name" : "LIMASSOL ANCHORAGE",
    "unCode" : "CY000511",
    "ics" : true
  },
  {
    "name" : "PAPHOS CUSTOMS",
    "unCode" : "CY000610",
    "ics" : true
  },
  {
    "name" : "PAPHOS AIRPORT",
    "unCode" : "CY000640",
    "ics" : true
  },
  {
    "name" : "celní - letiště, Brno",
    "unCode" : "CZ121020",
    "ics" : true
  },
  {
    "name" : "celní Brno I, Brno",
    "unCode" : "CZ121030",
    "ics" : true
  },
  {
    "name" : "celní Brno II, Brno",
    "unCode" : "CZ121040",
    "ics" : true
  },
  {
    "name" : "celní Střítež, Střítež u Jihlavy",
    "unCode" : "CZ121050",
    "ics" : true
  },
  {
    "name" : "celní Lanžhot, Lanžhot",
    "unCode" : "CZ121060",
    "ics" : true
  },
  {
    "name" : "celní I, Pardubice",
    "unCode" : "CZ221010",
    "ics" : true
  },
  {
    "name" : "celní - letiště, Pardubice",
    "unCode" : "CZ221020",
    "ics" : true
  },
  {
    "name" : "celní Ústí n/L, Ústí nad Labem",
    "unCode" : "CZ221030",
    "ics" : true
  },
  {
    "name" : "celní Liberec, Liberec",
    "unCode" : "CZ221040",
    "ics" : true
  },
  {
    "name" : "celní Hradec Králové",
    "unCode" : "CZ221050",
    "ics" : true
  },
  {
    "name" : "celní Pardubice, Pardubice",
    "unCode" : "CZ221060",
    "ics" : true
  },
  {
    "name" : "celní Česká Třebová, Česká Třebová",
    "unCode" : "CZ221061",
    "ics" : true
  },
  {
    "name" : "celní - letiště, Mošnov",
    "unCode" : "CZ321020",
    "ics" : true
  },
  {
    "name" : "celní Mošnov, Mošnov",
    "unCode" : "CZ321030",
    "ics" : true
  },
  {
    "name" : "celní Paskov, Paskov",
    "unCode" : "CZ321040",
    "ics" : true
  },
  {
    "name" : "celní Opava, Opava",
    "unCode" : "CZ321041",
    "ics" : true
  },
  {
    "name" : "celní Olomouc, Olomouc",
    "unCode" : "CZ321050",
    "ics" : true
  },
  {
    "name" : "celní Šumperk, Šumperk",
    "unCode" : "CZ321051",
    "ics" : true
  },
  {
    "name" : "celní Lípa, Lípa",
    "unCode" : "CZ321060",
    "ics" : true
  },
  {
    "name" : "celní Uherské Hradiště",
    "unCode" : "CZ321061",
    "ics" : true
  },
  {
    "name" : "celní I, České Budějovice",
    "unCode" : "CZ421010",
    "ics" : true
  },
  {
    "name" : "celní - letiště, Karlovy Vary",
    "unCode" : "CZ421020",
    "ics" : true
  },
  {
    "name" : "celní České Budějovice",
    "unCode" : "CZ421030",
    "ics" : true
  },
  {
    "name" : "celní Plzeň, Plzeň",
    "unCode" : "CZ421040",
    "ics" : true
  },
  {
    "name" : "celní Karlovy Vary, Karlovy Vary",
    "unCode" : "CZ421041",
    "ics" : true
  },
  {
    "name" : "celní I, Praha 1",
    "unCode" : "CZ521010",
    "ics" : true
  },
  {
    "name" : "celní - letiště, Praha 6",
    "unCode" : "CZ521020",
    "ics" : true
  },
  {
    "name" : "celní Hostivař, Praha 10",
    "unCode" : "CZ521030",
    "ics" : true
  },
  {
    "name" : "celní pošta Hostivař, Praha 10",
    "unCode" : "CZ521040",
    "ics" : true
  },
  {
    "name" : "celní Uhříněves, Praha 10",
    "unCode" : "CZ521050",
    "ics" : true
  },
  {
    "name" : "celní Ruzyně, Praha 6",
    "unCode" : "CZ521060",
    "ics" : true
  },
  {
    "name" : "celní I, Mělník",
    "unCode" : "CZ621010",
    "ics" : true
  },
  {
    "name" : "celní Mělník, Mělník",
    "unCode" : "CZ621020",
    "ics" : true
  },
  {
    "name" : "celní Kosmonosy, Kosmonosy",
    "unCode" : "CZ621021",
    "ics" : true
  },
  {
    "name" : "celní Kolín, Kolín",
    "unCode" : "CZ621030",
    "ics" : true
  },
  {
    "name" : "celní Benešov, Benešov",
    "unCode" : "CZ621031",
    "ics" : true
  },
  {
    "name" : "celní Rudná, Rudná",
    "unCode" : "CZ621040",
    "ics" : true
  },
  {
    "name" : "celní Zdiby, Zdiby",
    "unCode" : "CZ621050",
    "ics" : true
  },
  {
    "name" : "celní Kladno, Kladno",
    "unCode" : "CZ621060",
    "ics" : true
  },
  {
    "name" : "celní Říčany, Říčany - Jažlovice",
    "unCode" : "CZ621070",
    "ics" : true
  },
  {
    "name" : "Berlin-Marzahn",
    "unCode" : "DE002101",
    "ics" : true
  },
  {
    "name" : "Schöneberg",
    "unCode" : "DE002151",
    "ics" : true
  },
  {
    "name" : "Berlin-Dreilinden",
    "unCode" : "DE002152",
    "ics" : true
  },
  {
    "name" : "Berlin-Messe",
    "unCode" : "DE002181",
    "ics" : true
  },
  {
    "name" : "Flughafen Bremen",
    "unCode" : "DE002301",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Bremen",
    "unCode" : "DE002307",
    "ics" : true
  },
  {
    "name" : "Bremen",
    "unCode" : "DE002325",
    "ics" : true
  },
  {
    "name" : "Bremerhaven",
    "unCode" : "DE002452",
    "ics" : true
  },
  {
    "name" : "Flughafen Düsseldorf",
    "unCode" : "DE002601",
    "ics" : true
  },
  {
    "name" : "Düsseldorf Nord",
    "unCode" : "DE002604",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Düsseldorf",
    "unCode" : "DE002605",
    "ics" : true
  },
  {
    "name" : "Düsseldorf Reisholz",
    "unCode" : "DE002607",
    "ics" : true
  },
  {
    "name" : "Düsseldorf Messe",
    "unCode" : "DE002631",
    "ics" : true
  },
  {
    "name" : "Essen",
    "unCode" : "DE002651",
    "ics" : true
  },
  {
    "name" : "Duisburg-Ruhrort",
    "unCode" : "DE002656",
    "ics" : true
  },
  {
    "name" : "Emmerich",
    "unCode" : "DE002701",
    "ics" : true
  },
  {
    "name" : "Straelen-Autobahn",
    "unCode" : "DE002702",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Weeze",
    "unCode" : "DE002704",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Flughafen Weeze",
    "unCode" : "DE002705",
    "ics" : true
  },
  {
    "name" : "Schwanenhaus",
    "unCode" : "DE002901",
    "ics" : true
  },
  {
    "name" : "Uerdingen",
    "unCode" : "DE002903",
    "ics" : true
  },
  {
    "name" : "Mönchengladbach",
    "unCode" : "DE002904",
    "ics" : true
  },
  {
    "name" : "Neuss",
    "unCode" : "DE002906",
    "ics" : true
  },
  {
    "name" : "Wuppertal",
    "unCode" : "DE002956",
    "ics" : true
  },
  {
    "name" : "Eisenach",
    "unCode" : "DE003002",
    "ics" : true
  },
  {
    "name" : "Am Flughafen Erfurt",
    "unCode" : "DE003003",
    "ics" : true
  },
  {
    "name" : "Jena",
    "unCode" : "DE003004",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Erfurt",
    "unCode" : "DE003009",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Luftverkehr",
    "unCode" : "DE003030",
    "ics" : true
  },
  {
    "name" : "Bensheim",
    "unCode" : "DE003201",
    "ics" : true
  },
  {
    "name" : "Wiesbaden",
    "unCode" : "DE003202",
    "ics" : true
  },
  {
    "name" : "Darmstadt",
    "unCode" : "DE003230",
    "ics" : true
  },
  {
    "name" : "Frankfurt am Main-Flughafen",
    "unCode" : "DE003302",
    "ics" : true
  },
  {
    "name" : "KEFR Frankfurt am Main",
    "unCode" : "DE003306",
    "ics" : true
  },
  {
    "name" : "KEF/Ü Frankfurt am Main",
    "unCode" : "DE003307",
    "ics" : true
  },
  {
    "name" : "Hanau",
    "unCode" : "DE003352",
    "ics" : true
  },
  {
    "name" : "Höchst",
    "unCode" : "DE003354",
    "ics" : true
  },
  {
    "name" : "Oberursel",
    "unCode" : "DE003356",
    "ics" : true
  },
  {
    "name" : "Frankfurt am Main-Osthafen",
    "unCode" : "DE003358",
    "ics" : true
  },
  {
    "name" : "Bad Hersfeld",
    "unCode" : "DE003401",
    "ics" : true
  },
  {
    "name" : "Fulda",
    "unCode" : "DE003430",
    "ics" : true
  },
  {
    "name" : "Marburg",
    "unCode" : "DE003452",
    "ics" : true
  },
  {
    "name" : "Wetzlar",
    "unCode" : "DE003453",
    "ics" : true
  },
  {
    "name" : "Kassel",
    "unCode" : "DE003454",
    "ics" : true
  },
  {
    "name" : "Finsterwalde",
    "unCode" : "DE003601",
    "ics" : true
  },
  {
    "name" : "Forst",
    "unCode" : "DE003603",
    "ics" : true
  },
  {
    "name" : "Frankfurt (Oder)-Autobahn",
    "unCode" : "DE003652",
    "ics" : true
  },
  {
    "name" : "Fürstenwalde",
    "unCode" : "DE003656",
    "ics" : true
  },
  {
    "name" : "Ludwigsfelde",
    "unCode" : "DE003701",
    "ics" : true
  },
  {
    "name" : "Velten",
    "unCode" : "DE003702",
    "ics" : true
  },
  {
    "name" : "Flughafen Berlin Brandenburg",
    "unCode" : "DE003703",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Berlin Brandenburg",
    "unCode" : "DE003704",
    "ics" : true
  },
  {
    "name" : "Neuruppin",
    "unCode" : "DE003730",
    "ics" : true
  },
  {
    "name" : "Perleberg",
    "unCode" : "DE003731",
    "ics" : true
  },
  {
    "name" : "Brandenburg",
    "unCode" : "DE003732",
    "ics" : true
  },
  {
    "name" : "Eberswalde",
    "unCode" : "DE003752",
    "ics" : true
  },
  {
    "name" : "Freiburg",
    "unCode" : "DE003954",
    "ics" : true
  },
  {
    "name" : "Appenweier",
    "unCode" : "DE003956",
    "ics" : true
  },
  {
    "name" : "Konstanz-Industriegebiet",
    "unCode" : "DE004002",
    "ics" : true
  },
  {
    "name" : "Konstanz-Autobahn (schweiz. Gebiet)",
    "unCode" : "DE004005",
    "ics" : true
  },
  {
    "name" : "Grenzacherhorn",
    "unCode" : "DE004051",
    "ics" : true
  },
  {
    "name" : "Lörrach-Stetten",
    "unCode" : "DE004053",
    "ics" : true
  },
  {
    "name" : "Weil am Rhein-Autobahn",
    "unCode" : "DE004055",
    "ics" : true
  },
  {
    "name" : "Deutsches Zollamt Basel",
    "unCode" : "DE004058",
    "ics" : true
  },
  {
    "name" : "Rheinfelden-Autobahn",
    "unCode" : "DE004062",
    "ics" : true
  },
  {
    "name" : "Weil am Rhein - Umschlagbahnhof",
    "unCode" : "DE004081",
    "ics" : true
  },
  {
    "name" : "Weil am Rhein",
    "unCode" : "DE004083",
    "ics" : true
  },
  {
    "name" : "Basler Häfen",
    "unCode" : "DE004085",
    "ics" : true
  },
  {
    "name" : "Rheinhafen",
    "unCode" : "DE004087",
    "ics" : true
  },
  {
    "name" : "Bietingen",
    "unCode" : "DE004101",
    "ics" : true
  },
  {
    "name" : "Neuhaus",
    "unCode" : "DE004102",
    "ics" : true
  },
  {
    "name" : "Rielasingen",
    "unCode" : "DE004103",
    "ics" : true
  },
  {
    "name" : "Singen-Bahnhof",
    "unCode" : "DE004105",
    "ics" : true
  },
  {
    "name" : "Deißlingen",
    "unCode" : "DE004106",
    "ics" : true
  },
  {
    "name" : "Erzingen",
    "unCode" : "DE004201",
    "ics" : true
  },
  {
    "name" : "Jestetten (schweiz. Gebiet)",
    "unCode" : "DE004203",
    "ics" : true
  },
  {
    "name" : "Laufenburg",
    "unCode" : "DE004204",
    "ics" : true
  },
  {
    "name" : "Lottstetten",
    "unCode" : "DE004205",
    "ics" : true
  },
  {
    "name" : "Stühlingen",
    "unCode" : "DE004206",
    "ics" : true
  },
  {
    "name" : "Waldshut",
    "unCode" : "DE004208",
    "ics" : true
  },
  {
    "name" : "Bad Säckingen",
    "unCode" : "DE004209",
    "ics" : true
  },
  {
    "name" : "Cuxhaven",
    "unCode" : "DE004501",
    "ics" : true
  },
  {
    "name" : "Hamburg-Flughafen",
    "unCode" : "DE004701",
    "ics" : true
  },
  {
    "name" : "Hamburg",
    "unCode" : "DE004851",
    "ics" : true
  },
  {
    "name" : "Wolfsburg",
    "unCode" : "DE004906",
    "ics" : true
  },
  {
    "name" : "Braunschweig- Broitzem",
    "unCode" : "DE004930",
    "ics" : true
  },
  {
    "name" : "Helmstedt-Autobahn",
    "unCode" : "DE004961",
    "ics" : true
  },
  {
    "name" : "Emden",
    "unCode" : "DE005004",
    "ics" : true
  },
  {
    "name" : "Papenburg",
    "unCode" : "DE005008",
    "ics" : true
  },
  {
    "name" : "Goslar",
    "unCode" : "DE005052",
    "ics" : true
  },
  {
    "name" : "Hameln",
    "unCode" : "DE005053",
    "ics" : true
  },
  {
    "name" : "Hildesheim",
    "unCode" : "DE005055",
    "ics" : true
  },
  {
    "name" : "Holzminden",
    "unCode" : "DE005056",
    "ics" : true
  },
  {
    "name" : "Göttingen",
    "unCode" : "DE005080",
    "ics" : true
  },
  {
    "name" : "Hannover-Nord",
    "unCode" : "DE005102",
    "ics" : true
  },
  {
    "name" : "Flughafen Hannover",
    "unCode" : "DE005103",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Hannover Langenhagen",
    "unCode" : "DE005104",
    "ics" : true
  },
  {
    "name" : "Hannover Messe",
    "unCode" : "DE005110",
    "ics" : true
  },
  {
    "name" : "Celle",
    "unCode" : "DE005111",
    "ics" : true
  },
  {
    "name" : "Soltau",
    "unCode" : "DE005202",
    "ics" : true
  },
  {
    "name" : "Stade",
    "unCode" : "DE005203",
    "ics" : true
  },
  {
    "name" : "Verden",
    "unCode" : "DE005204",
    "ics" : true
  },
  {
    "name" : "Lüneburg",
    "unCode" : "DE005230",
    "ics" : true
  },
  {
    "name" : "Brake",
    "unCode" : "DE005301",
    "ics" : true
  },
  {
    "name" : "Wilhelmshaven",
    "unCode" : "DE005310",
    "ics" : true
  },
  {
    "name" : "Oldenburg-Kreyenbrück",
    "unCode" : "DE005330",
    "ics" : true
  },
  {
    "name" : "Schüttorf",
    "unCode" : "DE005351",
    "ics" : true
  },
  {
    "name" : "Lohne",
    "unCode" : "DE005355",
    "ics" : true
  },
  {
    "name" : "Lingen",
    "unCode" : "DE005356",
    "ics" : true
  },
  {
    "name" : "Fledder",
    "unCode" : "DE005380",
    "ics" : true
  },
  {
    "name" : "Nossen",
    "unCode" : "DE005502",
    "ics" : true
  },
  {
    "name" : "Chemnitz",
    "unCode" : "DE005530",
    "ics" : true
  },
  {
    "name" : "Flughafen Dresden",
    "unCode" : "DE005552",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Dresden",
    "unCode" : "DE005555",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Leipzig",
    "unCode" : "DE005557",
    "ics" : true
  },
  {
    "name" : "Dresden",
    "unCode" : "DE005580",
    "ics" : true
  },
  {
    "name" : "Taucha",
    "unCode" : "DE005603",
    "ics" : true
  },
  {
    "name" : "Flughafen Leipzig",
    "unCode" : "DE005604",
    "ics" : true
  },
  {
    "name" : "IFS Radefeld",
    "unCode" : "DE005633",
    "ics" : true
  },
  {
    "name" : "Löbau",
    "unCode" : "DE005687",
    "ics" : true
  },
  {
    "name" : "Reichenbach",
    "unCode" : "DE005756",
    "ics" : true
  },
  {
    "name" : "Bruchsal",
    "unCode" : "DE005852",
    "ics" : true
  },
  {
    "name" : "Baden-Baden",
    "unCode" : "DE005853",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Karlsruhe",
    "unCode" : "DE005855",
    "ics" : true
  },
  {
    "name" : "Nagold",
    "unCode" : "DE005857",
    "ics" : true
  },
  {
    "name" : "Pforzheim",
    "unCode" : "DE005858",
    "ics" : true
  },
  {
    "name" : "Karlsruhe",
    "unCode" : "DE005880",
    "ics" : true
  },
  {
    "name" : "AbfSt Flugh. Karlsruhe/Baden-Baden",
    "unCode" : "DE005881",
    "ics" : true
  },
  {
    "name" : "Heidelberg",
    "unCode" : "DE005901",
    "ics" : true
  },
  {
    "name" : "Mannheim",
    "unCode" : "DE005904",
    "ics" : true
  },
  {
    "name" : "Flensburg",
    "unCode" : "DE006133",
    "ics" : true
  },
  {
    "name" : "Brunsbüttel",
    "unCode" : "DE006151",
    "ics" : true
  },
  {
    "name" : "Husum",
    "unCode" : "DE006155",
    "ics" : true
  },
  {
    "name" : "Pinneberg",
    "unCode" : "DE006156",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Itzehoe",
    "unCode" : "DE006183",
    "ics" : true
  },
  {
    "name" : "Rendsburg",
    "unCode" : "DE006206",
    "ics" : true
  },
  {
    "name" : "Kiel",
    "unCode" : "DE006207",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Norwegenkai",
    "unCode" : "DE006231",
    "ics" : true
  },
  {
    "name" : "Heiligenhafen",
    "unCode" : "DE006302",
    "ics" : true
  },
  {
    "name" : "Mölln",
    "unCode" : "DE006310",
    "ics" : true
  },
  {
    "name" : "Zollamt Lübeck",
    "unCode" : "DE006332",
    "ics" : true
  },
  {
    "name" : "Lübeck",
    "unCode" : "DE006333",
    "ics" : true
  },
  {
    "name" : "Kaiserslautern",
    "unCode" : "DE006501",
    "ics" : true
  },
  {
    "name" : "Pirmasens",
    "unCode" : "DE006502",
    "ics" : true
  },
  {
    "name" : "Mainz",
    "unCode" : "DE006504",
    "ics" : true
  },
  {
    "name" : "Koblenz-Rheinhafen",
    "unCode" : "DE006551",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheiten Flughafen Hahn",
    "unCode" : "DE006554",
    "ics" : true
  },
  {
    "name" : "Germersheim",
    "unCode" : "DE006653",
    "ics" : true
  },
  {
    "name" : "AbfSt IFS Speyer",
    "unCode" : "DE006681",
    "ics" : true
  },
  {
    "name" : "Idar-Oberstein",
    "unCode" : "DE006752",
    "ics" : true
  },
  {
    "name" : "Ehrang",
    "unCode" : "DE006753",
    "ics" : true
  },
  {
    "name" : "Hahn-Flughafen",
    "unCode" : "DE006756",
    "ics" : true
  },
  {
    "name" : "Heinsberg",
    "unCode" : "DE007053",
    "ics" : true
  },
  {
    "name" : "Charlottenburger Allee",
    "unCode" : "DE007054",
    "ics" : true
  },
  {
    "name" : "Düren",
    "unCode" : "DE007064",
    "ics" : true
  },
  {
    "name" : "Bonn",
    "unCode" : "DE007152",
    "ics" : true
  },
  {
    "name" : "Gummersbach",
    "unCode" : "DE007153",
    "ics" : true
  },
  {
    "name" : "Flughafen Köln/Bonn",
    "unCode" : "DE007154",
    "ics" : true
  },
  {
    "name" : "Wahn",
    "unCode" : "DE007157",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Köln/Bonn",
    "unCode" : "DE007159",
    "ics" : true
  },
  {
    "name" : "Köln-Messe",
    "unCode" : "DE007181",
    "ics" : true
  },
  {
    "name" : "Köln-West",
    "unCode" : "DE007202",
    "ics" : true
  },
  {
    "name" : "Aschersleben",
    "unCode" : "DE007352",
    "ics" : true
  },
  {
    "name" : "Stendal",
    "unCode" : "DE007359",
    "ics" : true
  },
  {
    "name" : "Dessau-Ost",
    "unCode" : "DE007361",
    "ics" : true
  },
  {
    "name" : "Halle (Saale)",
    "unCode" : "DE007362",
    "ics" : true
  },
  {
    "name" : "Magdeburg-Rothensee",
    "unCode" : "DE007380",
    "ics" : true
  },
  {
    "name" : "Göggingen",
    "unCode" : "DE007401",
    "ics" : true
  },
  {
    "name" : "Donauwörth",
    "unCode" : "DE007402",
    "ics" : true
  },
  {
    "name" : "Ingolstadt",
    "unCode" : "DE007403",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Augsburg",
    "unCode" : "DE007423",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Memmingerberg",
    "unCode" : "DE007424",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Flughafen",
    "unCode" : "DE007430",
    "ics" : true
  },
  {
    "name" : "Altötting (Autobahn)",
    "unCode" : "DE007455",
    "ics" : true
  },
  {
    "name" : "Bad Reichenhall-Autobahn",
    "unCode" : "DE007458",
    "ics" : true
  },
  {
    "name" : "Hallbergmoos",
    "unCode" : "DE007501",
    "ics" : true
  },
  {
    "name" : "Plattling",
    "unCode" : "DE007504",
    "ics" : true
  },
  {
    "name" : "Hörbranz-Autobahn",
    "unCode" : "DE007551",
    "ics" : true
  },
  {
    "name" : "Kempten",
    "unCode" : "DE007553",
    "ics" : true
  },
  {
    "name" : "AbfSt Flughafen Memmingerberg",
    "unCode" : "DE007554",
    "ics" : true
  },
  {
    "name" : "Memmingen",
    "unCode" : "DE007561",
    "ics" : true
  },
  {
    "name" : "Garching-Hochbrück",
    "unCode" : "DE007602",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheiten Flughafen München",
    "unCode" : "DE007611",
    "ics" : true
  },
  {
    "name" : "Flughafen München",
    "unCode" : "DE007650",
    "ics" : true
  },
  {
    "name" : "Suben-Autobahn (österr. Gebiet)",
    "unCode" : "DE007701",
    "ics" : true
  },
  {
    "name" : "Passau",
    "unCode" : "DE007703",
    "ics" : true
  },
  {
    "name" : "Weilheim",
    "unCode" : "DE007751",
    "ics" : true
  },
  {
    "name" : "Reischenhart",
    "unCode" : "DE007755",
    "ics" : true
  },
  {
    "name" : "Bielefeld-Eckendorfer Straße",
    "unCode" : "DE008001",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Paderborn/Lippstadt",
    "unCode" : "DE008002",
    "ics" : true
  },
  {
    "name" : "Lemgo",
    "unCode" : "DE008004",
    "ics" : true
  },
  {
    "name" : "Lübbecke",
    "unCode" : "DE008008",
    "ics" : true
  },
  {
    "name" : "Bochum",
    "unCode" : "DE008051",
    "ics" : true
  },
  {
    "name" : "Gelsenkirchen",
    "unCode" : "DE008052",
    "ics" : true
  },
  {
    "name" : "Hagen",
    "unCode" : "DE008101",
    "ics" : true
  },
  {
    "name" : "Dortmund-Ost",
    "unCode" : "DE008103",
    "ics" : true
  },
  {
    "name" : "Lüdenscheid",
    "unCode" : "DE008104",
    "ics" : true
  },
  {
    "name" : "Siegen",
    "unCode" : "DE008106",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Dortmund",
    "unCode" : "DE008107",
    "ics" : true
  },
  {
    "name" : "Flughafen Dortmund",
    "unCode" : "DE008131",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Münster",
    "unCode" : "DE008301",
    "ics" : true
  },
  {
    "name" : "Bocholt",
    "unCode" : "DE008302",
    "ics" : true
  },
  {
    "name" : "Coesfeld",
    "unCode" : "DE008303",
    "ics" : true
  },
  {
    "name" : "Münster-Loddenheide",
    "unCode" : "DE008304",
    "ics" : true
  },
  {
    "name" : "Rheine",
    "unCode" : "DE008305",
    "ics" : true
  },
  {
    "name" : "Flughafen Münster",
    "unCode" : "DE008306",
    "ics" : true
  },
  {
    "name" : "Anröchte",
    "unCode" : "DE008351",
    "ics" : true
  },
  {
    "name" : "Arnsberg",
    "unCode" : "DE008352",
    "ics" : true
  },
  {
    "name" : "Paderborn",
    "unCode" : "DE008355",
    "ics" : true
  },
  {
    "name" : "Beckum",
    "unCode" : "DE008356",
    "ics" : true
  },
  {
    "name" : "Flughafen Paderborn",
    "unCode" : "DE008380",
    "ics" : true
  },
  {
    "name" : "Bamberg",
    "unCode" : "DE008601",
    "ics" : true
  },
  {
    "name" : "Bayreuth",
    "unCode" : "DE008602",
    "ics" : true
  },
  {
    "name" : "Coburg",
    "unCode" : "DE008605",
    "ics" : true
  },
  {
    "name" : "Hof-Marktredwitz",
    "unCode" : "DE008715",
    "ics" : true
  },
  {
    "name" : "Ansbach-Weißenburg",
    "unCode" : "DE008751",
    "ics" : true
  },
  {
    "name" : "Erlangen-Tennenlohe",
    "unCode" : "DE008752",
    "ics" : true
  },
  {
    "name" : "Flughafen Nürnberg",
    "unCode" : "DE008755",
    "ics" : true
  },
  {
    "name" : "Hafen",
    "unCode" : "DE008756",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Nürnberg",
    "unCode" : "DE008757",
    "ics" : true
  },
  {
    "name" : "Oberpfalz",
    "unCode" : "DE008801",
    "ics" : true
  },
  {
    "name" : "Regensburg-Furth im Wald",
    "unCode" : "DE008804",
    "ics" : true
  },
  {
    "name" : "Aschaffenburg",
    "unCode" : "DE008851",
    "ics" : true
  },
  {
    "name" : "Schweinfurt-Londonstraße",
    "unCode" : "DE008853",
    "ics" : true
  },
  {
    "name" : "Dettelbach-Mainfrankenpark",
    "unCode" : "DE008857",
    "ics" : true
  },
  {
    "name" : "Pomellen",
    "unCode" : "DE009004",
    "ics" : true
  },
  {
    "name" : "Neubrandenburg",
    "unCode" : "DE009030",
    "ics" : true
  },
  {
    "name" : "Ludwigslust",
    "unCode" : "DE009101",
    "ics" : true
  },
  {
    "name" : "Laage",
    "unCode" : "DE009102",
    "ics" : true
  },
  {
    "name" : "Wismar",
    "unCode" : "DE009103",
    "ics" : true
  },
  {
    "name" : "Rostock",
    "unCode" : "DE009104",
    "ics" : true
  },
  {
    "name" : "Kontrolleinheit Flughafen Rostock",
    "unCode" : "DE009106",
    "ics" : true
  },
  {
    "name" : "Wolgast",
    "unCode" : "DE009152",
    "ics" : true
  },
  {
    "name" : "Mukran",
    "unCode" : "DE009154",
    "ics" : true
  },
  {
    "name" : "Stralsund-Dänholm",
    "unCode" : "DE009180",
    "ics" : true
  },
  {
    "name" : "Saarbrücken",
    "unCode" : "DE009303",
    "ics" : true
  },
  {
    "name" : "Flughafen Saarbrücken",
    "unCode" : "DE009304",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Saarbrücken",
    "unCode" : "DE009305",
    "ics" : true
  },
  {
    "name" : "Bodensee-Oberschwaben",
    "unCode" : "DE009404",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Fähre",
    "unCode" : "DE009420",
    "ics" : true
  },
  {
    "name" : "Heilbronn",
    "unCode" : "DE009452",
    "ics" : true
  },
  {
    "name" : "Ludwigsburg",
    "unCode" : "DE009453",
    "ics" : true
  },
  {
    "name" : "Tauberbischofsheim",
    "unCode" : "DE009456",
    "ics" : true
  },
  {
    "name" : "Untermünkheim",
    "unCode" : "DE009459",
    "ics" : true
  },
  {
    "name" : "Albstadt",
    "unCode" : "DE009501",
    "ics" : true
  },
  {
    "name" : "Böblingen",
    "unCode" : "DE009551",
    "ics" : true
  },
  {
    "name" : "Stuttgart-Hafen",
    "unCode" : "DE009552",
    "ics" : true
  },
  {
    "name" : "Stuttgart-Zuffenhausen",
    "unCode" : "DE009554",
    "ics" : true
  },
  {
    "name" : "Flughafen Stuttgart",
    "unCode" : "DE009555",
    "ics" : true
  },
  {
    "name" : "Winnenden",
    "unCode" : "DE009556",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Stuttgart",
    "unCode" : "DE009557",
    "ics" : true
  },
  {
    "name" : "Abfertigungsstelle Landesmesse",
    "unCode" : "DE009589",
    "ics" : true
  },
  {
    "name" : "Aalen",
    "unCode" : "DE009651",
    "ics" : true
  },
  {
    "name" : "Göppingen",
    "unCode" : "DE009652",
    "ics" : true
  },
  {
    "name" : "KE Flughafen Friedrichshafen",
    "unCode" : "DE009653",
    "ics" : true
  },
  {
    "name" : "Donautal",
    "unCode" : "DE009656",
    "ics" : true
  },
  {
    "name" : "Metzingen",
    "unCode" : "DE009680",
    "ics" : true
  },
  {
    "name" : "Bane",
    "unCode" : "DK000020",
    "ics" : true
  },
  {
    "name" : "Toldstyrelsen (old)",
    "unCode" : "DK000460",
    "ics" : true
  },
  {
    "name" : "Færgeterminalen ved DFDS (old)",
    "unCode" : "DK000461",
    "ics" : true
  },
  {
    "name" : "Told Frihavnen (old)",
    "unCode" : "DK000462",
    "ics" : true
  },
  {
    "name" : "Told Kystvejen (old)",
    "unCode" : "DK000463",
    "ics" : true
  },
  {
    "name" : "Told Frederikshavn",
    "unCode" : "DK003101",
    "ics" : true
  },
  {
    "name" : "Told Hirtshals",
    "unCode" : "DK003102",
    "ics" : true
  },
  {
    "name" : "Told Kvistgård (old)",
    "unCode" : "DK003761",
    "ics" : true
  },
  {
    "name" : "Told Bornholm (old)",
    "unCode" : "DK003762",
    "ics" : true
  },
  {
    "name" : "Told Billund Lufthavn (old)",
    "unCode" : "DK003862",
    "ics" : true
  },
  {
    "name" : "Told Esbjerg (old)",
    "unCode" : "DK003863",
    "ics" : true
  },
  {
    "name" : "Told Aarhus",
    "unCode" : "DK004701",
    "ics" : true
  },
  {
    "name" : "Told Køge (old)",
    "unCode" : "DK005160",
    "ics" : true
  },
  {
    "name" : "Told Nørre Alslev (old)",
    "unCode" : "DK005162",
    "ics" : true
  },
  {
    "name" : "Skattecenter Middelfart",
    "unCode" : "DK005600",
    "ics" : true
  },
  {
    "name" : "Told Padborg",
    "unCode" : "DK005604",
    "ics" : true
  },
  {
    "name" : "Told Billund Lufthavn",
    "unCode" : "DK005606",
    "ics" : true
  },
  {
    "name" : "Told Esbjerg Havn",
    "unCode" : "DK005607",
    "ics" : true
  },
  {
    "name" : "Esbjerg Lufthavn",
    "unCode" : "DK005612",
    "ics" : true
  },
  {
    "name" : "Told Køge",
    "unCode" : "DK006600",
    "ics" : true
  },
  {
    "name" : "Told Nørre Alslev",
    "unCode" : "DK006602",
    "ics" : true
  },
  {
    "name" : "Told Køge",
    "unCode" : "DK007900",
    "ics" : true
  },
  {
    "name" : "Færgeterminalen ved DFDS",
    "unCode" : "DK007901",
    "ics" : true
  },
  {
    "name" : "Told Frihavnen",
    "unCode" : "DK007902",
    "ics" : true
  },
  {
    "name" : "Told Kystvejen",
    "unCode" : "DK007903",
    "ics" : true
  },
  {
    "name" : "Told Kvistgård",
    "unCode" : "DK007908",
    "ics" : true
  },
  {
    "name" : "Told Bornholm",
    "unCode" : "DK007909",
    "ics" : true
  },
  {
    "name" : "Centerhavn Toldekspedition",
    "unCode" : "DK009262",
    "ics" : true
  },
  {
    "name" : "Told Padborg (old)",
    "unCode" : "DK009264",
    "ics" : true
  },
  {
    "name" : "Told Aalborg",
    "unCode" : "DK009760",
    "ics" : true
  },
  {
    "name" : "Told Frederikshavn (old)",
    "unCode" : "DK009761",
    "ics" : true
  },
  {
    "name" : "Told Hirtshals (old)",
    "unCode" : "DK009762",
    "ics" : true
  },
  {
    "name" : "Told Aarhus (old)",
    "unCode" : "DK009860",
    "ics" : true
  },
  {
    "name" : "Tolliformaalsuste osakond",
    "unCode" : "EE1000EE",
    "ics" : true
  },
  {
    "name" : "Kvaliteedi kontrolli üksus",
    "unCode" : "EE1110EE",
    "ics" : true
  },
  {
    "name" : "Lennujaama kontroll",
    "unCode" : "EE1111EE",
    "ics" : true
  },
  {
    "name" : "Uurimisosakond",
    "unCode" : "EE1112EE",
    "ics" : true
  },
  {
    "name" : "Sadamate kontroll",
    "unCode" : "EE1113EE",
    "ics" : true
  },
  {
    "name" : "Põhja II talitus",
    "unCode" : "EE1115EE",
    "ics" : true
  },
  {
    "name" : "Kaupade kontroll",
    "unCode" : "EE1116EE",
    "ics" : true
  },
  {
    "name" : "Paldiski piiripunkt",
    "unCode" : "EE1160EE",
    "ics" : true
  },
  {
    "name" : "Muuga tollipunkt",
    "unCode" : "EE1210EE",
    "ics" : true
  },
  {
    "name" : "Lennujaama tollipunkt",
    "unCode" : "EE1310EE",
    "ics" : true
  },
  {
    "name" : "Klienditeeninduse osakond",
    "unCode" : "EE3000EE",
    "ics" : true
  },
  {
    "name" : "Pärnu teenindusbüroo",
    "unCode" : "EE3300EE",
    "ics" : true
  },
  {
    "name" : "Kuressaare teenindusbüroo",
    "unCode" : "EE3310EE",
    "ics" : true
  },
  {
    "name" : "Lääne talitus",
    "unCode" : "EE3700EE",
    "ics" : true
  },
  {
    "name" : "Võru teenindusbüroo",
    "unCode" : "EE4100EE",
    "ics" : true
  },
  {
    "name" : "Valga teenindusbüroo",
    "unCode" : "EE4110EE",
    "ics" : true
  },
  {
    "name" : "Tartu teenindusbüroo",
    "unCode" : "EE4120EE",
    "ics" : true
  },
  {
    "name" : "Lõuna talitus",
    "unCode" : "EE4400EE",
    "ics" : true
  },
  {
    "name" : "Luhamaa tollipunkt",
    "unCode" : "EE4600EE",
    "ics" : true
  },
  {
    "name" : "Luhamaa piiripunkt",
    "unCode" : "EE4700EE",
    "ics" : true
  },
  {
    "name" : "Koidula maantee piiripunkt",
    "unCode" : "EE4800EE",
    "ics" : true
  },
  {
    "name" : "Koidula raudtee piiripunkt",
    "unCode" : "EE4810EE",
    "ics" : true
  },
  {
    "name" : "Narva teenindusbüroo",
    "unCode" : "EE5100EE",
    "ics" : true
  },
  {
    "name" : "Rakvere teenindusbüroo",
    "unCode" : "EE5110EE",
    "ics" : true
  },
  {
    "name" : "Sillamäe tollipunkt",
    "unCode" : "EE5130EE",
    "ics" : true
  },
  {
    "name" : "Narva raudtee piiripunkt",
    "unCode" : "EE5500EE",
    "ics" : true
  },
  {
    "name" : "Narva tollipunkt",
    "unCode" : "EE5600EE",
    "ics" : true
  },
  {
    "name" : "Ida talitus",
    "unCode" : "EE5800EE",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO VITORIA-FORONDA",
    "unCode" : "ES000101",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VITORIA - CARRETERA",
    "unCode" : "ES000141",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VITORIA DOMICILIACIÓN",
    "unCode" : "ES000150",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALBACETE DOMICILIACIÓN",
    "unCode" : "ES000241",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO ALICANTE-ELCHE",
    "unCode" : "ES000301",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALICANTE - MARÍTIMA",
    "unCode" : "ES000311",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO DE ALMERÍA",
    "unCode" : "ES000401",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALMERIA-MARÍTIMA",
    "unCode" : "ES000411",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PUERTO DE GARRUCHA",
    "unCode" : "ES000412",
    "ics" : true
  },
  {
    "name" : "ALMERÍA-MARÍTIMA CARBONERAS",
    "unCode" : "ES000415",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALMERIA-CARRETERA",
    "unCode" : "ES000441",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BADAJOZ-CARRETERA.",
    "unCode" : "ES000641",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BADAJOZ-FERROCARRIL",
    "unCode" : "ES000671",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO PALMA MALLORCA",
    "unCode" : "ES000701",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO DE IBIZA",
    "unCode" : "ES000707",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO DE MAHÓN",
    "unCode" : "ES000708",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PALMA DE MALLORCA",
    "unCode" : "ES000711",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALCUDIA",
    "unCode" : "ES000717",
    "ics" : true
  },
  {
    "name" : "ADUANA DE IBIZA MARITIMA",
    "unCode" : "ES000721",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MAHON - MARITIMA",
    "unCode" : "ES000731",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO BARCELONA EL PRAT",
    "unCode" : "ES000801",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA - MARÍTIMA",
    "unCode" : "ES000811",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA-MARÍTIMA EXPORT",
    "unCode" : "ES000812",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA-ZONA FRANCA",
    "unCode" : "ES000821",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA - CARRETERA",
    "unCode" : "ES000841",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA FERIA MUESTRAS",
    "unCode" : "ES000851",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA-DOMICILIACIÓN",
    "unCode" : "ES000860",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BARCELONA-FFCC.- MORROT",
    "unCode" : "ES000881",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BURGOS CARRETERA",
    "unCode" : "ES000941",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CÁCERES-CARRETERA",
    "unCode" : "ES001041",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO JEREZ DE LA FRONT",
    "unCode" : "ES001101",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CADIZ - PRINCIPAL",
    "unCode" : "ES001111",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CADIZ - ZONA FRANCA",
    "unCode" : "ES001115",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALGECIRAS DOMICILIACIÓN",
    "unCode" : "ES001130",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALGECIRAS MARÍTIMA",
    "unCode" : "ES001131",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ALGECIRAS- TARIFA",
    "unCode" : "ES001133",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CADIZ - CARRETERA",
    "unCode" : "ES001141",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LÍNEA DE CONCEPCIÓN-MAR",
    "unCode" : "ES001161",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LA LINEA DE LA CONCEPCIÓN",
    "unCode" : "ES001167",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CASTELLON DE LA PLANA",
    "unCode" : "ES001211",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CASTELLON - CARRETERA",
    "unCode" : "ES001241",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CIUDAD REAL AEROPUERTO",
    "unCode" : "ES001301",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CIUDAD REAL CARRETERA",
    "unCode" : "ES001341",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CORDOBA CARRETERA",
    "unCode" : "ES001441",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO A CORUÑA-ALVEDRO",
    "unCode" : "ES001501",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO SANTIAGO-LABACOLL",
    "unCode" : "ES001507",
    "ics" : true
  },
  {
    "name" : "ADUANA DE A CORUÑA",
    "unCode" : "ES001511",
    "ics" : true
  },
  {
    "name" : "ADUANA DE A CORUÑA-DEPOSITO FRANCO",
    "unCode" : "ES001517",
    "ics" : true
  },
  {
    "name" : "ADUANA DE EL FERROL-MARITIMA",
    "unCode" : "ES001521",
    "ics" : true
  },
  {
    "name" : "ADUANA DE A CORUÑA CARRETERA",
    "unCode" : "ES001541",
    "ics" : true
  },
  {
    "name" : "ADUANA DE EL FERROL - CARRETERA",
    "unCode" : "ES001551",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CUENCA CARRETERA",
    "unCode" : "ES001641",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PALAMOS-MARITIMA",
    "unCode" : "ES001711",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LA JUNQUERA",
    "unCode" : "ES001741",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VILLAMALLA",
    "unCode" : "ES001761",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PORT BOU - FERROCARRIL",
    "unCode" : "ES001771",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MOTRIL",
    "unCode" : "ES001811",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MOTRIL-CARRETERA",
    "unCode" : "ES001841",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GUADALAJARA CARRETERA",
    "unCode" : "ES001941",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GUADALAJARA DOMICILIACIÓN",
    "unCode" : "ES001950",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO IRÚN",
    "unCode" : "ES002001",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PASAJES - MARÍTIMA",
    "unCode" : "ES002011",
    "ics" : true
  },
  {
    "name" : "ADUANA DE IRUN-ZAISA",
    "unCode" : "ES002045",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PASAJES CARRETERA",
    "unCode" : "ES002051",
    "ics" : true
  },
  {
    "name" : "ADUANA DE IRÚN FERROCARRIL",
    "unCode" : "ES002071",
    "ics" : true
  },
  {
    "name" : "ADUANA DE HUELVA - PRINCIPAL",
    "unCode" : "ES002111",
    "ics" : true
  },
  {
    "name" : "ADUANA DE HUELVA - CARRETERA",
    "unCode" : "ES002141",
    "ics" : true
  },
  {
    "name" : "ADUANA DE JAÉN DOMICILIACIÓN",
    "unCode" : "ES002341",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LEÓN CARRETERA",
    "unCode" : "ES002441",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LA FARGA DE MOLES",
    "unCode" : "ES002541",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LLEIDA CARRETERA",
    "unCode" : "ES002561",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LOGROÑO",
    "unCode" : "ES002641",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO DE LA RIOJA",
    "unCode" : "ES002642",
    "ics" : true
  },
  {
    "name" : "ADUANA DE RIBADEO",
    "unCode" : "ES002711",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO MADRID-BARAJAS",
    "unCode" : "ES002801",
    "ics" : true
  },
  {
    "name" : "ADUANA POSTAL DE MADRID",
    "unCode" : "ES002803",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MADRID-DOMICILIACIÓN",
    "unCode" : "ES002861",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO MÁLAGA",
    "unCode" : "ES002901",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MALAGA-PRINCIPAL",
    "unCode" : "ES002911",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MALAGA- DOMICILIACIÓN",
    "unCode" : "ES002915",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MALAGA-CARRETERA",
    "unCode" : "ES002941",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MURCIA AEROPUERTO INTERNA",
    "unCode" : "ES003001",
    "ics" : true
  },
  {
    "name" : "ADUANA DE CARTAGENA - PRINCIPAL",
    "unCode" : "ES003011",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MURCIA - CARRETERA",
    "unCode" : "ES003051",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PAMPLONA - IMARCOAÍN",
    "unCode" : "ES003161",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PAMPLONA - NOAÍN FERROC.",
    "unCode" : "ES003171",
    "ics" : true
  },
  {
    "name" : "ADUANA DE OURENSE CARRETERA",
    "unCode" : "ES003241",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO DE ASTURIAS",
    "unCode" : "ES003301",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GIJON -MARITIMA",
    "unCode" : "ES003311",
    "ics" : true
  },
  {
    "name" : "ADUANA DE AVILÉS MARÍTIMA",
    "unCode" : "ES003331",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GIJÓN CARRETERA",
    "unCode" : "ES003341",
    "ics" : true
  },
  {
    "name" : "ADUANA DE AVILES CARRETERA",
    "unCode" : "ES003351",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GIJON - FERROCARRIL",
    "unCode" : "ES003371",
    "ics" : true
  },
  {
    "name" : "ADUANA DE PALENCIA-CARRETERA",
    "unCode" : "ES003441",
    "ics" : true
  },
  {
    "name" : "ADUANA DE FUERTEVENTURA-MAR. (T1)",
    "unCode" : "ES003541",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO FUERTEVENTURA",
    "unCode" : "ES003551",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LANZAROTE-MARITIMA (T1)",
    "unCode" : "ES003561",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO LANZAROTE",
    "unCode" : "ES003571",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO GRAN CANARIA",
    "unCode" : "ES003581",
    "ics" : true
  },
  {
    "name" : "ADUANA DE LAS PALMAS MARÍTIMA (T1)",
    "unCode" : "ES003591",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GRAN CANARIA POSTAL",
    "unCode" : "ES003593",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO VIGO",
    "unCode" : "ES003601",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VIGO-PRINCIPAL",
    "unCode" : "ES003611",
    "ics" : true
  },
  {
    "name" : "ADUANA DE MARIN",
    "unCode" : "ES003621",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VILAGARCIA DE AROUSA-MAR.",
    "unCode" : "ES003631",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VIGO CARRETERA",
    "unCode" : "ES003641",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VILAGARCIA DE AROUSA CAR.",
    "unCode" : "ES003651",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VIGO-ZONA FRANCA",
    "unCode" : "ES003681",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VIGO DOMICILIACIÓN",
    "unCode" : "ES003691",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SALAMANCA-CARRETERA",
    "unCode" : "ES003741",
    "ics" : true
  },
  {
    "name" : "ADUANA DE STA CRUZ DE PALMA-MAR.T1",
    "unCode" : "ES003861",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO LA PALMA",
    "unCode" : "ES003871",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO TENERIFE SUR",
    "unCode" : "ES003881",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO TENERIFE NORTE",
    "unCode" : "ES003883",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TENERIFE-MARÍTIMA",
    "unCode" : "ES003891",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TENERIFE POSTALES",
    "unCode" : "ES003893",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO SANTANDER",
    "unCode" : "ES003901",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SANTANDER-MARITIMA",
    "unCode" : "ES003911",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SANTANDER ZONA FRANCA",
    "unCode" : "ES003921",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SANTANDER CARRETERA",
    "unCode" : "ES003941",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO SEVILLA",
    "unCode" : "ES004101",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SEVILLA-PRINCIPAL",
    "unCode" : "ES004111",
    "ics" : true
  },
  {
    "name" : "SEVILLA-ZONA FRANCA",
    "unCode" : "ES004115",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SEVILLA CARRETERA",
    "unCode" : "ES004141",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TARRAGONA-MARITIMA",
    "unCode" : "ES004311",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SAN CARLOS DE LA RÁPITA",
    "unCode" : "ES004321",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TARRAGONA-CARRETERA",
    "unCode" : "ES004341",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TARRAGONA-DOMICIL. Y DEP.",
    "unCode" : "ES004350",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TARRAGONA-FEROCARRIL",
    "unCode" : "ES004371",
    "ics" : true
  },
  {
    "name" : "ADUANA DE TOLEDO DOMICILIACIÓN",
    "unCode" : "ES004541",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO VALENCIA",
    "unCode" : "ES004601",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VALENCIA MARÍTIMA",
    "unCode" : "ES004611",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SAGUNTO-MARITIMA",
    "unCode" : "ES004621",
    "ics" : true
  },
  {
    "name" : "ADUANA DE GANDIA-MARITIMA",
    "unCode" : "ES004631",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VALENCIA CARRETERA",
    "unCode" : "ES004641",
    "ics" : true
  },
  {
    "name" : "ADUANA DE SILLA-CARRETERA",
    "unCode" : "ES004647",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VALENCIA-DOMICILIACIÓN",
    "unCode" : "ES004650",
    "ics" : true
  },
  {
    "name" : "ADUANA DE VALLADOLID",
    "unCode" : "ES004741",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO BILBAO",
    "unCode" : "ES004801",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BILBAO-MARITIMA",
    "unCode" : "ES004811",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BILBAO-ZAL",
    "unCode" : "ES004825",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BILBAO - CARRETERA",
    "unCode" : "ES004842",
    "ics" : true
  },
  {
    "name" : "ADUANA DE BILBAO DOMICILIACIÓN",
    "unCode" : "ES004850",
    "ics" : true
  },
  {
    "name" : "ADUANA AEROPUERTO ZARAGOZA",
    "unCode" : "ES005001",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ZARAGOZA CARRETERA/TIR",
    "unCode" : "ES005041",
    "ics" : true
  },
  {
    "name" : "ADUANA DE ZARAGOZA-DOMICILIACION",
    "unCode" : "ES005060",
    "ics" : true
  },
  {
    "name" : "Meritulli Olympiaterminaali",
    "unCode" : "FI001400",
    "ics" : true
  },
  {
    "name" : "HELSINKI Katajanokka K7 Tulli",
    "unCode" : "FI001602",
    "ics" : true
  },
  {
    "name" : "Helsinki Tulli KatajanokkaK9",
    "unCode" : "FI001604",
    "ics" : true
  },
  {
    "name" : "Helsinki Tulli Länsisatama L5",
    "unCode" : "FI001802",
    "ics" : true
  },
  {
    "name" : "Tulliselvityskeskus",
    "unCode" : "FI002000",
    "ics" : true
  },
  {
    "name" : "Tulliselvityskeskus, TRA",
    "unCode" : "FI002006",
    "ics" : true
  },
  {
    "name" : "Helsinki Tulli",
    "unCode" : "FI005000",
    "ics" : true
  },
  {
    "name" : "Meritulli Vuosaari satama V6",
    "unCode" : "FI009801",
    "ics" : true
  },
  {
    "name" : "Meritulli Vuosaari Hansaterminaali",
    "unCode" : "FI009802",
    "ics" : true
  },
  {
    "name" : "Lentotulli Helsinki-Vantaa Rahti",
    "unCode" : "FI015300",
    "ics" : true
  },
  {
    "name" : "Lentotulli Hki-Vantaa Matkustaja",
    "unCode" : "FI015302",
    "ics" : true
  },
  {
    "name" : "Loviisa Satama Tulli",
    "unCode" : "FI079000",
    "ics" : true
  },
  {
    "name" : "Hanko Tulli",
    "unCode" : "FI109000",
    "ics" : true
  },
  {
    "name" : "Turku Tulli",
    "unCode" : "FI201000",
    "ics" : true
  },
  {
    "name" : "Turku Tulli",
    "unCode" : "FI201003",
    "ics" : true
  },
  {
    "name" : "Turku Lentotulli",
    "unCode" : "FI203600",
    "ics" : true
  },
  {
    "name" : "Naantalin satama Tulli",
    "unCode" : "FI211000",
    "ics" : true
  },
  {
    "name" : "Mariehamn Tull Hamnterminal",
    "unCode" : "FI221001",
    "ics" : true
  },
  {
    "name" : "Eckerö Tulli",
    "unCode" : "FI222700",
    "ics" : true
  },
  {
    "name" : "Långnäs Tulli",
    "unCode" : "FI226300",
    "ics" : true
  },
  {
    "name" : "Uusikaupunki satama Tulli",
    "unCode" : "FI235000",
    "ics" : true
  },
  {
    "name" : "Rauma Tulli",
    "unCode" : "FI261000",
    "ics" : true
  },
  {
    "name" : "PoriTulli",
    "unCode" : "FI288800",
    "ics" : true
  },
  {
    "name" : "Tampere Tulli",
    "unCode" : "FI339000",
    "ics" : true
  },
  {
    "name" : "Jyväskylä Tulli",
    "unCode" : "FI403200",
    "ics" : true
  },
  {
    "name" : "Kotka Hietasen satama Tulli",
    "unCode" : "FI482000",
    "ics" : true
  },
  {
    "name" : "Kotka Tulli",
    "unCode" : "FI483100",
    "ics" : true
  },
  {
    "name" : "Hamina Tulli",
    "unCode" : "FI494600",
    "ics" : true
  },
  {
    "name" : "Vaalimaa Tulli",
    "unCode" : "FI499300",
    "ics" : true
  },
  {
    "name" : "Nuijamaa Tulli",
    "unCode" : "FI542300",
    "ics" : true
  },
  {
    "name" : "Vainikkala Tulli",
    "unCode" : "FI542700",
    "ics" : true
  },
  {
    "name" : "Imatra Tulli",
    "unCode" : "FI556100",
    "ics" : true
  },
  {
    "name" : "Kaskisen satama Tulli",
    "unCode" : "FI642600",
    "ics" : true
  },
  {
    "name" : "Vaasa Tulli",
    "unCode" : "FI651700",
    "ics" : true
  },
  {
    "name" : "Kokkola Tulli",
    "unCode" : "FI671000",
    "ics" : true
  },
  {
    "name" : "Pietarsaaren satama Tulli",
    "unCode" : "FI686000",
    "ics" : true
  },
  {
    "name" : "Niirala Tulli",
    "unCode" : "FI826750",
    "ics" : true
  },
  {
    "name" : "Vartius Tulli",
    "unCode" : "FI889300",
    "ics" : true
  },
  {
    "name" : "Oulu Tulli",
    "unCode" : "FI904000",
    "ics" : true
  },
  {
    "name" : "OULU LENTOTULLI",
    "unCode" : "FI904001",
    "ics" : true
  },
  {
    "name" : "Kuusamo Tulli",
    "unCode" : "FI939990",
    "ics" : true
  },
  {
    "name" : "Kemin Satama Tulli",
    "unCode" : "FI941000",
    "ics" : true
  },
  {
    "name" : "Tornio Hallinto Tulli",
    "unCode" : "FI954000",
    "ics" : true
  },
  {
    "name" : "Tornio Tulli",
    "unCode" : "FI954001",
    "ics" : true
  },
  {
    "name" : "Salla Tulli",
    "unCode" : "FI989200",
    "ics" : true
  },
  {
    "name" : "Kivilompolo Tulli",
    "unCode" : "FI994400",
    "ics" : true
  },
  {
    "name" : "Kilpisjärvi Tulli",
    "unCode" : "FI994900",
    "ics" : true
  },
  {
    "name" : "Raja-Jooseppi Tulli",
    "unCode" : "FI998001",
    "ics" : true
  },
  {
    "name" : "Näätämö tulli",
    "unCode" : "FI998002",
    "ics" : true
  },
  {
    "name" : "Karigasniemi Tulli",
    "unCode" : "FI999500",
    "ics" : true
  },
  {
    "name" : "Utsjoki Tulli",
    "unCode" : "FI999800",
    "ics" : true
  },
  {
    "name" : "Polmak Tulli",
    "unCode" : "FI999801",
    "ics" : true
  },
  {
    "name" : "Ajaccio port",
    "unCode" : "FR000040",
    "ics" : true
  },
  {
    "name" : "Amiens bureau",
    "unCode" : "FR000100",
    "ics" : true
  },
  {
    "name" : "Angers bureau",
    "unCode" : "FR000120",
    "ics" : true
  },
  {
    "name" : "Angouleme bureau",
    "unCode" : "FR000130",
    "ics" : true
  },
  {
    "name" : "Annecy bureau",
    "unCode" : "FR000140",
    "ics" : true
  },
  {
    "name" : "Dunkerque energies bureau",
    "unCode" : "FR000170",
    "ics" : true
  },
  {
    "name" : "Avignon bureau",
    "unCode" : "FR000270",
    "ics" : true
  },
  {
    "name" : "Bale mulhouse aero bureau",
    "unCode" : "FR000340",
    "ics" : true
  },
  {
    "name" : "Bastia port",
    "unCode" : "FR000380",
    "ics" : true
  },
  {
    "name" : "Bayonne bureau",
    "unCode" : "FR000390",
    "ics" : true
  },
  {
    "name" : "Besancon bureau",
    "unCode" : "FR000460",
    "ics" : true
  },
  {
    "name" : "Bordeaux merignac bureau",
    "unCode" : "FR000600",
    "ics" : true
  },
  {
    "name" : "Bordeaux bassens pt bureau",
    "unCode" : "FR000610",
    "ics" : true
  },
  {
    "name" : "Boulogne bureau",
    "unCode" : "FR000630",
    "ics" : true
  },
  {
    "name" : "Brest bureau",
    "unCode" : "FR000690",
    "ics" : true
  },
  {
    "name" : "Caen bureau",
    "unCode" : "FR000720",
    "ics" : true
  },
  {
    "name" : "Calais bureau",
    "unCode" : "FR000740",
    "ics" : true
  },
  {
    "name" : "Cannes bureau",
    "unCode" : "FR000800",
    "ics" : true
  },
  {
    "name" : "Chambery bureau",
    "unCode" : "FR000870",
    "ics" : true
  },
  {
    "name" : "Chateauroux bureau",
    "unCode" : "FR000910",
    "ics" : true
  },
  {
    "name" : "Cherbourg bureau",
    "unCode" : "FR000950",
    "ics" : true
  },
  {
    "name" : "Clermont bureau",
    "unCode" : "FR000980",
    "ics" : true
  },
  {
    "name" : "Delle bureau",
    "unCode" : "FR001140",
    "ics" : true
  },
  {
    "name" : "Dijon bureau",
    "unCode" : "FR001170",
    "ics" : true
  },
  {
    "name" : "Donges raffinerie",
    "unCode" : "FR001200",
    "ics" : true
  },
  {
    "name" : "Dunkerque port bureau",
    "unCode" : "FR001260",
    "ics" : true
  },
  {
    "name" : "Ennery bureau",
    "unCode" : "FR001280",
    "ics" : true
  },
  {
    "name" : "Epinal bureau",
    "unCode" : "FR001290",
    "ics" : true
  },
  {
    "name" : "Ferney voltaire bureau",
    "unCode" : "FR001400",
    "ics" : true
  },
  {
    "name" : "Gonfreville raffinerie",
    "unCode" : "FR001560",
    "ics" : true
  },
  {
    "name" : "Grenoble bureau",
    "unCode" : "FR001610",
    "ics" : true
  },
  {
    "name" : "Ferriere sous jougne",
    "unCode" : "FR00201S",
    "ics" : true
  },
  {
    "name" : "L'isle d'abeau bureau",
    "unCode" : "FR002030",
    "ics" : true
  },
  {
    "name" : "La rochelle pallice bureau",
    "unCode" : "FR002090",
    "ics" : true
  },
  {
    "name" : "Le Havre Produits Pétroliers",
    "unCode" : "FR002270",
    "ics" : true
  },
  {
    "name" : "Le Havre Port bureau",
    "unCode" : "FR002300",
    "ics" : true
  },
  {
    "name" : "Le mans bureau",
    "unCode" : "FR002340",
    "ics" : true
  },
  {
    "name" : "Porta bureau",
    "unCode" : "FR002510",
    "ics" : true
  },
  {
    "name" : "Limoges bureau",
    "unCode" : "FR002540",
    "ics" : true
  },
  {
    "name" : "Lorient bureau",
    "unCode" : "FR002600",
    "ics" : true
  },
  {
    "name" : "Lyon St Exupery bureau",
    "unCode" : "FR002650",
    "ics" : true
  },
  {
    "name" : "Marignane aero bureau",
    "unCode" : "FR002710",
    "ics" : true
  },
  {
    "name" : "Marseille port bureau",
    "unCode" : "FR002730",
    "ics" : true
  },
  {
    "name" : "Monaco bureau",
    "unCode" : "FR002860",
    "ics" : true
  },
  {
    "name" : "Morteau bureau",
    "unCode" : "FR002970",
    "ics" : true
  },
  {
    "name" : "COL FRANCE BC",
    "unCode" : "FR00297S",
    "ics" : true
  },
  {
    "name" : "Mulhouse bureau",
    "unCode" : "FR002990",
    "ics" : true
  },
  {
    "name" : "Nancy bureau",
    "unCode" : "FR003000",
    "ics" : true
  },
  {
    "name" : "Nantes atlant. bureau",
    "unCode" : "FR003030",
    "ics" : true
  },
  {
    "name" : "Nice aero bureau",
    "unCode" : "FR003080",
    "ics" : true
  },
  {
    "name" : "Nimes bureau",
    "unCode" : "FR003120",
    "ics" : true
  },
  {
    "name" : "Orleans bureau",
    "unCode" : "FR003160",
    "ics" : true
  },
  {
    "name" : "Paris principal bureau",
    "unCode" : "FR003260",
    "ics" : true
  },
  {
    "name" : "Orly aero bureau",
    "unCode" : "FR003370",
    "ics" : true
  },
  {
    "name" : "Gennevilliers bureau",
    "unCode" : "FR003410",
    "ics" : true
  },
  {
    "name" : "Pau bureau",
    "unCode" : "FR003440",
    "ics" : true
  },
  {
    "name" : "Perpignan bureau",
    "unCode" : "FR003480",
    "ics" : true
  },
  {
    "name" : "Poitiers bureau",
    "unCode" : "FR003540",
    "ics" : true
  },
  {
    "name" : "Pontarlier bureau",
    "unCode" : "FR003550",
    "ics" : true
  },
  {
    "name" : "Port de Bouc Energies",
    "unCode" : "FR003620",
    "ics" : true
  },
  {
    "name" : "Port jerome raffinerie",
    "unCode" : "FR003630",
    "ics" : true
  },
  {
    "name" : "Fos port st louis pt bureau",
    "unCode" : "FR003680",
    "ics" : true
  },
  {
    "name" : "Port Vendres port bureau",
    "unCode" : "FR003690",
    "ics" : true
  },
  {
    "name" : "Reims bureau",
    "unCode" : "FR003790",
    "ics" : true
  },
  {
    "name" : "Rennes bureau",
    "unCode" : "FR003800",
    "ics" : true
  },
  {
    "name" : "Rouen port bureau",
    "unCode" : "FR003920",
    "ics" : true
  },
  {
    "name" : "St Etienne bureau",
    "unCode" : "FR003970",
    "ics" : true
  },
  {
    "name" : "St julien bardon. bureau",
    "unCode" : "FR004020",
    "ics" : true
  },
  {
    "name" : "St louis autoroute",
    "unCode" : "FR004050",
    "ics" : true
  },
  {
    "name" : "St malo bureau",
    "unCode" : "FR004060",
    "ics" : true
  },
  {
    "name" : "St nazaire montoir bureau",
    "unCode" : "FR004080",
    "ics" : true
  },
  {
    "name" : "Sete bureau",
    "unCode" : "FR004250",
    "ics" : true
  },
  {
    "name" : "STRASBOURG-ENTZHEIM BUREAU",
    "unCode" : "FR004310",
    "ics" : true
  },
  {
    "name" : "SAINT-GINGOLPH BC",
    "unCode" : "FR00439A",
    "ics" : true
  },
  {
    "name" : "Toulon la seyne bureau",
    "unCode" : "FR004430",
    "ics" : true
  },
  {
    "name" : "Toulouse blagnac aero bureau",
    "unCode" : "FR004440",
    "ics" : true
  },
  {
    "name" : "Troyes bureau",
    "unCode" : "FR004520",
    "ics" : true
  },
  {
    "name" : "Valence bureau",
    "unCode" : "FR004550",
    "ics" : true
  },
  {
    "name" : "Valenciennes bureau",
    "unCode" : "FR004560",
    "ics" : true
  },
  {
    "name" : "Brive bureau",
    "unCode" : "FR004960",
    "ics" : true
  },
  {
    "name" : "Compiegne bureau",
    "unCode" : "FR004990",
    "ics" : true
  },
  {
    "name" : "St quentin bureau",
    "unCode" : "FR005040",
    "ics" : true
  },
  {
    "name" : "Vatry bureau",
    "unCode" : "FR005061",
    "ics" : true
  },
  {
    "name" : "Niort bureau",
    "unCode" : "FR005070",
    "ics" : true
  },
  {
    "name" : "Agen bureau",
    "unCode" : "FR005130",
    "ics" : true
  },
  {
    "name" : "Grandpuits raffinerie",
    "unCode" : "FR005190",
    "ics" : true
  },
  {
    "name" : "Lons le saunier bureau",
    "unCode" : "FR005260",
    "ics" : true
  },
  {
    "name" : "Aulnay-sous-Bois bureau",
    "unCode" : "FR005340",
    "ics" : true
  },
  {
    "name" : "Lesquin bureau",
    "unCode" : "FR005350",
    "ics" : true
  },
  {
    "name" : "Corbeil evry bureau",
    "unCode" : "FR005440",
    "ics" : true
  },
  {
    "name" : "Cahors bureau",
    "unCode" : "FR005470",
    "ics" : true
  },
  {
    "name" : "Rodez bureau",
    "unCode" : "FR005480",
    "ics" : true
  },
  {
    "name" : "Haguenau bureau",
    "unCode" : "FR005580",
    "ics" : true
  },
  {
    "name" : "Trappes bureau",
    "unCode" : "FR005590",
    "ics" : true
  },
  {
    "name" : "Arras bureau",
    "unCode" : "FR005620",
    "ics" : true
  },
  {
    "name" : "Montauban bureau",
    "unCode" : "FR005680",
    "ics" : true
  },
  {
    "name" : "Albi bureau",
    "unCode" : "FR005800",
    "ics" : true
  },
  {
    "name" : "Auch bureau",
    "unCode" : "FR005810",
    "ics" : true
  },
  {
    "name" : "Gap bureau",
    "unCode" : "FR005830",
    "ics" : true
  },
  {
    "name" : "Mont de marsan bureau",
    "unCode" : "FR005850",
    "ics" : true
  },
  {
    "name" : "Rungis bureau",
    "unCode" : "FR006130",
    "ics" : true
  },
  {
    "name" : "Roissy France handling bureau",
    "unCode" : "FR00617C",
    "ics" : true
  },
  {
    "name" : "Roissy Fedex bureau",
    "unCode" : "FR00619C",
    "ics" : true
  },
  {
    "name" : "La roche sur yon bureau",
    "unCode" : "FR006240",
    "ics" : true
  },
  {
    "name" : "Marne la vallee bureau",
    "unCode" : "FR006270",
    "ics" : true
  },
  {
    "name" : "Le raizet bureau",
    "unCode" : "FR006330",
    "ics" : true
  },
  {
    "name" : "Fort de france port bureau",
    "unCode" : "FR006340",
    "ics" : true
  },
  {
    "name" : "Degrad d cannes port bureau",
    "unCode" : "FR006370",
    "ics" : true
  },
  {
    "name" : "Cayenne aero bureau",
    "unCode" : "FR006380",
    "ics" : true
  },
  {
    "name" : "St laurent maroni bureau",
    "unCode" : "FR006390",
    "ics" : true
  },
  {
    "name" : "Le port bureau",
    "unCode" : "FR006420",
    "ics" : true
  },
  {
    "name" : "Le lamentin aero bureau",
    "unCode" : "FR006440",
    "ics" : true
  },
  {
    "name" : "St denis aero",
    "unCode" : "FR006460",
    "ics" : true
  },
  {
    "name" : "Cayenne CDP",
    "unCode" : "FR006530",
    "ics" : true
  },
  {
    "name" : "La pointe-jarry port",
    "unCode" : "FR006610",
    "ics" : true
  },
  {
    "name" : "Vallard thonex bureau",
    "unCode" : "FR006670",
    "ics" : true
  },
  {
    "name" : "Montpellier Mediterranee aero bur",
    "unCode" : "FR006710",
    "ics" : true
  },
  {
    "name" : "St georges de l'oyapok bureau",
    "unCode" : "FR006750",
    "ics" : true
  },
  {
    "name" : "Roissy prise en charge",
    "unCode" : "FR00677A",
    "ics" : true
  },
  {
    "name" : "Wissous BDP",
    "unCode" : "FR006790",
    "ics" : true
  },
  {
    "name" : "Longoni port bureau",
    "unCode" : "FR006800",
    "ics" : true
  },
  {
    "name" : "Pamandzi bureau",
    "unCode" : "FR006810",
    "ics" : true
  },
  {
    "name" : "Cid Bureau fictif",
    "unCode" : "FR009990",
    "ics" : true
  },
  {
    "name" : "Montpellier mediterranee bur dedoua",
    "unCode" : "FR340002",
    "ics" : true
  },
  {
    "name" : "Dunkerque ferry bureau",
    "unCode" : "FR590002",
    "ics" : true
  },
  {
    "name" : "Calais port tunnel bureau",
    "unCode" : "FR620001",
    "ics" : true
  },
  {
    "name" : "Roissy Sogaris bureau",
    "unCode" : "FRA0617B",
    "ics" : true
  },
  {
    "name" : "Roissy CDP bureau",
    "unCode" : "FRA0617D",
    "ics" : true
  },
  {
    "name" : "Roissy Air France bureau",
    "unCode" : "FRA0619A",
    "ics" : true
  },
  {
    "name" : "Roissy Cargo centre bureau",
    "unCode" : "FRA0619B",
    "ics" : true
  },
  {
    "name" : "Roissy Sodexi bureau",
    "unCode" : "FRB0617A",
    "ics" : true
  },
  {
    "name" : "Roissy Chronopost bureau",
    "unCode" : "FRB0617D",
    "ics" : true
  },
  {
    "name" : "Roissy Cargo 7 bureau",
    "unCode" : "FRB0617E",
    "ics" : true
  },
  {
    "name" : "Roissy Banale bureau",
    "unCode" : "FRB0619A",
    "ics" : true
  },
  {
    "name" : "Roissy avitaillement",
    "unCode" : "FRB0677B",
    "ics" : true
  },
  {
    "name" : "Roissy Nord Gestion des procedures",
    "unCode" : "FRC0619A",
    "ics" : true
  },
  {
    "name" : "Le Havre Port - CREPS",
    "unCode" : "FRD02300",
    "ics" : true
  },
  {
    "name" : "Roissy OPCO Aerogares",
    "unCode" : "FRD0619A",
    "ics" : true
  },
  {
    "name" : "National Transit Movements",
    "unCode" : "GB000004",
    "ics" : false
  },
  {
    "name" : "Birmingham Airport",
    "unCode" : "GB000011",
    "ics" : false
  },
  {
    "name" : "UKBF, Bristol International Airport",
    "unCode" : "GB000029",
    "ics" : false
  },
  {
    "name" : "Ramsgate",
    "unCode" : "GB000047",
    "ics" : false
  },
  {
    "name" : "Felixstowe",
    "unCode" : "GB000051",
    "ics" : false
  },
  {
    "name" : "Harwich",
    "unCode" : "GB000052",
    "ics" : false
  },
  {
    "name" : "Cairnryan",
    "unCode" : "GB000053",
    "ics" : false
  },
  {
    "name" : "Glasgow Airport",
    "unCode" : "GB000054",
    "ics" : false
  },
  {
    "name" : "Aberdeen + Highlands & Island Ports",
    "unCode" : "GB000055",
    "ics" : false
  },
  {
    "name" : "Edinburgh Airport",
    "unCode" : "GB000058",
    "ics" : false
  },
  {
    "name" : "Grangemouth",
    "unCode" : "GB000059",
    "ics" : false
  },
  {
    "name" : "Dover/Folkestone Eurotunnel Freight",
    "unCode" : "GB000060",
    "ics" : false
  },
  {
    "name" : "Hull",
    "unCode" : "GB000072",
    "ics" : false
  },
  {
    "name" : "Immingham",
    "unCode" : "GB000074",
    "ics" : false
  },
  {
    "name" : "Liverpool",
    "unCode" : "GB000080",
    "ics" : false
  },
  {
    "name" : "UK North Auth Consignor/nees",
    "unCode" : "GB000081",
    "ics" : false
  },
  {
    "name" : "London Heathrow Cargo",
    "unCode" : "GB000084",
    "ics" : false
  },
  {
    "name" : "London Gatwick Airport Cargo Dist.",
    "unCode" : "GB000085",
    "ics" : false
  },
  {
    "name" : "Leeds Bradford",
    "unCode" : "GB000087",
    "ics" : false
  },
  {
    "name" : "Tilbury",
    "unCode" : "GB000093",
    "ics" : false
  },
  {
    "name" : "Luton Airport FCT",
    "unCode" : "GB000102",
    "ics" : false
  },
  {
    "name" : "London Heathrow Airport (Baggage)",
    "unCode" : "GB000120",
    "ics" : false
  },
  {
    "name" : "Stansted Airport FCT",
    "unCode" : "GB000121",
    "ics" : false
  },
  {
    "name" : "Cardiff Airport (including Barry)",
    "unCode" : "GB000122",
    "ics" : false
  },
  {
    "name" : "HOLYHEAD",
    "unCode" : "GB000124",
    "ics" : false
  },
  {
    "name" : "PEMBROKE DOCK",
    "unCode" : "GB000126",
    "ics" : false
  },
  {
    "name" : "Purfleet Thames Terminal",
    "unCode" : "GB000149",
    "ics" : false
  },
  {
    "name" : "Thamesport",
    "unCode" : "GB000150",
    "ics" : false
  },
  {
    "name" : "London Gateway Port",
    "unCode" : "GB000170",
    "ics" : false
  },
  {
    "name" : "Manchester",
    "unCode" : "GB000191",
    "ics" : false
  },
  {
    "name" : "Border Force, Port of Tyne",
    "unCode" : "GB000218",
    "ics" : false
  },
  {
    "name" : "Teesport",
    "unCode" : "GB000219",
    "ics" : false
  },
  {
    "name" : "UKBA East Midlands Airport",
    "unCode" : "GB000245",
    "ics" : false
  },
  {
    "name" : "UK South Auth Consignor/nees",
    "unCode" : "GB000246",
    "ics" : false
  },
  {
    "name" : "Southampton",
    "unCode" : "GB000290",
    "ics" : false
  },
  {
    "name" : "Poole Ferry Terminal",
    "unCode" : "GB000291",
    "ics" : false
  },
  {
    "name" : "Portsmouth",
    "unCode" : "GB000292",
    "ics" : false
  },
  {
    "name" : "Isle of Man Customs & Excise",
    "unCode" : "GB000450",
    "ics" : false
  },
  {
    "name" : "Guernsey Customs & Excise",
    "unCode" : "GB000461",
    "ics" : false
  },
  {
    "name" : "Jersey Customs & Immigration",
    "unCode" : "GB000465",
    "ics" : false
  },
  {
    "name" : "Plymouth Docks",
    "unCode" : "GB003050",
    "ics" : false
  },
  {
    "name" : "Newhaven",
    "unCode" : "GB003250",
    "ics" : false
  },
  {
    "name" : "Killingholme - Appointment only",
    "unCode" : "GB005170",
    "ics" : false
  },
  {
    "name" : "Fishguard",
    "unCode" : "GB005200",
    "ics" : false
  },
  {
    "name" : "Heysham",
    "unCode" : "GB005210",
    "ics" : false
  },
  {
    "name" : "BCP 'Tbilisi Airport'",
    "unCode" : "GEBCP001",
    "ics" : false
  },
  {
    "name" : "BCP 'Tsiteli Khidi'",
    "unCode" : "GEBCP002",
    "ics" : false
  },
  {
    "name" : "BCP “Sadakhlo – Motorway”",
    "unCode" : "GEBCP003",
    "ics" : false
  },
  {
    "name" : "BCP “Sadakhlo – Railway”",
    "unCode" : "GEBCP004",
    "ics" : false
  },
  {
    "name" : "BCP “Guguti”",
    "unCode" : "GEBCP005",
    "ics" : false
  },
  {
    "name" : "BCP “Gardabani”",
    "unCode" : "GEBCP009",
    "ics" : false
  },
  {
    "name" : "BCP “Lagodekhi”",
    "unCode" : "GEBCP010",
    "ics" : false
  },
  {
    "name" : "BCP “Kazbegi”",
    "unCode" : "GEBCP101",
    "ics" : false
  },
  {
    "name" : "BCP “Vale”",
    "unCode" : "GEBCP301",
    "ics" : false
  },
  {
    "name" : "BCP “Ninotsminda”",
    "unCode" : "GEBCP302",
    "ics" : false
  },
  {
    "name" : "BCP“Kartsakhi–Akhalkalaki Railway”",
    "unCode" : "GEBCP309",
    "ics" : false
  },
  {
    "name" : "BCP “Kartsakhi”",
    "unCode" : "GEBCP320",
    "ics" : false
  },
  {
    "name" : "BCP “Kutaisi and Senaki Airports",
    "unCode" : "GEBCP401",
    "ics" : false
  },
  {
    "name" : "BCP “Poti Sea Port'",
    "unCode" : "GEBCP501",
    "ics" : false
  },
  {
    "name" : "BCP “Kulevi Sea Port'",
    "unCode" : "GEBCP502",
    "ics" : false
  },
  {
    "name" : "BCP new sea port of Poti",
    "unCode" : "GEBCP504",
    "ics" : false
  },
  {
    "name" : "BCP “Sarpi”",
    "unCode" : "GEBCP601",
    "ics" : false
  },
  {
    "name" : "BCP ”Batumi Airport”",
    "unCode" : "GEBCP603",
    "ics" : false
  },
  {
    "name" : "BCP “Batumi Sea Port”",
    "unCode" : "GEBCP604",
    "ics" : false
  },
  {
    "name" : "CCD Rustavi",
    "unCode" : "GECCD014",
    "ics" : false
  },
  {
    "name" : "CCD Telavi",
    "unCode" : "GECCD017",
    "ics" : false
  },
  {
    "name" : "CCD Akhaltsikhe",
    "unCode" : "GECCD300",
    "ics" : false
  },
  {
    "name" : "CCD Kutaisi",
    "unCode" : "GECCD400",
    "ics" : false
  },
  {
    "name" : "CCZ Tbilisi",
    "unCode" : "GECCZ111",
    "ics" : false
  },
  {
    "name" : "CCZ Batumi",
    "unCode" : "GECCZ112",
    "ics" : false
  },
  {
    "name" : "CCZ Poti",
    "unCode" : "GECCZ113",
    "ics" : false
  },
  {
    "name" : "CCZ Airport",
    "unCode" : "GECCZ114",
    "ics" : false
  },
  {
    "name" : "CCZ Tbilisi 2",
    "unCode" : "GECCZ115",
    "ics" : false
  },
  {
    "name" : "CCZ Tbilisi 2",
    "unCode" : "GECCZ116",
    "ics" : false
  },
  {
    "name" : "CCZ E-GEZ",
    "unCode" : "GECCZ117",
    "ics" : false
  },
  {
    "name" : "FIZ 'Tbilisi Technology Park '",
    "unCode" : "GEFIZ110",
    "ics" : false
  },
  {
    "name" : "FIZ KUTAISI",
    "unCode" : "GEFIZ403",
    "ics" : false
  },
  {
    "name" : "FIZ hualing Kutaisi",
    "unCode" : "GEFIZ404",
    "ics" : false
  },
  {
    "name" : "FIZ POTI",
    "unCode" : "GEFIZ503",
    "ics" : false
  },
  {
    "name" : "ATHINON",
    "unCode" : "GR000102",
    "ics" : true
  },
  {
    "name" : "ASTAKOU",
    "unCode" : "GR000232",
    "ics" : true
  },
  {
    "name" : "MESOLOGIOU",
    "unCode" : "GR000234",
    "ics" : true
  },
  {
    "name" : "LAVRIOU",
    "unCode" : "GR000303",
    "ics" : true
  },
  {
    "name" : "A.I.A. 'ELEFTHERIOS VENIZELOS'",
    "unCode" : "GR000304",
    "ics" : true
  },
  {
    "name" : "RAFINAS",
    "unCode" : "GR000331",
    "ics" : true
  },
  {
    "name" : "NAFPLIOU",
    "unCode" : "GR000402",
    "ics" : true
  },
  {
    "name" : "ARTAS",
    "unCode" : "GR000631",
    "ics" : true
  },
  {
    "name" : "PATRON",
    "unCode" : "GR000701",
    "ics" : true
  },
  {
    "name" : "EGIOU",
    "unCode" : "GR000731",
    "ics" : true
  },
  {
    "name" : "ANTIKYRAS",
    "unCode" : "GR000831",
    "ics" : true
  },
  {
    "name" : "INOIS",
    "unCode" : "GR000832",
    "ics" : true
  },
  {
    "name" : "DRAMAS",
    "unCode" : "GR001002",
    "ics" : true
  },
  {
    "name" : "DYTIKIS ATTIKIS",
    "unCode" : "GR001102",
    "ics" : true
  },
  {
    "name" : "RODOU",
    "unCode" : "GR001202",
    "ics" : true
  },
  {
    "name" : "KALYMNOY",
    "unCode" : "GR001232",
    "ics" : true
  },
  {
    "name" : "KARPATHOU",
    "unCode" : "GR001233",
    "ics" : true
  },
  {
    "name" : "LEROU",
    "unCode" : "GR001234",
    "ics" : true
  },
  {
    "name" : "KO",
    "unCode" : "GR001235",
    "ics" : true
  },
  {
    "name" : "PATMOU",
    "unCode" : "GR001236",
    "ics" : true
  },
  {
    "name" : "SIMIS",
    "unCode" : "GR001237",
    "ics" : true
  },
  {
    "name" : "MEGISTIS",
    "unCode" : "GR001272",
    "ics" : true
  },
  {
    "name" : "ALEXANDROUPOLIS",
    "unCode" : "GR001302",
    "ics" : true
  },
  {
    "name" : "NEAS ORESTIADAS",
    "unCode" : "GR001331",
    "ics" : true
  },
  {
    "name" : "KIPON",
    "unCode" : "GR001332",
    "ics" : true
  },
  {
    "name" : "KASTANEON",
    "unCode" : "GR001336",
    "ics" : true
  },
  {
    "name" : "CHALKIDAS",
    "unCode" : "GR001402",
    "ics" : true
  },
  {
    "name" : "OREON",
    "unCode" : "GR001431",
    "ics" : true
  },
  {
    "name" : "ZAKYNTHOU",
    "unCode" : "GR001631",
    "ics" : true
  },
  {
    "name" : "KYLLINIS",
    "unCode" : "GR001732",
    "ics" : true
  },
  {
    "name" : "VERIAS",
    "unCode" : "GR001802",
    "ics" : true
  },
  {
    "name" : "IRAKLIOU",
    "unCode" : "GR001902",
    "ics" : true
  },
  {
    "name" : "1ο THESSALONIKIS",
    "unCode" : "GR002001",
    "ics" : true
  },
  {
    "name" : "2ο THESSALONIKIS",
    "unCode" : "GR002005",
    "ics" : true
  },
  {
    "name" : "3o THESSALONIKIS",
    "unCode" : "GR002006",
    "ics" : true
  },
  {
    "name" : "STAVROU",
    "unCode" : "GR002051",
    "ics" : true
  },
  {
    "name" : "IGOUMENITSAS",
    "unCode" : "GR002102",
    "ics" : true
  },
  {
    "name" : "MAVROMATIOU",
    "unCode" : "GR002132",
    "ics" : true
  },
  {
    "name" : "IOANNINON",
    "unCode" : "GR002202",
    "ics" : true
  },
  {
    "name" : "KAKAVIAS",
    "unCode" : "GR002203",
    "ics" : true
  },
  {
    "name" : "MERTZANIS",
    "unCode" : "GR002233",
    "ics" : true
  },
  {
    "name" : "KAVALAS",
    "unCode" : "GR002302",
    "ics" : true
  },
  {
    "name" : "KASTORIAS",
    "unCode" : "GR002501",
    "ics" : true
  },
  {
    "name" : "KERKYRAS",
    "unCode" : "GR002602",
    "ics" : true
  },
  {
    "name" : "ARGOSTOLIOU",
    "unCode" : "GR002731",
    "ics" : true
  },
  {
    "name" : "EVZONON",
    "unCode" : "GR002802",
    "ics" : true
  },
  {
    "name" : "DOIRANIS",
    "unCode" : "GR002803",
    "ics" : true
  },
  {
    "name" : "KILKIS",
    "unCode" : "GR002805",
    "ics" : true
  },
  {
    "name" : "PTOLEMAIDAS",
    "unCode" : "GR002931",
    "ics" : true
  },
  {
    "name" : "KORINTHOU",
    "unCode" : "GR003002",
    "ics" : true
  },
  {
    "name" : "SYROU",
    "unCode" : "GR003102",
    "ics" : true
  },
  {
    "name" : "MILOY",
    "unCode" : "GR003131",
    "ics" : true
  },
  {
    "name" : "PAROU",
    "unCode" : "GR003132",
    "ics" : true
  },
  {
    "name" : "MYKONOY",
    "unCode" : "GR003133",
    "ics" : true
  },
  {
    "name" : "NAXOU",
    "unCode" : "GR003134",
    "ics" : true
  },
  {
    "name" : "THIRAS",
    "unCode" : "GR003135",
    "ics" : true
  },
  {
    "name" : "GYTHIOU",
    "unCode" : "GR003201",
    "ics" : true
  },
  {
    "name" : "NEAPOLIS VION",
    "unCode" : "GR003232",
    "ics" : true
  },
  {
    "name" : "LARISAS",
    "unCode" : "GR003302",
    "ics" : true
  },
  {
    "name" : "AGIOU NIKOLAOU",
    "unCode" : "GR003431",
    "ics" : true
  },
  {
    "name" : "SHTEIAS",
    "unCode" : "GR003433",
    "ics" : true
  },
  {
    "name" : "MYTILINIS",
    "unCode" : "GR003502",
    "ics" : true
  },
  {
    "name" : "MYRINAS",
    "unCode" : "GR003532",
    "ics" : true
  },
  {
    "name" : "PLOMARIOU",
    "unCode" : "GR003575",
    "ics" : true
  },
  {
    "name" : "LEFKADAS",
    "unCode" : "GR003631",
    "ics" : true
  },
  {
    "name" : "VOLOU",
    "unCode" : "GR003702",
    "ics" : true
  },
  {
    "name" : "SKIATHOU",
    "unCode" : "GR003751",
    "ics" : true
  },
  {
    "name" : "KALAMATAS",
    "unCode" : "GR003802",
    "ics" : true
  },
  {
    "name" : "XANTHIS",
    "unCode" : "GR003931",
    "ics" : true
  },
  {
    "name" : "1ο PEIRAIA",
    "unCode" : "GR004001",
    "ics" : true
  },
  {
    "name" : "3ο PEIRAIA",
    "unCode" : "GR004005",
    "ics" : true
  },
  {
    "name" : "2ο PEIRAIA",
    "unCode" : "GR004006",
    "ics" : true
  },
  {
    "name" : "4ο PEIRAIA",
    "unCode" : "GR004007",
    "ics" : true
  },
  {
    "name" : "SKYDRAS",
    "unCode" : "GR004101",
    "ics" : true
  },
  {
    "name" : "KATERINIS",
    "unCode" : "GR004201",
    "ics" : true
  },
  {
    "name" : "PREVEZAS",
    "unCode" : "GR004302",
    "ics" : true
  },
  {
    "name" : "RETHYMNΟΥ",
    "unCode" : "GR004431",
    "ics" : true
  },
  {
    "name" : "KOMOTINIS",
    "unCode" : "GR004531",
    "ics" : true
  },
  {
    "name" : "SAMOU",
    "unCode" : "GR004631",
    "ics" : true
  },
  {
    "name" : "AGIOU KIRIKOU",
    "unCode" : "GR004671",
    "ics" : true
  },
  {
    "name" : "SERRON",
    "unCode" : "GR004701",
    "ics" : true
  },
  {
    "name" : "TRIKALA",
    "unCode" : "GR004831",
    "ics" : true
  },
  {
    "name" : "STYLIDAS",
    "unCode" : "GR004902",
    "ics" : true
  },
  {
    "name" : "KRYSTALOPIGIS",
    "unCode" : "GR005001",
    "ics" : true
  },
  {
    "name" : "FLORINAS",
    "unCode" : "GR005031",
    "ics" : true
  },
  {
    "name" : "NIKIS",
    "unCode" : "GR005032",
    "ics" : true
  },
  {
    "name" : "ITEAS",
    "unCode" : "GR005131",
    "ics" : true
  },
  {
    "name" : "DAFNI",
    "unCode" : "GR005201",
    "ics" : true
  },
  {
    "name" : "IERISSOU",
    "unCode" : "GR005233",
    "ics" : true
  },
  {
    "name" : "NEON MOUDANION",
    "unCode" : "GR005234",
    "ics" : true
  },
  {
    "name" : "HANION",
    "unCode" : "GR005302",
    "ics" : true
  },
  {
    "name" : "CHIOS",
    "unCode" : "GR005401",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP JANKOMIR I SL.ZONA",
    "unCode" : "HR030171",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ŽITNJAK",
    "unCode" : "HR030228",
    "ics" : true
  },
  {
    "name" : "RGP ZRAČNA LUKA ZAGREB",
    "unCode" : "HR030236",
    "ics" : true
  },
  {
    "name" : "RGP POŠTA",
    "unCode" : "HR030244",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP KRAPINA I SL.ZONA",
    "unCode" : "HR030287",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP VARAŽDIN I SL.ZONA",
    "unCode" : "HR030325",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ČAKOVEC",
    "unCode" : "HR030333",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP KOPRIVNICA",
    "unCode" : "HR030376",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP BJELOVAR",
    "unCode" : "HR030384",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP SISAK",
    "unCode" : "HR030422",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO KUTINA",
    "unCode" : "HR030430",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO CRNAC",
    "unCode" : "HR030449",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP KARLOVAC",
    "unCode" : "HR030481",
    "ics" : true
  },
  {
    "name" : "RGP JASENOVAC",
    "unCode" : "HR030503",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO VOLINJA",
    "unCode" : "HR030538",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ZAPADNI KOLODVOR",
    "unCode" : "HR030562",
    "ics" : true
  },
  {
    "name" : "RGP DVOR",
    "unCode" : "HR030600",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO MACELJ",
    "unCode" : "HR030660",
    "ics" : true
  },
  {
    "name" : "KM I (RHEA-UPS)",
    "unCode" : "HR030724",
    "ics" : true
  },
  {
    "name" : "KM II (IN TIME-FEDEX I TNT)",
    "unCode" : "HR030732",
    "ics" : true
  },
  {
    "name" : "KM III (DHL)",
    "unCode" : "HR030740",
    "ics" : true
  },
  {
    "name" : "KM IV (LAGERMAX - DPD)",
    "unCode" : "HR030759",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO KOTORIBA",
    "unCode" : "HR030767",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP LUKA RIJEKA",
    "unCode" : "HR060178",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO ZRAČNA LUKA RIJEKA",
    "unCode" : "HR060186",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO OMIŠALJ",
    "unCode" : "HR060208",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO MALI LOŠINJ",
    "unCode" : "HR060216",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ŠKRLJEVO",
    "unCode" : "HR060224",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP LUKA PULA - POLA",
    "unCode" : "HR060267",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO LABIN",
    "unCode" : "HR060275",
    "ics" : true
  },
  {
    "name" : "KONTOLNO MJESTO ZRAČNA LUKA PULA",
    "unCode" : "HR060283",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO BUJE",
    "unCode" : "HR060291",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO BRŠICA",
    "unCode" : "HR060305",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO UMAG",
    "unCode" : "HR060313",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP PAZIN",
    "unCode" : "HR060356",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP GOSPIĆ",
    "unCode" : "HR060399",
    "ics" : true
  },
  {
    "name" : "RGP LIČKO PETROVO SELO",
    "unCode" : "HR060410",
    "ics" : true
  },
  {
    "name" : "RGP MALJEVAC",
    "unCode" : "HR060461",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP OSIJEK I SL. ZONA",
    "unCode" : "HR070173",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO ZRAČNA LUKA OSIJEK",
    "unCode" : "HR070181",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP VINKOVCI",
    "unCode" : "HR070203",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP SL. BROD I SL. ZONA",
    "unCode" : "HR070246",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP POŽEGA",
    "unCode" : "HR070254",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP VIROVITICA",
    "unCode" : "HR070297",
    "ics" : true
  },
  {
    "name" : "RGP BAJAKOVO",
    "unCode" : "HR070319",
    "ics" : true
  },
  {
    "name" : "RGP TOVARNIK",
    "unCode" : "HR070327",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP VUKOVAR I SL ZONA",
    "unCode" : "HR070343",
    "ics" : true
  },
  {
    "name" : "RGP BATINA",
    "unCode" : "HR070378",
    "ics" : true
  },
  {
    "name" : "RGP ILOK",
    "unCode" : "HR070386",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO PRINCIPOVAC I",
    "unCode" : "HR070394",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO PRINCIPOVAC II",
    "unCode" : "HR070408",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO ILOK I",
    "unCode" : "HR070416",
    "ics" : true
  },
  {
    "name" : "RGP ŽUPANJA MOST",
    "unCode" : "HR070440",
    "ics" : true
  },
  {
    "name" : "RGP GUNJA",
    "unCode" : "HR070467",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO Ž. KOL. DRENOVCI",
    "unCode" : "HR070483",
    "ics" : true
  },
  {
    "name" : "RGP SL. ŠAMAC I ŽELJ.KOL. SL. ŠAMAC",
    "unCode" : "HR070491",
    "ics" : true
  },
  {
    "name" : "RGP STARA GRADIŠKA",
    "unCode" : "HR070521",
    "ics" : true
  },
  {
    "name" : "RGP SLAVONSKI BROD I LUKA SL.BROD",
    "unCode" : "HR070548",
    "ics" : true
  },
  {
    "name" : "RGP SVILAJ",
    "unCode" : "HR070556",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO LUKA DRAVA",
    "unCode" : "HR070572",
    "ics" : true
  },
  {
    "name" : "RGP ERDUT I Ž.KOLODVOR",
    "unCode" : "HR070599",
    "ics" : true
  },
  {
    "name" : "RGP GORNJI VAROŠ",
    "unCode" : "HR070637",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ŽUPANJA",
    "unCode" : "HR070661",
    "ics" : true
  },
  {
    "name" : "KM TOVARNIK ŽELJEZNIČKI KOLODVOR",
    "unCode" : "HR070726",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP SPLIT",
    "unCode" : "HR080179",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ZRAČNA LUKA SPLIT",
    "unCode" : "HR080209",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ZADAR",
    "unCode" : "HR080314",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO ZRAČNA LUKA ZADAR",
    "unCode" : "HR080322",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP LUKA PLOČE",
    "unCode" : "HR080381",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO LUKA DUBROVNIK",
    "unCode" : "HR080438",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP KORČULA",
    "unCode" : "HR080446",
    "ics" : true
  },
  {
    "name" : "KONTROLNO MJESTO VELA LUKA",
    "unCode" : "HR080454",
    "ics" : true
  },
  {
    "name" : "KONT. MJESTO ZRAČNA LUKA DUBROVNIK",
    "unCode" : "HR080470",
    "ics" : true
  },
  {
    "name" : "RGP KAMENSKO",
    "unCode" : "HR080500",
    "ics" : true
  },
  {
    "name" : "RGP STRMICA",
    "unCode" : "HR080551",
    "ics" : true
  },
  {
    "name" : "RGP VINJANI DONJI",
    "unCode" : "HR080594",
    "ics" : true
  },
  {
    "name" : "RGP VINJANI GORNJI",
    "unCode" : "HR080632",
    "ics" : true
  },
  {
    "name" : "RGP METKOVIĆ - NOVA SELA",
    "unCode" : "HR080659",
    "ics" : true
  },
  {
    "name" : "RGP Ž. KOLODVOR I LUKA METKOVIĆ",
    "unCode" : "HR080683",
    "ics" : true
  },
  {
    "name" : "RGP KLEK",
    "unCode" : "HR080756",
    "ics" : true
  },
  {
    "name" : "RGP KARASOVIĆI",
    "unCode" : "HR080780",
    "ics" : true
  },
  {
    "name" : "RGP ZATON DOLI",
    "unCode" : "HR080810",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP ŠIBENIK",
    "unCode" : "HR080896",
    "ics" : true
  },
  {
    "name" : "SLUŽBA ZA RGP DUBROVNIK",
    "unCode" : "HR080918",
    "ics" : true
  },
  {
    "name" : "NAV Informatikai Intézet",
    "unCode" : "HU015000",
    "ics" : true
  },
  {
    "name" : "NAV Dél-Budapesti AVI",
    "unCode" : "HU101000",
    "ics" : true
  },
  {
    "name" : "NAV Dél-budapesti AVI Metrans Sz.h.",
    "unCode" : "HU101150",
    "ics" : true
  },
  {
    "name" : "NAV Dél-budapesti AVI Bilk Log. SZH",
    "unCode" : "HU101220",
    "ics" : true
  },
  {
    "name" : "NAV Dél-budapesti AVI BSZL Zrt. SZH",
    "unCode" : "HU101280",
    "ics" : true
  },
  {
    "name" : "NAV KAVIG",
    "unCode" : "HU102000",
    "ics" : true
  },
  {
    "name" : "NAV PVM AVI Masped Rt. SzH",
    "unCode" : "HU106200",
    "ics" : true
  },
  {
    "name" : "NAV Repülőtéri Igazgatósága",
    "unCode" : "HU121000",
    "ics" : true
  },
  {
    "name" : "NAV Kelet-Budapesti AVI",
    "unCode" : "HU160000",
    "ics" : true
  },
  {
    "name" : "NAV Észak-Budapesti AVI",
    "unCode" : "HU170000",
    "ics" : true
  },
  {
    "name" : "NAV Baranya Vármegyei AVI",
    "unCode" : "HU211000",
    "ics" : true
  },
  {
    "name" : "NAV BAVM AVI Mohácsi Hk.",
    "unCode" : "HU213000",
    "ics" : true
  },
  {
    "name" : "NAV Somogy Vármegyei AVI",
    "unCode" : "HU221000",
    "ics" : true
  },
  {
    "name" : "NAV Tolna Vármegyei AVI",
    "unCode" : "HU231000",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI Royal Sped Zrt. SzH",
    "unCode" : "HU311040",
    "ics" : true
  },
  {
    "name" : "NAV Bács-Kiskun Vármegyei AVI",
    "unCode" : "HU311500",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI Hercegszántói Hk.",
    "unCode" : "HU315000",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI Kelebia SzH",
    "unCode" : "HU316000",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI Tompai Hk.",
    "unCode" : "HU317000",
    "ics" : true
  },
  {
    "name" : "NAV JászNagykunSzolnok Vármegyei AV",
    "unCode" : "HU321000",
    "ics" : true
  },
  {
    "name" : "NAV JNSZVM AVI MB2001 Kft. SzH",
    "unCode" : "HU321010",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI Bajai SzH. I.",
    "unCode" : "HU331000",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI ÁTI DEPO Zrt. SzH.",
    "unCode" : "HU331010",
    "ics" : true
  },
  {
    "name" : "NAV BKKVM AVI Kiskőrösi SzH.",
    "unCode" : "HU332000",
    "ics" : true
  },
  {
    "name" : "NAV BorsodAbaújZemplénVármegyei AVI",
    "unCode" : "HU411000",
    "ics" : true
  },
  {
    "name" : "NAV BAZVM AVI ÁTI Depó SzH.",
    "unCode" : "HU411020",
    "ics" : true
  },
  {
    "name" : "NAV Heves Vármegyei AVI",
    "unCode" : "HU421000",
    "ics" : true
  },
  {
    "name" : "NAV Csongrád-Csanád Vármegyei AVI",
    "unCode" : "HU511000",
    "ics" : true
  },
  {
    "name" : "NAV CSCSVM AVI Zoll-Platz Kft. SzH",
    "unCode" : "HU511010",
    "ics" : true
  },
  {
    "name" : "NAV CSCSVM AVI Röszke Hk",
    "unCode" : "HU515000",
    "ics" : true
  },
  {
    "name" : "NAV CSCSVM AVI Röszke Hk Vasúti SzH",
    "unCode" : "HU515030",
    "ics" : true
  },
  {
    "name" : "NAV CSCSVM AVI Tiszaszigeti SzH",
    "unCode" : "HU517000",
    "ics" : true
  },
  {
    "name" : "NAV Békés Vármegyei AVI",
    "unCode" : "HU521000",
    "ics" : true
  },
  {
    "name" : "NAV BÉVM AVI Pintér Vám SzH",
    "unCode" : "HU521050",
    "ics" : true
  },
  {
    "name" : "NAV Győr-Moson-Sopron Vármegyei AVI",
    "unCode" : "HU611000",
    "ics" : true
  },
  {
    "name" : "NAVGYMSAVI QuehenbergerLogisticsKft",
    "unCode" : "HU611040",
    "ics" : true
  },
  {
    "name" : "NAV GYMSVM AVI Soproni SzH",
    "unCode" : "HU618000",
    "ics" : true
  },
  {
    "name" : "NAV GYMSVM AVI Gysev Cargo SzH",
    "unCode" : "HU618010",
    "ics" : true
  },
  {
    "name" : "NAV Komárom-Esztergom Vármegyei AVI",
    "unCode" : "HU621000",
    "ics" : true
  },
  {
    "name" : "NAV KEVM AVI ZEBRA NEO2014 SzH",
    "unCode" : "HU621030",
    "ics" : true
  },
  {
    "name" : "NAV KEVM AVI Esztergomi SzH",
    "unCode" : "HU624000",
    "ics" : true
  },
  {
    "name" : "NAV KEVM AVI Weskamp Bt. SzH",
    "unCode" : "HU624100",
    "ics" : true
  },
  {
    "name" : "NAV Veszprém Vármegyei AVI",
    "unCode" : "HU631000",
    "ics" : true
  },
  {
    "name" : "NAV VEVM AVI Pápai SzH",
    "unCode" : "HU634000",
    "ics" : true
  },
  {
    "name" : "NAV VEVM AVI Pápa Repülőtér",
    "unCode" : "HU634100",
    "ics" : true
  },
  {
    "name" : "NAV Hajdú-Bihar Vármegyei AVI",
    "unCode" : "HU711000",
    "ics" : true
  },
  {
    "name" : "NAV Hajdú-Bihar Vármegyei AVI e-Ker",
    "unCode" : "HU711030",
    "ics" : true
  },
  {
    "name" : "NAV Hajdú-Bihar Vm-i AVI Repülőtér",
    "unCode" : "HU711070",
    "ics" : true
  },
  {
    "name" : "NAV Szabolcs-Szatmár-Bereg VM AVI",
    "unCode" : "HU721000",
    "ics" : true
  },
  {
    "name" : "NAV SzabolcsSzatmárBereg VMAVI-EWG",
    "unCode" : "HU721070",
    "ics" : true
  },
  {
    "name" : "NAV SZSZBVM AVI Záhonyi Hk.",
    "unCode" : "HU724000",
    "ics" : true
  },
  {
    "name" : "NAV SZSZBVM AVI Eperjeskei SzH",
    "unCode" : "HU724010",
    "ics" : true
  },
  {
    "name" : "NAV SZSZBVM AVI Lónyai SzH",
    "unCode" : "HU726030",
    "ics" : true
  },
  {
    "name" : "NAV SZSZBVM AVI Beregsurányi Hk.",
    "unCode" : "HU726040",
    "ics" : true
  },
  {
    "name" : "NAV SZSZBVM AVI Tiszabecsi SzH",
    "unCode" : "HU727000",
    "ics" : true
  },
  {
    "name" : "NAV SZSZBVM AVI Nagyhódosi SzH.",
    "unCode" : "HU727010",
    "ics" : true
  },
  {
    "name" : "NAV Pest Vármegyei AVI",
    "unCode" : "HU811000",
    "ics" : true
  },
  {
    "name" : "NAV PVM AVI Depo-Zoll Kft. SzH",
    "unCode" : "HU811010",
    "ics" : true
  },
  {
    "name" : "NAV PVM AVI Schenker Kft.SzH",
    "unCode" : "HU811020",
    "ics" : true
  },
  {
    "name" : "NAV PVM AVI CECZ Kft. Szh.",
    "unCode" : "HU811030",
    "ics" : true
  },
  {
    "name" : "NAV DBP AVI Trimex Kft. Sz. Hely",
    "unCode" : "HU811190",
    "ics" : true
  },
  {
    "name" : "NAV Pest Vármegyei AVI e-Ker",
    "unCode" : "HU811500",
    "ics" : true
  },
  {
    "name" : "NAV Fejér Vármegyei AVI",
    "unCode" : "HU821000",
    "ics" : true
  },
  {
    "name" : "NAV FEM AVI LOGALBA Kft. SzH",
    "unCode" : "HU821060",
    "ics" : true
  },
  {
    "name" : "NAV Nógrád Vármegyei AVI",
    "unCode" : "HU831000",
    "ics" : true
  },
  {
    "name" : "NAV Vas Vármegyei AVI",
    "unCode" : "HU911000",
    "ics" : true
  },
  {
    "name" : "NAV VAVM AVI VÁMCO SzH",
    "unCode" : "HU911010",
    "ics" : true
  },
  {
    "name" : "NAV Zala Vármegyei AVI",
    "unCode" : "HU921000",
    "ics" : true
  },
  {
    "name" : "NAV ZAVM AVI Sármelléki Repülőtér",
    "unCode" : "HU921060",
    "ics" : true
  },
  {
    "name" : "NAV ZAVM AVI Nagykanizsai SzH",
    "unCode" : "HU922000",
    "ics" : true
  },
  {
    "name" : "NAV ZAVM AVI Nagykanizsa VSZ Zrt.Sz",
    "unCode" : "HU922050",
    "ics" : true
  },
  {
    "name" : "ACE/ACR ATHLONE",
    "unCode" : "IEATH200",
    "ics" : true
  },
  {
    "name" : "ACE/ACR Athy",
    "unCode" : "IEATY200",
    "ics" : true
  },
  {
    "name" : "Athy",
    "unCode" : "IEATY800",
    "ics" : true
  },
  {
    "name" : "Burtonport",
    "unCode" : "IEBTP100",
    "ics" : true
  },
  {
    "name" : "BANTRY, CORK",
    "unCode" : "IEBYT100",
    "ics" : true
  },
  {
    "name" : "Castletownbere Port",
    "unCode" : "IECBP100",
    "ics" : true
  },
  {
    "name" : "DROGHEDA PORT",
    "unCode" : "IEDRO100",
    "ics" : true
  },
  {
    "name" : "DUBLIN PORT",
    "unCode" : "IEDUB100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR DUBLIN",
    "unCode" : "IEDUB200",
    "ics" : true
  },
  {
    "name" : "DUBLIN AIRPORT",
    "unCode" : "IEDUB400",
    "ics" : true
  },
  {
    "name" : "DUBLIN MAIL CENTRE",
    "unCode" : "IEDUB500",
    "ics" : true
  },
  {
    "name" : "FOYNES",
    "unCode" : "IEFOV100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR FOYNES",
    "unCode" : "IEFOV200",
    "ics" : true
  },
  {
    "name" : "Greencastle Port",
    "unCode" : "IEGCP100",
    "ics" : true
  },
  {
    "name" : "GREENORE PORT, GOVT BLDGS,",
    "unCode" : "IEGRN100",
    "ics" : true
  },
  {
    "name" : "GALWAY",
    "unCode" : "IEGWY100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR GALWAY",
    "unCode" : "IEGWY200",
    "ics" : true
  },
  {
    "name" : "HOWTH PORT",
    "unCode" : "IEHWP100",
    "ics" : true
  },
  {
    "name" : "KILLYBEGS",
    "unCode" : "IEKBS100",
    "ics" : true
  },
  {
    "name" : "Limerick Docks,",
    "unCode" : "IELMK100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR LIMERICK",
    "unCode" : "IELMK200",
    "ics" : true
  },
  {
    "name" : "CORK AIRPORT",
    "unCode" : "IEORK400",
    "ics" : true
  },
  {
    "name" : "RINGASKIDDY",
    "unCode" : "IERIN100",
    "ics" : true
  },
  {
    "name" : "Rathmullen Port",
    "unCode" : "IERMP100",
    "ics" : true
  },
  {
    "name" : "Rosslare Harbour",
    "unCode" : "IEROS100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR Rosslare",
    "unCode" : "IEROS200",
    "ics" : true
  },
  {
    "name" : "Rosamhil Port",
    "unCode" : "IERSP100",
    "ics" : true
  },
  {
    "name" : "Shannon Airport",
    "unCode" : "IESNN400",
    "ics" : true
  },
  {
    "name" : "TIVOLI",
    "unCode" : "IETIV100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR Tvoli Cork",
    "unCode" : "IETIV200",
    "ics" : true
  },
  {
    "name" : "Waterford Government Buildings",
    "unCode" : "IEWAT100",
    "ics" : true
  },
  {
    "name" : "Belview, Waterford",
    "unCode" : "IEWAT101",
    "ics" : true
  },
  {
    "name" : "ACE/ACR Waterford",
    "unCode" : "IEWAT200",
    "ics" : true
  },
  {
    "name" : "Ireland West East",
    "unCode" : "IEWSE100",
    "ics" : true
  },
  {
    "name" : "ACE/ACR Ireland West East",
    "unCode" : "IEWSE200",
    "ics" : true
  },
  {
    "name" : "Reykjavik toll",
    "unCode" : "IS000100",
    "ics" : false
  },
  {
    "name" : "PUGLIA 2 FOGGIA",
    "unCode" : "IT014100",
    "ics" : true
  },
  {
    "name" : "MANFREDONIA",
    "unCode" : "IT014101",
    "ics" : true
  },
  {
    "name" : "PUGLIA 3 BRINDISI",
    "unCode" : "IT015100",
    "ics" : true
  },
  {
    "name" : "AEREOPORTO BRINDISI",
    "unCode" : "IT015101",
    "ics" : true
  },
  {
    "name" : "COSTA MORENA",
    "unCode" : "IT015102",
    "ics" : true
  },
  {
    "name" : "PUGLIA 4 LECCE",
    "unCode" : "IT016100",
    "ics" : true
  },
  {
    "name" : "GALLIPOLI",
    "unCode" : "IT016101",
    "ics" : true
  },
  {
    "name" : "OTRANTO",
    "unCode" : "IT016102",
    "ics" : true
  },
  {
    "name" : "PUGLIA 5 TARANTO",
    "unCode" : "IT017100",
    "ics" : true
  },
  {
    "name" : "PUGLIA 1 BARI",
    "unCode" : "IT018100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO BARI",
    "unCode" : "IT018101",
    "ics" : true
  },
  {
    "name" : "BARLETTA",
    "unCode" : "IT018102",
    "ics" : true
  },
  {
    "name" : "MONOPOLI",
    "unCode" : "IT018105",
    "ics" : true
  },
  {
    "name" : "BASILICATA - POTENZA",
    "unCode" : "IT019100",
    "ics" : true
  },
  {
    "name" : "MATERA",
    "unCode" : "IT019102",
    "ics" : true
  },
  {
    "name" : "EMILIA 3 PARMA",
    "unCode" : "IT028100",
    "ics" : true
  },
  {
    "name" : "EMILIA 2 PIACENZA",
    "unCode" : "IT029100",
    "ics" : true
  },
  {
    "name" : "RESIA",
    "unCode" : "IT034101",
    "ics" : true
  },
  {
    "name" : "AEROPORTO BOLZANO",
    "unCode" : "IT034102",
    "ics" : true
  },
  {
    "name" : "MAGAZZINI GENERALI BOLZANO",
    "unCode" : "IT034103",
    "ics" : true
  },
  {
    "name" : "BRESSANONE",
    "unCode" : "IT034104",
    "ics" : true
  },
  {
    "name" : "BRUNICO",
    "unCode" : "IT034105",
    "ics" : true
  },
  {
    "name" : "CAMPO DI TRENS",
    "unCode" : "IT034106",
    "ics" : true
  },
  {
    "name" : "MERANO",
    "unCode" : "IT034107",
    "ics" : true
  },
  {
    "name" : "TUBRE",
    "unCode" : "IT034108",
    "ics" : true
  },
  {
    "name" : "INTERPORTO",
    "unCode" : "IT035101",
    "ics" : true
  },
  {
    "name" : "SARDEGNA 2 SASSARI",
    "unCode" : "IT043100",
    "ics" : true
  },
  {
    "name" : "PORTO TORRES",
    "unCode" : "IT043101",
    "ics" : true
  },
  {
    "name" : "PORTO ALGHERO",
    "unCode" : "IT043102",
    "ics" : true
  },
  {
    "name" : "LA MADDALENA",
    "unCode" : "IT043103",
    "ics" : true
  },
  {
    "name" : "PORTO OLBIA",
    "unCode" : "IT043104",
    "ics" : true
  },
  {
    "name" : "SARDEGNA 1 CAGLIARI",
    "unCode" : "IT044100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI CAGLIARI",
    "unCode" : "IT044101",
    "ics" : true
  },
  {
    "name" : "ORISTANO",
    "unCode" : "IT044103",
    "ics" : true
  },
  {
    "name" : "PORTO CANALE",
    "unCode" : "IT044106",
    "ics" : true
  },
  {
    "name" : "TOSCANA 3 PISA",
    "unCode" : "IT054100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO PISA",
    "unCode" : "IT054101",
    "ics" : true
  },
  {
    "name" : "MASSA CARRARA",
    "unCode" : "IT054104",
    "ics" : true
  },
  {
    "name" : "LUCCA - VIAREGGIO",
    "unCode" : "IT054105",
    "ics" : true
  },
  {
    "name" : "TOSCANA 2 LIVORNO",
    "unCode" : "IT055100",
    "ics" : true
  },
  {
    "name" : "GROSSETO",
    "unCode" : "IT055103",
    "ics" : true
  },
  {
    "name" : "PIOMBINO - PORTOFERRAIO",
    "unCode" : "IT055104",
    "ics" : true
  },
  {
    "name" : "TOSCANA 4 PRATO",
    "unCode" : "IT056100",
    "ics" : true
  },
  {
    "name" : "LIGURIA 2 LA SPEZIA",
    "unCode" : "IT068100",
    "ics" : true
  },
  {
    "name" : "CAMPANIA 2 SALERNO",
    "unCode" : "IT084100",
    "ics" : true
  },
  {
    "name" : "CALABRIA 2 CATANZARO",
    "unCode" : "IT085100",
    "ics" : true
  },
  {
    "name" : "AEREOPORTO LAMEZIA TERME",
    "unCode" : "IT085101",
    "ics" : true
  },
  {
    "name" : "COSENZA",
    "unCode" : "IT085102",
    "ics" : true
  },
  {
    "name" : "CROTONE",
    "unCode" : "IT085103",
    "ics" : true
  },
  {
    "name" : "PORTO CORIGLIANO",
    "unCode" : "IT085104",
    "ics" : true
  },
  {
    "name" : "CAMPANIA 3 CASERTA",
    "unCode" : "IT088100",
    "ics" : true
  },
  {
    "name" : "SICILIA 6 PORTO EMPEDOCLE",
    "unCode" : "IT096100",
    "ics" : true
  },
  {
    "name" : "GELA",
    "unCode" : "IT096101",
    "ics" : true
  },
  {
    "name" : "SCIACCA",
    "unCode" : "IT096102",
    "ics" : true
  },
  {
    "name" : "LICATA",
    "unCode" : "IT096103",
    "ics" : true
  },
  {
    "name" : "SICILIA 4 MESSINA",
    "unCode" : "IT098100",
    "ics" : true
  },
  {
    "name" : "MILAZZO",
    "unCode" : "IT098101",
    "ics" : true
  },
  {
    "name" : "LIPARI",
    "unCode" : "IT098103",
    "ics" : true
  },
  {
    "name" : "S. AGATA DI MILITELLO",
    "unCode" : "IT098104",
    "ics" : true
  },
  {
    "name" : "SICILIA 3 SIRACUSA",
    "unCode" : "IT099100",
    "ics" : true
  },
  {
    "name" : "PORTO AUGUSTA",
    "unCode" : "IT099101",
    "ics" : true
  },
  {
    "name" : "POZZALLO",
    "unCode" : "IT099102",
    "ics" : true
  },
  {
    "name" : "RAGUSA",
    "unCode" : "IT099103",
    "ics" : true
  },
  {
    "name" : "VALLE D'AOSTA",
    "unCode" : "IT118100",
    "ics" : true
  },
  {
    "name" : "TRAFORO GRAN S. BERNARDO",
    "unCode" : "IT118101",
    "ics" : true
  },
  {
    "name" : "PIEMONTE 5 DOMODOSSOLA",
    "unCode" : "IT119100",
    "ics" : true
  },
  {
    "name" : "PIAGGIO VALMARA",
    "unCode" : "IT119101",
    "ics" : true
  },
  {
    "name" : "ISELLE TRASQUERA",
    "unCode" : "IT119102",
    "ics" : true
  },
  {
    "name" : "FRIULI-VENEZIA GIULIA 3 GORIZIA",
    "unCode" : "IT127100",
    "ics" : true
  },
  {
    "name" : "PORTO MONFALCONE",
    "unCode" : "IT127101",
    "ics" : true
  },
  {
    "name" : "AER. GIULIANO RONCHI DEI LEGIONARI",
    "unCode" : "IT127102",
    "ics" : true
  },
  {
    "name" : "VENETO 4 TREVISO",
    "unCode" : "IT134100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI TREVISO",
    "unCode" : "IT134101",
    "ics" : true
  },
  {
    "name" : "SEDICO",
    "unCode" : "IT134102",
    "ics" : true
  },
  {
    "name" : "VENETO 3 VICENZA",
    "unCode" : "IT135100",
    "ics" : true
  },
  {
    "name" : "VENETO 2 VERONA",
    "unCode" : "IT136100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI VERONA",
    "unCode" : "IT136101",
    "ics" : true
  },
  {
    "name" : "MM. GG DI VERONA",
    "unCode" : "IT136102",
    "ics" : true
  },
  {
    "name" : "VENETO 1 VENEZIA",
    "unCode" : "IT137100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI VENEZIA",
    "unCode" : "IT137101",
    "ics" : true
  },
  {
    "name" : "CHIOGGIA",
    "unCode" : "IT137102",
    "ics" : true
  },
  {
    "name" : "INTERPORTO DI MARGHERA",
    "unCode" : "IT137103",
    "ics" : true
  },
  {
    "name" : "PORTOGRUARO",
    "unCode" : "IT137104",
    "ics" : true
  },
  {
    "name" : "STAZIONE MARITTIMA DI VENEZIA",
    "unCode" : "IT137105",
    "ics" : true
  },
  {
    "name" : "VENETO 5 PADOVA",
    "unCode" : "IT138100",
    "ics" : true
  },
  {
    "name" : "ROVIGO",
    "unCode" : "IT138101",
    "ics" : true
  },
  {
    "name" : "CALABRIA 1 GIOIA TAURO",
    "unCode" : "IT172100",
    "ics" : true
  },
  {
    "name" : "PORTO DI VIBO VALENTIA",
    "unCode" : "IT172101",
    "ics" : true
  },
  {
    "name" : "CALABRIA 3 REGGIO CALABRIA",
    "unCode" : "IT173100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO REGGIO CALABRIA",
    "unCode" : "IT173101",
    "ics" : true
  },
  {
    "name" : "ROCCELLA JONICA",
    "unCode" : "IT173102",
    "ics" : true
  },
  {
    "name" : "NAPOLI",
    "unCode" : "IT182100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI NAPOLI",
    "unCode" : "IT182101",
    "ics" : true
  },
  {
    "name" : "INTERPORTO DI NOLA",
    "unCode" : "IT182102",
    "ics" : true
  },
  {
    "name" : "CAMPANIA 1 NAPOLI",
    "unCode" : "IT183100",
    "ics" : true
  },
  {
    "name" : "T. ANNUNZIATA - C.MARE DI STABIA",
    "unCode" : "IT183101",
    "ics" : true
  },
  {
    "name" : "CAMPANIA 4 BENEVENTO",
    "unCode" : "IT184100",
    "ics" : true
  },
  {
    "name" : "AVELLINO",
    "unCode" : "IT184101",
    "ics" : true
  },
  {
    "name" : "TOSCANA 1 FIRENZE",
    "unCode" : "IT201100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO FIRENZE",
    "unCode" : "IT201101",
    "ics" : true
  },
  {
    "name" : "AREZZO",
    "unCode" : "IT201102",
    "ics" : true
  },
  {
    "name" : "SIENA",
    "unCode" : "IT201103",
    "ics" : true
  },
  {
    "name" : "UMBRIA - PERUGIA",
    "unCode" : "IT202100",
    "ics" : true
  },
  {
    "name" : "TERNI",
    "unCode" : "IT202102",
    "ics" : true
  },
  {
    "name" : "PORTO GENOVA PASSO NUOVO",
    "unCode" : "IT211101",
    "ics" : true
  },
  {
    "name" : "PORTO GENOVA PRA",
    "unCode" : "IT211102",
    "ics" : true
  },
  {
    "name" : "LIGURIA 1 GENOVA",
    "unCode" : "IT212100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO GENOVA",
    "unCode" : "IT212101",
    "ics" : true
  },
  {
    "name" : "LIGURIA 3 SAVONA",
    "unCode" : "IT213100",
    "ics" : true
  },
  {
    "name" : "VADO LIGURE",
    "unCode" : "IT213101",
    "ics" : true
  },
  {
    "name" : "IMPERIA",
    "unCode" : "IT213102",
    "ics" : true
  },
  {
    "name" : "SANREMO",
    "unCode" : "IT213103",
    "ics" : true
  },
  {
    "name" : "ROMAGNA 1 RAVENNA",
    "unCode" : "IT221100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI BOLOGNA",
    "unCode" : "IT223101",
    "ics" : true
  },
  {
    "name" : "INTERPORTO DI BOLOGNA",
    "unCode" : "IT223102",
    "ics" : true
  },
  {
    "name" : "FERRARA",
    "unCode" : "IT223103",
    "ics" : true
  },
  {
    "name" : "EMILIA 4 MODENA",
    "unCode" : "IT224100",
    "ics" : true
  },
  {
    "name" : "REGGIO EMILIA",
    "unCode" : "IT224101",
    "ics" : true
  },
  {
    "name" : "ROMAGNA 2 RIMINI",
    "unCode" : "IT225100",
    "ics" : true
  },
  {
    "name" : "FORLI'-CESENA",
    "unCode" : "IT225101",
    "ics" : true
  },
  {
    "name" : "PIEMONTE 2 ALESSANDRIA",
    "unCode" : "IT231100",
    "ics" : true
  },
  {
    "name" : "ASTI",
    "unCode" : "IT231101",
    "ics" : true
  },
  {
    "name" : "RIVALTA SCRIVIA",
    "unCode" : "IT231102",
    "ics" : true
  },
  {
    "name" : "POZZOLO FORMIGARO",
    "unCode" : "IT231103",
    "ics" : true
  },
  {
    "name" : "PIEMONTE 3 NOVARA",
    "unCode" : "IT232100",
    "ics" : true
  },
  {
    "name" : "VERCELLI",
    "unCode" : "IT232101",
    "ics" : true
  },
  {
    "name" : "MAGAZZINI GENERALI DEI TRAFORI",
    "unCode" : "IT232102",
    "ics" : true
  },
  {
    "name" : "BIELLA",
    "unCode" : "IT232103",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 9 TIRANO",
    "unCode" : "IT272100",
    "ics" : true
  },
  {
    "name" : "PASSO DEL FOSCAGNO",
    "unCode" : "IT272101",
    "ics" : true
  },
  {
    "name" : "VILLA DI CHIAVENNA",
    "unCode" : "IT272103",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 4 VARESE",
    "unCode" : "IT273100",
    "ics" : true
  },
  {
    "name" : "BUSTO ARSIZIO",
    "unCode" : "IT273101",
    "ics" : true
  },
  {
    "name" : "GAGGIOLO",
    "unCode" : "IT273102",
    "ics" : true
  },
  {
    "name" : "LUINO",
    "unCode" : "IT273104",
    "ics" : true
  },
  {
    "name" : "PONTE TRESA",
    "unCode" : "IT273105",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 8 COMO",
    "unCode" : "IT275100",
    "ics" : true
  },
  {
    "name" : "LECCO",
    "unCode" : "IT275102",
    "ics" : true
  },
  {
    "name" : "MONTANO LUCINO",
    "unCode" : "IT275103",
    "ics" : true
  },
  {
    "name" : "ORIA VALSOLDA",
    "unCode" : "IT275104",
    "ics" : true
  },
  {
    "name" : "PONTE CHIASSO",
    "unCode" : "IT275105",
    "ics" : true
  },
  {
    "name" : "CAMPIONE D'ITALIA",
    "unCode" : "IT275106",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 6 BERGAMO",
    "unCode" : "IT276100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO BERGAMO",
    "unCode" : "IT276101",
    "ics" : true
  },
  {
    "name" : "MILANO",
    "unCode" : "IT277100",
    "ics" : true
  },
  {
    "name" : "O.N.T. MAGAZZINI GENERALI",
    "unCode" : "IT277102",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 3 MALPENSA",
    "unCode" : "IT279100",
    "ics" : true
  },
  {
    "name" : "SICILIA 2 CATANIA",
    "unCode" : "IT291100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO CATANIA",
    "unCode" : "IT291101",
    "ics" : true
  },
  {
    "name" : "RIPOSTO",
    "unCode" : "IT291102",
    "ics" : true
  },
  {
    "name" : "SICILIA 1 PALERMO",
    "unCode" : "IT292100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO PALERMO",
    "unCode" : "IT292101",
    "ics" : true
  },
  {
    "name" : "PORTO TERMINI IMERESE",
    "unCode" : "IT292102",
    "ics" : true
  },
  {
    "name" : "SICILIA 5 TRAPANI",
    "unCode" : "IT294100",
    "ics" : true
  },
  {
    "name" : "MARSALA",
    "unCode" : "IT294101",
    "ics" : true
  },
  {
    "name" : "MAZARA DEL VALLO",
    "unCode" : "IT294102",
    "ics" : true
  },
  {
    "name" : "PANTELLERIA",
    "unCode" : "IT294103",
    "ics" : true
  },
  {
    "name" : "LAMPEDUSA",
    "unCode" : "IT295100",
    "ics" : true
  },
  {
    "name" : "MOLISE - CAMPOBASSO",
    "unCode" : "IT303100",
    "ics" : true
  },
  {
    "name" : "TERMOLI",
    "unCode" : "IT303101",
    "ics" : true
  },
  {
    "name" : "MARCHE 1 ANCONA",
    "unCode" : "IT305100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO DI ANCONA",
    "unCode" : "IT305101",
    "ics" : true
  },
  {
    "name" : "FABRIANO",
    "unCode" : "IT305103",
    "ics" : true
  },
  {
    "name" : "PESARO-FANO",
    "unCode" : "IT305106",
    "ics" : true
  },
  {
    "name" : "MARCHE 2 CIVITANOVA MARCHE",
    "unCode" : "IT308100",
    "ics" : true
  },
  {
    "name" : "SAN BENEDETTO DEL TRONTO",
    "unCode" : "IT308101",
    "ics" : true
  },
  {
    "name" : "PIEMONTE 4 CUNEO",
    "unCode" : "IT311100",
    "ics" : true
  },
  {
    "name" : "ALBA",
    "unCode" : "IT311101",
    "ics" : true
  },
  {
    "name" : "PIEMONTE 1 TORINO",
    "unCode" : "IT314100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO TORINO",
    "unCode" : "IT314101",
    "ics" : true
  },
  {
    "name" : "INTERPORTO ORBASSANO",
    "unCode" : "IT314102",
    "ics" : true
  },
  {
    "name" : "PORTO INDUSTRIALE DI TRIESTE",
    "unCode" : "IT322101",
    "ics" : true
  },
  {
    "name" : "PORTO FRANCO NUOVO DI TRIESTE",
    "unCode" : "IT322102",
    "ics" : true
  },
  {
    "name" : "PORTO FRANCO VECCHIO DI TRIESTE",
    "unCode" : "IT322103",
    "ics" : true
  },
  {
    "name" : "INTERPORTO DI FERNETTI",
    "unCode" : "IT322104",
    "ics" : true
  },
  {
    "name" : "PROSECCO",
    "unCode" : "IT322105",
    "ics" : true
  },
  {
    "name" : "PONTEBBA",
    "unCode" : "IT323101",
    "ics" : true
  },
  {
    "name" : "PORTO NOGARO",
    "unCode" : "IT323102",
    "ics" : true
  },
  {
    "name" : "Z.A.U.",
    "unCode" : "IT323103",
    "ics" : true
  },
  {
    "name" : "PORDENONE",
    "unCode" : "IT323104",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 2 LINATE",
    "unCode" : "IT371100",
    "ics" : true
  },
  {
    "name" : "MELZO",
    "unCode" : "IT371101",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 1 MILANO",
    "unCode" : "IT372100",
    "ics" : true
  },
  {
    "name" : "CONCOREZZO",
    "unCode" : "IT372101",
    "ics" : true
  },
  {
    "name" : "FIERA RHO",
    "unCode" : "IT372102",
    "ics" : true
  },
  {
    "name" : "Vittuone-Turbigo",
    "unCode" : "IT372103",
    "ics" : true
  },
  {
    "name" : "PAVIA",
    "unCode" : "IT372104",
    "ics" : true
  },
  {
    "name" : "SANNAZZARO DE' BURGONDI",
    "unCode" : "IT372105",
    "ics" : true
  },
  {
    "name" : "VIGEVANO",
    "unCode" : "IT372106",
    "ics" : true
  },
  {
    "name" : "VOGHERA",
    "unCode" : "IT372107",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 5 MANTOVA",
    "unCode" : "IT373100",
    "ics" : true
  },
  {
    "name" : "CREMONA",
    "unCode" : "IT373101",
    "ics" : true
  },
  {
    "name" : "LOMBARDIA 7 BRESCIA",
    "unCode" : "IT374100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO BRESCIA",
    "unCode" : "IT374101",
    "ics" : true
  },
  {
    "name" : "LAZIO 1 ROMA",
    "unCode" : "IT402100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO CIAMPINO",
    "unCode" : "IT402101",
    "ics" : true
  },
  {
    "name" : "POMEZIA - ANZIO",
    "unCode" : "IT402102",
    "ics" : true
  },
  {
    "name" : "GUIDONIA",
    "unCode" : "IT402103",
    "ics" : true
  },
  {
    "name" : "LAZIO 2 FIUMICINO",
    "unCode" : "IT403100",
    "ics" : true
  },
  {
    "name" : "AEROPORTO FIUMICINO",
    "unCode" : "IT403101",
    "ics" : true
  },
  {
    "name" : "LAZIO 3 CIVITAVECCHIA",
    "unCode" : "IT404100",
    "ics" : true
  },
  {
    "name" : "VITERBO",
    "unCode" : "IT404101",
    "ics" : true
  },
  {
    "name" : "RIETI",
    "unCode" : "IT404102",
    "ics" : true
  },
  {
    "name" : "LAZIO 4 GAETA",
    "unCode" : "IT405100",
    "ics" : true
  },
  {
    "name" : "APRILIA",
    "unCode" : "IT405101",
    "ics" : true
  },
  {
    "name" : "LATINA",
    "unCode" : "IT405102",
    "ics" : true
  },
  {
    "name" : "FROSINONE",
    "unCode" : "IT405103",
    "ics" : true
  },
  {
    "name" : "ABRUZZO - PESCARA",
    "unCode" : "IT406100",
    "ics" : true
  },
  {
    "name" : "AEREOPORTO PESCARA",
    "unCode" : "IT406101",
    "ics" : true
  },
  {
    "name" : "GIULIANOVA",
    "unCode" : "IT406102",
    "ics" : true
  },
  {
    "name" : "ORTONA",
    "unCode" : "IT406103",
    "ics" : true
  },
  {
    "name" : "VASTO",
    "unCode" : "IT406104",
    "ics" : true
  },
  {
    "name" : "L'AQUILA",
    "unCode" : "IT406105",
    "ics" : true
  },
  {
    "name" : "AVEZZANO",
    "unCode" : "IT406106",
    "ics" : true
  },
  {
    "name" : "Kauno oro uosto postas",
    "unCode" : "LTKA1000",
    "ics" : true
  },
  {
    "name" : "Kybartų geležinkelio postas",
    "unCode" : "LTKG3000",
    "ics" : true
  },
  {
    "name" : "Kybartų kelio postas",
    "unCode" : "LTKK2000",
    "ics" : true
  },
  {
    "name" : "Ramoniškių kelio postas",
    "unCode" : "LTKK3000",
    "ics" : true
  },
  {
    "name" : "Krovinių postas Tiekimas",
    "unCode" : "LTKR2000",
    "ics" : true
  },
  {
    "name" : "MTV KIT",
    "unCode" : "LTKR2004",
    "ics" : true
  },
  {
    "name" : "MTV Lavisa",
    "unCode" : "LTKR2006",
    "ics" : true
  },
  {
    "name" : "MTV Lavisos LEZ",
    "unCode" : "LTKR2008",
    "ics" : true
  },
  {
    "name" : "MTV Jovarai",
    "unCode" : "LTKR2009",
    "ics" : true
  },
  {
    "name" : "Marijampolės krovinių postas",
    "unCode" : "LTKR5000",
    "ics" : true
  },
  {
    "name" : "Palangos oro uosto postas",
    "unCode" : "LTLA1000",
    "ics" : true
  },
  {
    "name" : "MTV Būtingė",
    "unCode" : "LTLA1001",
    "ics" : true
  },
  {
    "name" : "Pagėgių geležinkelio postas",
    "unCode" : "LTLG3000",
    "ics" : true
  },
  {
    "name" : "Nidos kelio postas",
    "unCode" : "LTLK1000",
    "ics" : true
  },
  {
    "name" : "Panemunės kelio postas",
    "unCode" : "LTLK4000",
    "ics" : true
  },
  {
    "name" : "MTV Gollner Spedition",
    "unCode" : "LTLR1006",
    "ics" : true
  },
  {
    "name" : "Nidos upių uosto postas",
    "unCode" : "LTLU4000",
    "ics" : true
  },
  {
    "name" : "Malkų įlankos jūrų uosto postas",
    "unCode" : "LTLU9000",
    "ics" : true
  },
  {
    "name" : "Molo jūrų uosto postas",
    "unCode" : "LTLUA000",
    "ics" : true
  },
  {
    "name" : "MTV Burės",
    "unCode" : "LTLUA001",
    "ics" : true
  },
  {
    "name" : "Pilies jūrų uosto postas",
    "unCode" : "LTLUB000",
    "ics" : true
  },
  {
    "name" : "Nemuno upių uosto postas",
    "unCode" : "LTLUC000",
    "ics" : true
  },
  {
    "name" : "Rusnės upių uosto postas",
    "unCode" : "LTLUD000",
    "ics" : true
  },
  {
    "name" : "Panevėžio 1 kat. krovinių postas",
    "unCode" : "LTPR2000",
    "ics" : true
  },
  {
    "name" : "Šiaulių oro uosto postas",
    "unCode" : "LTSA1000",
    "ics" : true
  },
  {
    "name" : "Radviliškio geležinkelio postas",
    "unCode" : "LTSG3000",
    "ics" : true
  },
  {
    "name" : "MTV Aloyzo Grigaliūno transportas",
    "unCode" : "LTSG3001",
    "ics" : true
  },
  {
    "name" : "Bugenių geležinkelio postas",
    "unCode" : "LTSG4000",
    "ics" : true
  },
  {
    "name" : "MTV Plungės kooperatinė prekyba",
    "unCode" : "LTSG4001",
    "ics" : true
  },
  {
    "name" : "Šiaulių 1 kat. krovinių postas",
    "unCode" : "LTSR1000",
    "ics" : true
  },
  {
    "name" : "MTV Šiaulių tiekimo bazė",
    "unCode" : "LTSR1001",
    "ics" : true
  },
  {
    "name" : "Vilniaus oro uosto postas",
    "unCode" : "LTVA1000",
    "ics" : true
  },
  {
    "name" : "Kenos geležinkelio postas",
    "unCode" : "LTVG1000",
    "ics" : true
  },
  {
    "name" : "Vaidotų geležinkelio postas",
    "unCode" : "LTVG2000",
    "ics" : true
  },
  {
    "name" : "Stasylų geležinkelio postas",
    "unCode" : "LTVG3000",
    "ics" : true
  },
  {
    "name" : "Lavoriškių kelio postas",
    "unCode" : "LTVK1000",
    "ics" : true
  },
  {
    "name" : "Medininkų kelio postas",
    "unCode" : "LTVK2000",
    "ics" : true
  },
  {
    "name" : "Šalčininkų kelio postas",
    "unCode" : "LTVK3000",
    "ics" : true
  },
  {
    "name" : "Raigardo kelio postas",
    "unCode" : "LTVK8000",
    "ics" : true
  },
  {
    "name" : "Šumsko kelio postas",
    "unCode" : "LTVKB000",
    "ics" : true
  },
  {
    "name" : "Tverečiaus kelio postas",
    "unCode" : "LTVKB100",
    "ics" : true
  },
  {
    "name" : "Vilniaus pašto postas",
    "unCode" : "LTVP1000",
    "ics" : true
  },
  {
    "name" : "Krovinių postas Savanoriai",
    "unCode" : "LTVR1000",
    "ics" : true
  },
  {
    "name" : "Krovinių postas Kirtimai",
    "unCode" : "LTVR3000",
    "ics" : true
  },
  {
    "name" : "Krovinių postas Žirmūnai",
    "unCode" : "LTVR4000",
    "ics" : true
  },
  {
    "name" : "Krovinių postas Paneriai",
    "unCode" : "LTVR5000",
    "ics" : true
  },
  {
    "name" : "Švendubrės upių uosto postas",
    "unCode" : "LTVU0100",
    "ics" : true
  },
  {
    "name" : "Road/Rail",
    "unCode" : "LU701000",
    "ics" : true
  },
  {
    "name" : "Accises",
    "unCode" : "LU704000",
    "ics" : true
  },
  {
    "name" : "Nord",
    "unCode" : "LU708000",
    "ics" : true
  },
  {
    "name" : "Airport",
    "unCode" : "LU715000",
    "ics" : true
  },
  {
    "name" : "ŠĶIROTAVAS MKP",
    "unCode" : "LV000207",
    "ics" : true
  },
  {
    "name" : "RĪGAS BRĪVOSTAS MKP",
    "unCode" : "LV000210",
    "ics" : true
  },
  {
    "name" : "LIDOSTAS MKP",
    "unCode" : "LV000240",
    "ics" : true
  },
  {
    "name" : "VENTSPILS OSTAS MKP",
    "unCode" : "LV000311",
    "ics" : true
  },
  {
    "name" : "LIEPĀJAS OSTAS MKP",
    "unCode" : "LV000411",
    "ics" : true
  },
  {
    "name" : "VIENTUĻU MKP",
    "unCode" : "LV000712",
    "ics" : true
  },
  {
    "name" : "GREBŅEVAS MKP",
    "unCode" : "LV000721",
    "ics" : true
  },
  {
    "name" : "TEREHOVAS MKP",
    "unCode" : "LV000722",
    "ics" : true
  },
  {
    "name" : "ZILUPES MKP",
    "unCode" : "LV000723",
    "ics" : true
  },
  {
    "name" : "KĀRSAVAS MKP",
    "unCode" : "LV000724",
    "ics" : true
  },
  {
    "name" : "PĀTERNIEKU MKP",
    "unCode" : "LV000731",
    "ics" : true
  },
  {
    "name" : "RĒZEKNES 2 MKP",
    "unCode" : "LV000742",
    "ics" : true
  },
  {
    "name" : "SILENES MKP",
    "unCode" : "LV000814",
    "ics" : true
  },
  {
    "name" : "DAUGAVPILS PREČU STACIJAS MKP",
    "unCode" : "LV000816",
    "ics" : true
  },
  {
    "name" : "INDRAS MKP",
    "unCode" : "LV000817",
    "ics" : true
  },
  {
    "name" : "VID MUITAS PĀRVALDE",
    "unCode" : "LV009999",
    "ics" : true
  },
  {
    "name" : "COSTESTI",
    "unCode" : "MD101000",
    "ics" : false
  },
  {
    "name" : "LIPCANI",
    "unCode" : "MD102000",
    "ics" : false
  },
  {
    "name" : "CRIVA 1",
    "unCode" : "MD103000",
    "ics" : false
  },
  {
    "name" : "BRICENI",
    "unCode" : "MD107000",
    "ics" : false
  },
  {
    "name" : "OCNITA 1",
    "unCode" : "MD109000",
    "ics" : false
  },
  {
    "name" : "OCNITA 2",
    "unCode" : "MD110000",
    "ics" : false
  },
  {
    "name" : "VOLCINET",
    "unCode" : "MD111000",
    "ics" : false
  },
  {
    "name" : "OTACI",
    "unCode" : "MD112000",
    "ics" : false
  },
  {
    "name" : "SOROCA",
    "unCode" : "MD115000",
    "ics" : false
  },
  {
    "name" : "SOROCA",
    "unCode" : "MD115100",
    "ics" : false
  },
  {
    "name" : "BRICENI",
    "unCode" : "MD116000",
    "ics" : false
  },
  {
    "name" : "BALTI",
    "unCode" : "MD117000",
    "ics" : false
  },
  {
    "name" : "CCZ DROCHIA, BALTI",
    "unCode" : "MD117100",
    "ics" : false
  },
  {
    "name" : "FEZ BALTI",
    "unCode" : "MD119000",
    "ics" : false
  },
  {
    "name" : "CCZ ALBINETUL VECHI",
    "unCode" : "MD119100",
    "ics" : false
  },
  {
    "name" : "MARCULESTI AIRPORT",
    "unCode" : "MD120000",
    "ics" : false
  },
  {
    "name" : "SCULENI",
    "unCode" : "MD201000",
    "ics" : false
  },
  {
    "name" : "UNGHENI",
    "unCode" : "MD202000",
    "ics" : false
  },
  {
    "name" : "ZCV UNGHENI",
    "unCode" : "MD202100",
    "ics" : false
  },
  {
    "name" : "LEUSENI",
    "unCode" : "MD203000",
    "ics" : false
  },
  {
    "name" : "PALANCA",
    "unCode" : "MD204000",
    "ics" : false
  },
  {
    "name" : "TUDORA",
    "unCode" : "MD205000",
    "ics" : false
  },
  {
    "name" : "CHISINAU 1",
    "unCode" : "MD207000",
    "ics" : false
  },
  {
    "name" : "ZCV CALEA FERATA, CHISINĂU 1",
    "unCode" : "MD207100",
    "ics" : false
  },
  {
    "name" : "CHISINAU 2",
    "unCode" : "MD208000",
    "ics" : false
  },
  {
    "name" : "ZCV IALOVENI, CHISINAU 3",
    "unCode" : "MD209100",
    "ics" : false
  },
  {
    "name" : "ZCV HINCESTI, CHISINAU 3",
    "unCode" : "MD209200",
    "ics" : false
  },
  {
    "name" : "ZCV HINCESTI 1 (UNGHENI-BUSINESS)",
    "unCode" : "MD209300",
    "ics" : false
  },
  {
    "name" : "CHISINAU4 POSTA",
    "unCode" : "MD210000",
    "ics" : false
  },
  {
    "name" : "CHISINAU RAILWAY STATION 4",
    "unCode" : "MD210100",
    "ics" : false
  },
  {
    "name" : "SUBZONA 'SUD-EST'",
    "unCode" : "MD211000",
    "ics" : false
  },
  {
    "name" : "CHISINAU Subzona 11 ZEL BALTI",
    "unCode" : "MD211100",
    "ics" : false
  },
  {
    "name" : "STRASENI (SUBZONA 4,5 ZEL BALTI)",
    "unCode" : "MD212000",
    "ics" : false
  },
  {
    "name" : "ORHEI (SUBZONA 6 ZEL BALTI)",
    "unCode" : "MD213000",
    "ics" : false
  },
  {
    "name" : "ORHEI SUBZONA 6 ZEL BALTI",
    "unCode" : "MD213100",
    "ics" : false
  },
  {
    "name" : "ZEL UNGHENI",
    "unCode" : "MD214000",
    "ics" : false
  },
  {
    "name" : "Calarasi CCZ, Ungheni FEZ",
    "unCode" : "MD214100",
    "ics" : false
  },
  {
    "name" : "CAUSENI",
    "unCode" : "MD215000",
    "ics" : false
  },
  {
    "name" : "BULBOACA",
    "unCode" : "MD217000",
    "ics" : false
  },
  {
    "name" : "BENDER 2",
    "unCode" : "MD218000",
    "ics" : false
  },
  {
    "name" : "REZINA",
    "unCode" : "MD219000",
    "ics" : false
  },
  {
    "name" : "RIBNITA",
    "unCode" : "MD220000",
    "ics" : false
  },
  {
    "name" : "REZINA POD",
    "unCode" : "MD222000",
    "ics" : false
  },
  {
    "name" : "CRIULENI (14,18)",
    "unCode" : "MD224000",
    "ics" : false
  },
  {
    "name" : "CCZ CRIULENI (Criuleni 14,18)",
    "unCode" : "MD224100",
    "ics" : false
  },
  {
    "name" : "HIRBOVAT",
    "unCode" : "MD227000",
    "ics" : false
  },
  {
    "name" : "HAGIMUS",
    "unCode" : "MD228000",
    "ics" : false
  },
  {
    "name" : "CHISINAU INTERNATIONAL AIRPORT",
    "unCode" : "MD230000",
    "ics" : false
  },
  {
    "name" : "CUCIURGAN",
    "unCode" : "MD232000",
    "ics" : false
  },
  {
    "name" : "PLATONOVO",
    "unCode" : "MD234000",
    "ics" : false
  },
  {
    "name" : "STEFAN VODA (FEZ BALTI)",
    "unCode" : "MD235000",
    "ics" : false
  },
  {
    "name" : "NOVOSAVITCAIA",
    "unCode" : "MD236000",
    "ics" : false
  },
  {
    "name" : "CAHUL",
    "unCode" : "MD301000",
    "ics" : false
  },
  {
    "name" : "GIURGIULESTI 1",
    "unCode" : "MD302000",
    "ics" : false
  },
  {
    "name" : "GIURGIULESTI 2",
    "unCode" : "MD303000",
    "ics" : false
  },
  {
    "name" : "PIL GIURGIULESTI",
    "unCode" : "MD304000",
    "ics" : false
  },
  {
    "name" : "CCZ GIURGIULESTI PIL GIURGIULESTI",
    "unCode" : "MD304100",
    "ics" : false
  },
  {
    "name" : "GIURGIULESTI PORT",
    "unCode" : "MD304200",
    "ics" : false
  },
  {
    "name" : "PIL GIURGIULESTI TRANZIT",
    "unCode" : "MD304300",
    "ics" : false
  },
  {
    "name" : "BASARABEASCA",
    "unCode" : "MD305000",
    "ics" : false
  },
  {
    "name" : "CEADIR-LUNGA 2",
    "unCode" : "MD307000",
    "ics" : false
  },
  {
    "name" : "MIRNOE",
    "unCode" : "MD308000",
    "ics" : false
  },
  {
    "name" : "VULCANESTI",
    "unCode" : "MD309000",
    "ics" : false
  },
  {
    "name" : "ETULIA",
    "unCode" : "MD310000",
    "ics" : false
  },
  {
    "name" : "CISMICHIOI",
    "unCode" : "MD311000",
    "ics" : false
  },
  {
    "name" : "CAHUL",
    "unCode" : "MD312000",
    "ics" : false
  },
  {
    "name" : "COMRAT",
    "unCode" : "MD313000",
    "ics" : false
  },
  {
    "name" : "CCZ CEADIR-LUNGA, COMRAT",
    "unCode" : "MD313100",
    "ics" : false
  },
  {
    "name" : "FAZ TARACLIA",
    "unCode" : "MD314000",
    "ics" : false
  },
  {
    "name" : "FAZ VALCANES",
    "unCode" : "MD315000",
    "ics" : false
  },
  {
    "name" : "FAZ TVARDITA",
    "unCode" : "MD316000",
    "ics" : false
  },
  {
    "name" : "CAHUL (SUBZONE No. 7 BALTI FEZ)",
    "unCode" : "MD317000",
    "ics" : false
  },
  {
    "name" : "Comrat Subzone (Vulcanesti FEZ)",
    "unCode" : "MD318000",
    "ics" : false
  },
  {
    "name" : "BASARABEASCA 1",
    "unCode" : "MD319000",
    "ics" : false
  },
  {
    "name" : "CI Terminal Podgorica",
    "unCode" : "ME035025",
    "ics" : false
  },
  {
    "name" : "CI Željeznička stanica Podgorica",
    "unCode" : "ME035037",
    "ics" : false
  },
  {
    "name" : "CI Božaj",
    "unCode" : "ME035041",
    "ics" : false
  },
  {
    "name" : "CI Danilovgrad",
    "unCode" : "ME035050",
    "ics" : false
  },
  {
    "name" : "CI Nikšić",
    "unCode" : "ME035076",
    "ics" : false
  },
  {
    "name" : "CI Cetinje",
    "unCode" : "ME035084",
    "ics" : false
  },
  {
    "name" : "CI Aerodrom Podgorica",
    "unCode" : "ME035092",
    "ics" : false
  },
  {
    "name" : "CI Pošta Podgorica",
    "unCode" : "ME035106",
    "ics" : false
  },
  {
    "name" : "CI Željeznička stanica Tuzi",
    "unCode" : "ME035149",
    "ics" : false
  },
  {
    "name" : "CI Šćepan Polje",
    "unCode" : "ME035173",
    "ics" : false
  },
  {
    "name" : "CI Vraćenovići",
    "unCode" : "ME035181",
    "ics" : false
  },
  {
    "name" : "CI Ilino Brdo",
    "unCode" : "ME035203",
    "ics" : false
  },
  {
    "name" : "CI Bar",
    "unCode" : "ME036021",
    "ics" : false
  },
  {
    "name" : "CI Slobodna zona Bar",
    "unCode" : "ME036072",
    "ics" : false
  },
  {
    "name" : "CF Budva",
    "unCode" : "ME036080",
    "ics" : false
  },
  {
    "name" : "CF Putnički terminal",
    "unCode" : "ME036094",
    "ics" : false
  },
  {
    "name" : "CI Aerodrom Tivat",
    "unCode" : "ME037010",
    "ics" : false
  },
  {
    "name" : "CI Bijela",
    "unCode" : "ME037028",
    "ics" : false
  },
  {
    "name" : "CI Zelenika",
    "unCode" : "ME037044",
    "ics" : false
  },
  {
    "name" : "CI Terminal Kotor",
    "unCode" : "ME037052",
    "ics" : false
  },
  {
    "name" : "CI Debeli Brijeg",
    "unCode" : "ME037095",
    "ics" : false
  },
  {
    "name" : "CI Luka Tivat",
    "unCode" : "ME037207",
    "ics" : false
  },
  {
    "name" : "CI Luka Kotor",
    "unCode" : "ME037255",
    "ics" : false
  },
  {
    "name" : "CF Kumbor",
    "unCode" : "ME037303",
    "ics" : false
  },
  {
    "name" : "CI Bijelo Polje",
    "unCode" : "ME038016",
    "ics" : false
  },
  {
    "name" : "CI Željeznička stanica B. Polje",
    "unCode" : "ME038059",
    "ics" : false
  },
  {
    "name" : "CI Dobrakovo",
    "unCode" : "ME038075",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Pljevlja",
    "unCode" : "ME038121",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Metaljka",
    "unCode" : "ME038156",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Ranče",
    "unCode" : "ME038164",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Berane",
    "unCode" : "ME038300",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Rožaje",
    "unCode" : "ME038334",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Kula",
    "unCode" : "ME038350",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Dračenovac",
    "unCode" : "ME038385",
    "ics" : false
  },
  {
    "name" : "Skopje 1",
    "unCode" : "MK001010",
    "ics" : false
  },
  {
    "name" : "Skopje 3",
    "unCode" : "MK001013",
    "ics" : false
  },
  {
    "name" : "Skopje 4",
    "unCode" : "MK001014",
    "ics" : false
  },
  {
    "name" : "Skopje 2",
    "unCode" : "MK001015",
    "ics" : false
  },
  {
    "name" : "Slobodna zona Bunardzik",
    "unCode" : "MK001020",
    "ics" : false
  },
  {
    "name" : "Carinska ispostava Posta",
    "unCode" : "MK001025",
    "ics" : false
  },
  {
    "name" : "CI Aerodrom Skopje stokovo",
    "unCode" : "MK001050",
    "ics" : false
  },
  {
    "name" : "CI Aerodrom Skopje Patnicki",
    "unCode" : "MK001051",
    "ics" : false
  },
  {
    "name" : "CI Blace patnicki",
    "unCode" : "MK001071",
    "ics" : false
  },
  {
    "name" : "CI Blace stokovo",
    "unCode" : "MK001075",
    "ics" : false
  },
  {
    "name" : "CI Tetovo",
    "unCode" : "MK001080",
    "ics" : false
  },
  {
    "name" : "CI Jazince",
    "unCode" : "MK001091",
    "ics" : false
  },
  {
    "name" : "CI Kumanovo",
    "unCode" : "MK002010",
    "ics" : false
  },
  {
    "name" : "CI Zeleznicka stanicaTabanovci",
    "unCode" : "MK002021",
    "ics" : false
  },
  {
    "name" : "CI Tabanovce stokovo",
    "unCode" : "MK002030",
    "ics" : false
  },
  {
    "name" : "CI Tabanovce patnicki",
    "unCode" : "MK002031",
    "ics" : false
  },
  {
    "name" : "CI Deve Bair stokovo",
    "unCode" : "MK002050",
    "ics" : false
  },
  {
    "name" : "CI Deve Bair- Patnicki",
    "unCode" : "MK002051",
    "ics" : false
  },
  {
    "name" : "CI Stip",
    "unCode" : "MK003010",
    "ics" : false
  },
  {
    "name" : "CI Delcevo stokovo",
    "unCode" : "MK003030",
    "ics" : false
  },
  {
    "name" : "CI Delcevo patnicki",
    "unCode" : "MK003031",
    "ics" : false
  },
  {
    "name" : "CI Veles",
    "unCode" : "MK003050",
    "ics" : false
  },
  {
    "name" : "CI Bogorodica patnicki",
    "unCode" : "MK004010",
    "ics" : false
  },
  {
    "name" : "CI Bogorodica stokovo",
    "unCode" : "MK004015",
    "ics" : false
  },
  {
    "name" : "CI Gevgelija",
    "unCode" : "MK004020",
    "ics" : false
  },
  {
    "name" : "CI Zeleznicka stanica Gevgelija",
    "unCode" : "MK004021",
    "ics" : false
  },
  {
    "name" : "CI Dojran",
    "unCode" : "MK004031",
    "ics" : false
  },
  {
    "name" : "CI Kavadarci",
    "unCode" : "MK004040",
    "ics" : false
  },
  {
    "name" : "CI Ctrumica",
    "unCode" : "MK004050",
    "ics" : false
  },
  {
    "name" : "CI Novo Selo stokovo",
    "unCode" : "MK004060",
    "ics" : false
  },
  {
    "name" : "CI Novo Selo patnicki",
    "unCode" : "MK004061",
    "ics" : false
  },
  {
    "name" : "CI Bitola",
    "unCode" : "MK005010",
    "ics" : false
  },
  {
    "name" : "CI Medzitlija stokovo",
    "unCode" : "MK005020",
    "ics" : false
  },
  {
    "name" : "CI Medzitlija patnicki",
    "unCode" : "MK005021",
    "ics" : false
  },
  {
    "name" : "CI Prilep",
    "unCode" : "MK005030",
    "ics" : false
  },
  {
    "name" : "CI Ohrid",
    "unCode" : "MK005040",
    "ics" : false
  },
  {
    "name" : "CI Aerodrom Ohrid",
    "unCode" : "MK005042",
    "ics" : false
  },
  {
    "name" : "CI Sveti Naum",
    "unCode" : "MK005051",
    "ics" : false
  },
  {
    "name" : "CI Struga",
    "unCode" : "MK005060",
    "ics" : false
  },
  {
    "name" : "CI Kafasan stokovo",
    "unCode" : "MK005070",
    "ics" : false
  },
  {
    "name" : "CI Kafasan patnicki",
    "unCode" : "MK005071",
    "ics" : false
  },
  {
    "name" : "CI Stenje",
    "unCode" : "MK005081",
    "ics" : false
  },
  {
    "name" : "CI Blato",
    "unCode" : "MK005091",
    "ics" : false
  },
  {
    "name" : "Airfreight",
    "unCode" : "MT000102",
    "ics" : true
  },
  {
    "name" : "Grand Harbour Seaport",
    "unCode" : "MT000103",
    "ics" : true
  },
  {
    "name" : "MIA Arrivals",
    "unCode" : "MT000104",
    "ics" : true
  },
  {
    "name" : "Deep Water Quay",
    "unCode" : "MT000107",
    "ics" : true
  },
  {
    "name" : "Laboratory Wharf",
    "unCode" : "MT000109",
    "ics" : true
  },
  {
    "name" : "Malta Freeport Main Gate",
    "unCode" : "MT000113",
    "ics" : true
  },
  {
    "name" : "Parcel Post Office - Malta",
    "unCode" : "MT000114",
    "ics" : true
  },
  {
    "name" : "Customs Express Freight Office",
    "unCode" : "MT000117",
    "ics" : true
  },
  {
    "name" : "MIA Departures",
    "unCode" : "MT000123",
    "ics" : true
  },
  {
    "name" : "Special Procedures Unit",
    "unCode" : "MT000124",
    "ics" : true
  },
  {
    "name" : "Containers & Groupage Section",
    "unCode" : "MT000600",
    "ics" : true
  },
  {
    "name" : "Koeriers simplified proc.",
    "unCode" : "NL000144",
    "ics" : true
  },
  {
    "name" : "Koeriers Normal proc.",
    "unCode" : "NL000155",
    "ics" : true
  },
  {
    "name" : "Kantoor Groningen (TIR)",
    "unCode" : "NL000184",
    "ics" : true
  },
  {
    "name" : "JFC HQ Brunssum",
    "unCode" : "NL000187",
    "ics" : true
  },
  {
    "name" : "Kantoor Venlo",
    "unCode" : "NL000205",
    "ics" : true
  },
  {
    "name" : "Schiphol Cargo",
    "unCode" : "NL000432",
    "ics" : true
  },
  {
    "name" : "Reeweg simplified proc.",
    "unCode" : "NL000510",
    "ics" : true
  },
  {
    "name" : "Reeweg normal proc.",
    "unCode" : "NL000511",
    "ics" : true
  },
  {
    "name" : "Kantoor De Lutte",
    "unCode" : "NL000851",
    "ics" : true
  },
  {
    "name" : "Kantoor Rotterdam The Hague Airport",
    "unCode" : "NL000853",
    "ics" : true
  },
  {
    "name" : "Kantoor Amsterdam",
    "unCode" : "NL000854",
    "ics" : true
  },
  {
    "name" : "Kantoor Moerdijk",
    "unCode" : "NL000855",
    "ics" : true
  },
  {
    "name" : "Tromsø GNTR",
    "unCode" : "NO321001",
    "ics" : true
  },
  {
    "name" : "Helligskogen GNTR",
    "unCode" : "NO321002",
    "ics" : true
  },
  {
    "name" : "Tromsø Lufthavn, Simpl. Proc.",
    "unCode" : "NO321003",
    "ics" : true
  },
  {
    "name" : "Hammerfest GNVF",
    "unCode" : "NO322001",
    "ics" : true
  },
  {
    "name" : "Alta, Simpl. Proc.",
    "unCode" : "NO322002",
    "ics" : true
  },
  {
    "name" : "Neiden GNNE",
    "unCode" : "NO323001",
    "ics" : true
  },
  {
    "name" : "Storskog GNST",
    "unCode" : "NO324001",
    "ics" : true
  },
  {
    "name" : "Kirkenes simpl. procedure GNST",
    "unCode" : "NO324002",
    "ics" : true
  },
  {
    "name" : "Polmak GNPO",
    "unCode" : "NO325001",
    "ics" : true
  },
  {
    "name" : "Karigasniemi tulli GDN",
    "unCode" : "NO329901",
    "ics" : true
  },
  {
    "name" : "Kivilompolo GDN",
    "unCode" : "NO329902",
    "ics" : true
  },
  {
    "name" : "Utsjok tulli GDN",
    "unCode" : "NO329903",
    "ics" : true
  },
  {
    "name" : "Bjørnfjell GMBJ",
    "unCode" : "NO331001",
    "ics" : true
  },
  {
    "name" : "Narvik Simplified proc. GMBJ",
    "unCode" : "NO331002",
    "ics" : true
  },
  {
    "name" : "Evenes, Simpl. Proc.",
    "unCode" : "NO331003",
    "ics" : true
  },
  {
    "name" : "Junkerdal GMHS",
    "unCode" : "NO332001",
    "ics" : true
  },
  {
    "name" : "Bodø GMHS",
    "unCode" : "NO332002",
    "ics" : true
  },
  {
    "name" : "Mo GMHS",
    "unCode" : "NO332003",
    "ics" : true
  },
  {
    "name" : "Bodø Lufthavn, Simpl. Proc.",
    "unCode" : "NO332004",
    "ics" : true
  },
  {
    "name" : "Værnes GDM",
    "unCode" : "NO333001",
    "ics" : true
  },
  {
    "name" : "Trondheim GDM",
    "unCode" : "NO333002",
    "ics" : true
  },
  {
    "name" : "Vauldalen GMRØ",
    "unCode" : "NO334001",
    "ics" : true
  },
  {
    "name" : "Røros Lufthavn, Simpl. Proc.",
    "unCode" : "NO334002",
    "ics" : true
  },
  {
    "name" : "Storlien tullexpedisjon GMD",
    "unCode" : "NO339901",
    "ics" : true
  },
  {
    "name" : "Tärnaby tullexpedition GMD",
    "unCode" : "NO339902",
    "ics" : true
  },
  {
    "name" : "Ålesund GVÅL",
    "unCode" : "NO341001",
    "ics" : true
  },
  {
    "name" : "Ålesund Lufthavn Vigra, Simpl. Proc",
    "unCode" : "NO341002",
    "ics" : true
  },
  {
    "name" : "Molde Lufthavn Årø, Simpl. Proc.",
    "unCode" : "NO341003",
    "ics" : true
  },
  {
    "name" : "Kristiansund Lufthavn, Simpl. Proc.",
    "unCode" : "NO341004",
    "ics" : true
  },
  {
    "name" : "Bergen GVMI Maritim innsatsseksjon",
    "unCode" : "NO342001",
    "ics" : true
  },
  {
    "name" : "Bergen Lufthavn Flesland Simp. Proc",
    "unCode" : "NO343001",
    "ics" : true
  },
  {
    "name" : "Haugesund GVHA",
    "unCode" : "NO344001",
    "ics" : true
  },
  {
    "name" : "Haugesund Lufthavn, Simpl. Proc.",
    "unCode" : "NO344002",
    "ics" : true
  },
  {
    "name" : "Tananger GVSO",
    "unCode" : "NO345001",
    "ics" : true
  },
  {
    "name" : "Stavanger Lufthavn Sola, Simpl Proc",
    "unCode" : "NO345002",
    "ics" : true
  },
  {
    "name" : "Oslo Gardermoen GDG",
    "unCode" : "NO351001",
    "ics" : true
  },
  {
    "name" : "Eggemoen flyplass, Simpl. Proc.",
    "unCode" : "NO351003",
    "ics" : true
  },
  {
    "name" : "Oslo Lufthavn, Post, Simpl. Proc.",
    "unCode" : "NO355001",
    "ics" : true
  },
  {
    "name" : "Kristiansand GDO",
    "unCode" : "NO361001",
    "ics" : true
  },
  {
    "name" : "Kristiansand lufthavn Kjevik, Simpl",
    "unCode" : "NO361002",
    "ics" : true
  },
  {
    "name" : "Grenland GDO",
    "unCode" : "NO362001",
    "ics" : true
  },
  {
    "name" : "Langesund Simpl. Proc. GDO",
    "unCode" : "NO362002",
    "ics" : true
  },
  {
    "name" : "Torp Sandefjord Lufthavn, Simpl Pro",
    "unCode" : "NO363001",
    "ics" : true
  },
  {
    "name" : "Sandefjord GDO",
    "unCode" : "NO364001",
    "ics" : true
  },
  {
    "name" : "Larvik Simpl. Proc. GDO",
    "unCode" : "NO364002",
    "ics" : true
  },
  {
    "name" : "Oslo Helsfyr Simpl. proc. GDO",
    "unCode" : "NO365001",
    "ics" : true
  },
  {
    "name" : "Oslo Utstikker 2 GDO",
    "unCode" : "NO365002",
    "ics" : true
  },
  {
    "name" : "Oslo-Hjortnes GDO",
    "unCode" : "NO365003",
    "ics" : true
  },
  {
    "name" : "Oslo ALNABRU Simpl. procedure GDO",
    "unCode" : "NO365004",
    "ics" : true
  },
  {
    "name" : "Drammen GDO",
    "unCode" : "NO368001",
    "ics" : true
  },
  {
    "name" : "Svinesund GDØ",
    "unCode" : "NO371001",
    "ics" : true
  },
  {
    "name" : "Moss Simpl. Proc. GDØ",
    "unCode" : "NO371002",
    "ics" : true
  },
  {
    "name" : "Ørje GDØ",
    "unCode" : "NO372001",
    "ics" : true
  },
  {
    "name" : "Kongsvinger GDØ",
    "unCode" : "NO373001",
    "ics" : true
  },
  {
    "name" : "Åsnes GDØ",
    "unCode" : "NO373002",
    "ics" : true
  },
  {
    "name" : "Østby GØTR",
    "unCode" : "NO374001",
    "ics" : true
  },
  {
    "name" : "Svinesund tullexpedition GDØ",
    "unCode" : "NO379901",
    "ics" : true
  },
  {
    "name" : "Hån tullexpedition GDØ",
    "unCode" : "NO379902",
    "ics" : true
  },
  {
    "name" : "Eda tullexpedition GDØ",
    "unCode" : "NO379903",
    "ics" : true
  },
  {
    "name" : "Idre tullexpedition GDØ",
    "unCode" : "NO379904",
    "ics" : true
  },
  {
    "name" : "BIAŁA PODLASKA OC",
    "unCode" : "PL301010",
    "ics" : true
  },
  {
    "name" : "MALASZEWICZE OC",
    "unCode" : "PL301020",
    "ics" : true
  },
  {
    "name" : "KOROSZCZYN OC",
    "unCode" : "PL301040",
    "ics" : true
  },
  {
    "name" : "TERESPOL OC",
    "unCode" : "PL301050",
    "ics" : true
  },
  {
    "name" : "TERESPOL OC DROGOWY",
    "unCode" : "PL301060",
    "ics" : true
  },
  {
    "name" : "SŁAWATYCZE OC",
    "unCode" : "PL301070",
    "ics" : true
  },
  {
    "name" : "DOROHUSK OC",
    "unCode" : "PL302050",
    "ics" : true
  },
  {
    "name" : "DOROHUSK OC DROGOWY",
    "unCode" : "PL302060",
    "ics" : true
  },
  {
    "name" : "OC PORT LOTNICZY LUBLIN-ŚWIDNIK",
    "unCode" : "PL302070",
    "ics" : true
  },
  {
    "name" : "Lublin OC Pocztowy",
    "unCode" : "PL302080",
    "ics" : true
  },
  {
    "name" : "HREBENNE OC",
    "unCode" : "PL303020",
    "ics" : true
  },
  {
    "name" : "HRUBIESZÓW OC",
    "unCode" : "PL303030",
    "ics" : true
  },
  {
    "name" : "ZOSIN OC",
    "unCode" : "PL303040",
    "ics" : true
  },
  {
    "name" : "DOŁHOBYCZÓW OC",
    "unCode" : "PL303091",
    "ics" : true
  },
  {
    "name" : "BIAŁYSTOK OC",
    "unCode" : "PL311010",
    "ics" : true
  },
  {
    "name" : "KUŹNICA OC KOLEJOWY",
    "unCode" : "PL311020",
    "ics" : true
  },
  {
    "name" : "KUŹNICA OC DROGOWY",
    "unCode" : "PL311030",
    "ics" : true
  },
  {
    "name" : "SIEMIANÓWKA OC",
    "unCode" : "PL311050",
    "ics" : true
  },
  {
    "name" : "POŁOWCE OC",
    "unCode" : "PL311060",
    "ics" : true
  },
  {
    "name" : "BOBROWNIKI OC",
    "unCode" : "PL311070",
    "ics" : true
  },
  {
    "name" : "GDYNIA OC BASEN V",
    "unCode" : "PL321010",
    "ics" : true
  },
  {
    "name" : "GDYNIA OC BAZA KONTENEROWA",
    "unCode" : "PL321030",
    "ics" : true
  },
  {
    "name" : "GDYNIA OC BASEN IV",
    "unCode" : "PL321050",
    "ics" : true
  },
  {
    "name" : "GDYNIA OC NABRZEŻE BUŁGARSKIE",
    "unCode" : "PL321070",
    "ics" : true
  },
  {
    "name" : "GDAŃSK OC OPŁOTKI",
    "unCode" : "PL322010",
    "ics" : true
  },
  {
    "name" : "OC PORT GDAŃSK",
    "unCode" : "PL322030",
    "ics" : true
  },
  {
    "name" : "GDAŃSK-RĘBIECHOWO OC PORT LOTNICZY",
    "unCode" : "PL322050",
    "ics" : true
  },
  {
    "name" : "GDAŃSK OC TERMINAL KONTENEROWY",
    "unCode" : "PL322080",
    "ics" : true
  },
  {
    "name" : "PRUSZCZ GDAŃSKI OC POCZTOWY",
    "unCode" : "PL322090",
    "ics" : true
  },
  {
    "name" : "TYCHY OC",
    "unCode" : "PL331020",
    "ics" : true
  },
  {
    "name" : "OC TOWAROWY PORT LOTNICZY PYRZOWICE",
    "unCode" : "PL331040",
    "ics" : true
  },
  {
    "name" : "OC OSOBOWY PORT LOTNICZY PYRZOWICE",
    "unCode" : "PL331050",
    "ics" : true
  },
  {
    "name" : "ZABRZE OC POCZTOWY",
    "unCode" : "PL332040",
    "ics" : true
  },
  {
    "name" : "CZECHOWICE-DZIEDZICE OC",
    "unCode" : "PL335010",
    "ics" : true
  },
  {
    "name" : "KIELCE OC",
    "unCode" : "PL341010",
    "ics" : true
  },
  {
    "name" : "KRAKÓW OC II",
    "unCode" : "PL351020",
    "ics" : true
  },
  {
    "name" : "KRAKÓW-BALICE OC PORT LOTNICZY",
    "unCode" : "PL351030",
    "ics" : true
  },
  {
    "name" : "ŁÓDŹ OC I",
    "unCode" : "PL361010",
    "ics" : true
  },
  {
    "name" : "LUBLINEK - OC PORT LOTNICZY",
    "unCode" : "PL362040",
    "ics" : true
  },
  {
    "name" : "OLSZTYN OC",
    "unCode" : "PL371010",
    "ics" : true
  },
  {
    "name" : "KORSZE OC",
    "unCode" : "PL371020",
    "ics" : true
  },
  {
    "name" : "BEZLEDY OC",
    "unCode" : "PL371030",
    "ics" : true
  },
  {
    "name" : "GOŁDAP OC",
    "unCode" : "PL371060",
    "ics" : true
  },
  {
    "name" : "ELBLĄG OC",
    "unCode" : "PL372010",
    "ics" : true
  },
  {
    "name" : "BRANIEWO OC",
    "unCode" : "PL372020",
    "ics" : true
  },
  {
    "name" : "GRONOWO OC",
    "unCode" : "PL372030",
    "ics" : true
  },
  {
    "name" : "GRZECHOTKI OC",
    "unCode" : "PL372050",
    "ics" : true
  },
  {
    "name" : "OPOLE OC",
    "unCode" : "PL381010",
    "ics" : true
  },
  {
    "name" : "POZNAŃ OC",
    "unCode" : "PL391010",
    "ics" : true
  },
  {
    "name" : "POZNAŃ OC MTP",
    "unCode" : "PL391020",
    "ics" : true
  },
  {
    "name" : "POZNAŃ-ŁAWICA OC PORT LOTNICZY",
    "unCode" : "PL391030",
    "ics" : true
  },
  {
    "name" : "KALISZ OC",
    "unCode" : "PL394010",
    "ics" : true
  },
  {
    "name" : "PRZEMYŚL OC",
    "unCode" : "PL401010",
    "ics" : true
  },
  {
    "name" : "MEDYKA OC",
    "unCode" : "PL401030",
    "ics" : true
  },
  {
    "name" : "PRZEMYŚL-MEDYKA OC KOLEJOWY",
    "unCode" : "PL401040",
    "ics" : true
  },
  {
    "name" : "KORCZOWA OC",
    "unCode" : "PL401060",
    "ics" : true
  },
  {
    "name" : "BUDOMIERZ OC",
    "unCode" : "PL401080",
    "ics" : true
  },
  {
    "name" : "PRZEMYŚL OC POCZTOWY",
    "unCode" : "PL401090",
    "ics" : true
  },
  {
    "name" : "RZESZÓW OC",
    "unCode" : "PL402010",
    "ics" : true
  },
  {
    "name" : "RZESZÓW-JASIONKA OC PORT LOTNICZY",
    "unCode" : "PL402020",
    "ics" : true
  },
  {
    "name" : "KROŚCIENKO OC",
    "unCode" : "PL404030",
    "ics" : true
  },
  {
    "name" : "ŚWIECKO OC",
    "unCode" : "PL412020",
    "ics" : true
  },
  {
    "name" : "SZCZECIN OC",
    "unCode" : "PL421010",
    "ics" : true
  },
  {
    "name" : "SZCZECIN OC NABRZEŻE ŁASZTOWNIA",
    "unCode" : "PL421030",
    "ics" : true
  },
  {
    "name" : "SZCZECIN-GOLENIÓW OC PORT LOTNICZY",
    "unCode" : "PL421050",
    "ics" : true
  },
  {
    "name" : "SWINOUJŚCIE OC",
    "unCode" : "PL421080",
    "ics" : true
  },
  {
    "name" : "KOŁOBRZEG OC",
    "unCode" : "PL422020",
    "ics" : true
  },
  {
    "name" : "BYDGOSZCZ OC II",
    "unCode" : "PL431020",
    "ics" : true
  },
  {
    "name" : "OC Port Lotniczy Bydgoszcz",
    "unCode" : "PL431040",
    "ics" : true
  },
  {
    "name" : "WARSZAWA OC I POCZTOWY",
    "unCode" : "PL441010",
    "ics" : true
  },
  {
    "name" : "WARSZAWA OC VI",
    "unCode" : "PL442020",
    "ics" : true
  },
  {
    "name" : "WARSZAWA OC OSOBOWY",
    "unCode" : "PL443010",
    "ics" : true
  },
  {
    "name" : "WARSZAWA OC TOWAROWY I",
    "unCode" : "PL443020",
    "ics" : true
  },
  {
    "name" : "WARSZAWA OC PORT LOTNICZY MODLIN",
    "unCode" : "PL443050",
    "ics" : true
  },
  {
    "name" : "PRUSZKÓW OC I",
    "unCode" : "PL445010",
    "ics" : true
  },
  {
    "name" : "WROCŁAW OC I",
    "unCode" : "PL451010",
    "ics" : true
  },
  {
    "name" : "WROCŁAW-STRACHOWICE OC TOWAROWY",
    "unCode" : "PL451030",
    "ics" : true
  },
  {
    "name" : "WROCŁAW-STRACHOWICE OC OSOBOWY",
    "unCode" : "PL451040",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira Aeroporto Faro",
    "unCode" : "PT000005",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro Aeroporto de Beja",
    "unCode" : "PT000006",
    "ics" : true
  },
  {
    "name" : "Delegação Adu. Aeroporto da Madeira",
    "unCode" : "PT000010",
    "ics" : true
  },
  {
    "name" : "Alfândega do Aeroporto de Lisboa",
    "unCode" : "PT000015",
    "ics" : true
  },
  {
    "name" : "Alfândega do Aeroporto do Porto",
    "unCode" : "PT000020",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira de Porto Santo",
    "unCode" : "PT000025",
    "ics" : true
  },
  {
    "name" : "Delegação Ad. Aeroporto Santa Maria",
    "unCode" : "PT000030",
    "ics" : true
  },
  {
    "name" : "Alfândega Marítima de Lisboa",
    "unCode" : "PT000040",
    "ics" : true
  },
  {
    "name" : "Alfândega do Funchal",
    "unCode" : "PT000070",
    "ics" : true
  },
  {
    "name" : "Alfândega de Ponta Delgada",
    "unCode" : "PT000080",
    "ics" : true
  },
  {
    "name" : "Alfândega de Alverca",
    "unCode" : "PT000088",
    "ics" : true
  },
  {
    "name" : "Delegação Adua. Angra do Heroísmo",
    "unCode" : "PT000095",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro da Bobadela",
    "unCode" : "PT000098",
    "ics" : true
  },
  {
    "name" : "Alfândega de Aveiro",
    "unCode" : "PT000115",
    "ics" : true
  },
  {
    "name" : "Alfândega de Braga",
    "unCode" : "PT000164",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira de Bragança",
    "unCode" : "PT000167",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira de Elvas",
    "unCode" : "PT000170",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira da Covilhã",
    "unCode" : "PT000227",
    "ics" : true
  },
  {
    "name" : "Alfândega de Faro",
    "unCode" : "PT000265",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira Figueira da Foz",
    "unCode" : "PT000275",
    "ics" : true
  },
  {
    "name" : "Alfândega do Freixieiro",
    "unCode" : "PT000284",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira da Horta",
    "unCode" : "PT000295",
    "ics" : true
  },
  {
    "name" : "Alfândega do Jardim do Tabaco",
    "unCode" : "PT000305",
    "ics" : true
  },
  {
    "name" : "Alfândega de Leixões",
    "unCode" : "PT000340",
    "ics" : true
  },
  {
    "name" : "Alfândega de Peniche",
    "unCode" : "PT000455",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira Peso da Régua",
    "unCode" : "PT000459",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro de Riachos",
    "unCode" : "PT000461",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira de Portimão",
    "unCode" : "PT000500",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro Praia da Graciosa",
    "unCode" : "PT000510",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro Lajes das Flores",
    "unCode" : "PT000574",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro S. Roque do Pico",
    "unCode" : "PT000650",
    "ics" : true
  },
  {
    "name" : "Alfândega de Setúbal",
    "unCode" : "PT000665",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira de Sines",
    "unCode" : "PT000670",
    "ics" : true
  },
  {
    "name" : "Posto Aduaneiro Velas de S. Jorge",
    "unCode" : "PT000745",
    "ics" : true
  },
  {
    "name" : "Alfândega de Viana do Castelo",
    "unCode" : "PT000750",
    "ics" : true
  },
  {
    "name" : "Delegação Aduaneira Vilar Formoso",
    "unCode" : "PT000830",
    "ics" : true
  },
  {
    "name" : "Delegação Ad. Zona Franca Madeira",
    "unCode" : "PT000855",
    "ics" : true
  },
  {
    "name" : "OTOPENI CALATORI",
    "unCode" : "ROBU1030",
    "ics" : true
  },
  {
    "name" : "BANEASA",
    "unCode" : "ROBU1040",
    "ics" : true
  },
  {
    "name" : "ILFOV",
    "unCode" : "ROBU1200",
    "ics" : true
  },
  {
    "name" : "BUCURESTI POSTA",
    "unCode" : "ROBU1380",
    "ics" : true
  },
  {
    "name" : "BUCURESTI",
    "unCode" : "ROBU1400",
    "ics" : true
  },
  {
    "name" : "GIURGIU",
    "unCode" : "ROBU3910",
    "ics" : true
  },
  {
    "name" : "ZONA LIBERA GIURGIU",
    "unCode" : "ROBU3980",
    "ics" : true
  },
  {
    "name" : "PRAHOVA",
    "unCode" : "ROBU7100",
    "ics" : true
  },
  {
    "name" : "DAMBOVITA",
    "unCode" : "ROBU8600",
    "ics" : true
  },
  {
    "name" : "ALBA IULIA",
    "unCode" : "ROBV0300",
    "ics" : true
  },
  {
    "name" : "BRASOV",
    "unCode" : "ROBV0900",
    "ics" : true
  },
  {
    "name" : "BRASOV AEROPORT",
    "unCode" : "ROBV0910",
    "ics" : true
  },
  {
    "name" : "HARGHITA",
    "unCode" : "ROBV5600",
    "ics" : true
  },
  {
    "name" : "COVASNA",
    "unCode" : "ROBV7820",
    "ics" : true
  },
  {
    "name" : "SIBIU",
    "unCode" : "ROBV7900",
    "ics" : true
  },
  {
    "name" : "SIBIU AEROPORT",
    "unCode" : "ROBV7910",
    "ics" : true
  },
  {
    "name" : "MURES",
    "unCode" : "ROBV8800",
    "ics" : true
  },
  {
    "name" : "TARGU-MURES AEROPORT",
    "unCode" : "ROBV8820",
    "ics" : true
  },
  {
    "name" : "BISTRITA NASAUD",
    "unCode" : "ROCJ0400",
    "ics" : true
  },
  {
    "name" : "MARAMURES",
    "unCode" : "ROCJ0500",
    "ics" : true
  },
  {
    "name" : "CLUJ",
    "unCode" : "ROCJ1800",
    "ics" : true
  },
  {
    "name" : "CLUJ NAPOCA AEROPORT",
    "unCode" : "ROCJ1810",
    "ics" : true
  },
  {
    "name" : "HALMEU",
    "unCode" : "ROCJ4310",
    "ics" : true
  },
  {
    "name" : "BIHOR",
    "unCode" : "ROCJ6570",
    "ics" : true
  },
  {
    "name" : "ORADEA AEROPORT",
    "unCode" : "ROCJ6580",
    "ics" : true
  },
  {
    "name" : "SATU MARE",
    "unCode" : "ROCJ7810",
    "ics" : true
  },
  {
    "name" : "SIGHET",
    "unCode" : "ROCJ8000",
    "ics" : true
  },
  {
    "name" : "SALAJ",
    "unCode" : "ROCJ9700",
    "ics" : true
  },
  {
    "name" : "TELEORMAN",
    "unCode" : "ROCR0310",
    "ics" : true
  },
  {
    "name" : "DOLJ",
    "unCode" : "ROCR2100",
    "ics" : true
  },
  {
    "name" : "CRAIOVA AEROPORT",
    "unCode" : "ROCR2110",
    "ics" : true
  },
  {
    "name" : "ARGES",
    "unCode" : "ROCR7000",
    "ics" : true
  },
  {
    "name" : "PORTILE DE FIER II",
    "unCode" : "ROCR7200",
    "ics" : true
  },
  {
    "name" : "PORTILE DE FIER I",
    "unCode" : "ROCR7270",
    "ics" : true
  },
  {
    "name" : "ORSOVA",
    "unCode" : "ROCR7280",
    "ics" : true
  },
  {
    "name" : "RAMNICU VALCEA",
    "unCode" : "ROCR7700",
    "ics" : true
  },
  {
    "name" : "OLT",
    "unCode" : "ROCR8210",
    "ics" : true
  },
  {
    "name" : "GORJ",
    "unCode" : "ROCR8810",
    "ics" : true
  },
  {
    "name" : "MEHEDINTI",
    "unCode" : "ROCR9000",
    "ics" : true
  },
  {
    "name" : "CALARASI",
    "unCode" : "ROCT1710",
    "ics" : true
  },
  {
    "name" : "CONSTANTA SUD",
    "unCode" : "ROCT1900",
    "ics" : true
  },
  {
    "name" : "CONSTANTA",
    "unCode" : "ROCT1970",
    "ics" : true
  },
  {
    "name" : "MIHAIL KOGALNICEANU",
    "unCode" : "ROCT5100",
    "ics" : true
  },
  {
    "name" : "MANGALIA",
    "unCode" : "ROCT5400",
    "ics" : true
  },
  {
    "name" : "IALOMITA",
    "unCode" : "ROCT8220",
    "ics" : true
  },
  {
    "name" : "SULINA",
    "unCode" : "ROCT8300",
    "ics" : true
  },
  {
    "name" : "BRAILA",
    "unCode" : "ROGL0700",
    "ics" : true
  },
  {
    "name" : "BUZAU",
    "unCode" : "ROGL1500",
    "ics" : true
  },
  {
    "name" : "VRANCEA",
    "unCode" : "ROGL3600",
    "ics" : true
  },
  {
    "name" : "OANCEA",
    "unCode" : "ROGL3610",
    "ics" : true
  },
  {
    "name" : "GALATI",
    "unCode" : "ROGL3800",
    "ics" : true
  },
  {
    "name" : "GALATI ZONA LIBERA",
    "unCode" : "ROGL3810",
    "ics" : true
  },
  {
    "name" : "GALATI-GIURGIULESTI",
    "unCode" : "ROGL3850",
    "ics" : true
  },
  {
    "name" : "TULCEA",
    "unCode" : "ROGL8900",
    "ics" : true
  },
  {
    "name" : "ISACCEA",
    "unCode" : "ROGL8920",
    "ics" : true
  },
  {
    "name" : "ALBITA",
    "unCode" : "ROIS0100",
    "ics" : true
  },
  {
    "name" : "BACAU",
    "unCode" : "ROIS0600",
    "ics" : true
  },
  {
    "name" : "BACAU AEROPORT",
    "unCode" : "ROIS0620",
    "ics" : true
  },
  {
    "name" : "BOTOSANI",
    "unCode" : "ROIS1600",
    "ics" : true
  },
  {
    "name" : "STANCA COSTESTI",
    "unCode" : "ROIS1610",
    "ics" : true
  },
  {
    "name" : "RADAUTI PRUT",
    "unCode" : "ROIS1620",
    "ics" : true
  },
  {
    "name" : "RACOVAT",
    "unCode" : "ROIS1630",
    "ics" : true
  },
  {
    "name" : "DORNESTI",
    "unCode" : "ROIS2700",
    "ics" : true
  },
  {
    "name" : "FĂLCIU",
    "unCode" : "ROIS4600",
    "ics" : true
  },
  {
    "name" : "IASI",
    "unCode" : "ROIS4650",
    "ics" : true
  },
  {
    "name" : "IASI AEROPORT",
    "unCode" : "ROIS4660",
    "ics" : true
  },
  {
    "name" : "SCULENI",
    "unCode" : "ROIS4990",
    "ics" : true
  },
  {
    "name" : "PIATRA NEAMT",
    "unCode" : "ROIS7400",
    "ics" : true
  },
  {
    "name" : "SIRET",
    "unCode" : "ROIS8200",
    "ics" : true
  },
  {
    "name" : "SUCEAVA",
    "unCode" : "ROIS8230",
    "ics" : true
  },
  {
    "name" : "SUCEAVA AEROPORT",
    "unCode" : "ROIS8250",
    "ics" : true
  },
  {
    "name" : "VASLUI",
    "unCode" : "ROIS9610",
    "ics" : true
  },
  {
    "name" : "VICOVU DE SUS",
    "unCode" : "ROIS9620",
    "ics" : true
  },
  {
    "name" : "ARAD",
    "unCode" : "ROTM0200",
    "ics" : true
  },
  {
    "name" : "JIMBOLIA",
    "unCode" : "ROTM5010",
    "ics" : true
  },
  {
    "name" : "MORAVITA",
    "unCode" : "ROTM5510",
    "ics" : true
  },
  {
    "name" : "NAIDAS",
    "unCode" : "ROTM6100",
    "ics" : true
  },
  {
    "name" : "CARAS-SEVERIN",
    "unCode" : "ROTM7600",
    "ics" : true
  },
  {
    "name" : "HUNEDOARA",
    "unCode" : "ROTM8100",
    "ics" : true
  },
  {
    "name" : "TIMIS",
    "unCode" : "ROTM8720",
    "ics" : true
  },
  {
    "name" : "TIMISOARA AEROPORT",
    "unCode" : "ROTM8730",
    "ics" : true
  },
  {
    "name" : "CI LUKA BEOGRAD",
    "unCode" : "RS011029",
    "ics" : false
  },
  {
    "name" : "CI PANČEVO",
    "unCode" : "RS011037",
    "ics" : false
  },
  {
    "name" : "CI POŠTA BEOGRAD",
    "unCode" : "RS011045",
    "ics" : false
  },
  {
    "name" : "CI RANŽIRNA ŽEL.STANICA MAKIŠ-BEOG",
    "unCode" : "RS011096",
    "ics" : false
  },
  {
    "name" : "CI OSTRUŽNICA",
    "unCode" : "RS011118",
    "ics" : false
  },
  {
    "name" : "CI TERMINAL II",
    "unCode" : "RS011126",
    "ics" : false
  },
  {
    "name" : "CI SKLADIŠTA",
    "unCode" : "RS011134",
    "ics" : false
  },
  {
    "name" : "CI ZA POSLOVE CAR. NADZORA-BEOGRAD",
    "unCode" : "RS011207",
    "ics" : false
  },
  {
    "name" : "CR SAVSKO PRISTANIŠTE",
    "unCode" : "RS011240",
    "ics" : false
  },
  {
    "name" : "CI AERODROM NIKOLA TESLA",
    "unCode" : "RS011274",
    "ics" : false
  },
  {
    "name" : "CI ZA KURIRSKE POŠILJKE-DHL",
    "unCode" : "RS011282",
    "ics" : false
  },
  {
    "name" : "CI BEOGRAD",
    "unCode" : "RS011347",
    "ics" : false
  },
  {
    "name" : "CI AERODROM BEOGRAD",
    "unCode" : "RS011410",
    "ics" : false
  },
  {
    "name" : "CI TERMINAL BEOGRAD",
    "unCode" : "RS011568",
    "ics" : false
  },
  {
    "name" : "CR INTERMODALNI TERMINAL",
    "unCode" : "RS011754",
    "ics" : false
  },
  {
    "name" : "CI MOKRANJE",
    "unCode" : "RS012033",
    "ics" : false
  },
  {
    "name" : "CI PRAHOVO",
    "unCode" : "RS012041",
    "ics" : false
  },
  {
    "name" : "CI VELIKO GRADIŠTE",
    "unCode" : "RS012068",
    "ics" : false
  },
  {
    "name" : "CR ĐERDAP 2",
    "unCode" : "RS012084",
    "ics" : false
  },
  {
    "name" : "CR MAJDANPEK",
    "unCode" : "RS012092",
    "ics" : false
  },
  {
    "name" : "CI ĐERDAP",
    "unCode" : "RS012289",
    "ics" : false
  },
  {
    "name" : "CR BOR",
    "unCode" : "RS012297",
    "ics" : false
  },
  {
    "name" : "CI VRŠKA ČUKA",
    "unCode" : "RS012319",
    "ics" : false
  },
  {
    "name" : "CR ZAJEČAR",
    "unCode" : "RS012327",
    "ics" : false
  },
  {
    "name" : "CARINSKI REFERAT DONJI MILANOVAC",
    "unCode" : "RS012343",
    "ics" : false
  },
  {
    "name" : "CI TERMINAL GRADINA",
    "unCode" : "RS013013",
    "ics" : false
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA DIMITROVGRAD",
    "unCode" : "RS013021",
    "ics" : false
  },
  {
    "name" : "CI SLOBODNA ZONA PIROT",
    "unCode" : "RS013030",
    "ics" : false
  },
  {
    "name" : "CR PIROT",
    "unCode" : "RS013048",
    "ics" : false
  },
  {
    "name" : "CI GRADINA",
    "unCode" : "RS013277",
    "ics" : false
  },
  {
    "name" : "CR RAŠKA",
    "unCode" : "RS014010",
    "ics" : false
  },
  {
    "name" : "CI KRALJEVO",
    "unCode" : "RS014052",
    "ics" : false
  },
  {
    "name" : "CI ČAČAK",
    "unCode" : "RS014060",
    "ics" : false
  },
  {
    "name" : "CI NOVI PAZAR",
    "unCode" : "RS014109",
    "ics" : false
  },
  {
    "name" : "CI GORNJI MILANOVAC",
    "unCode" : "RS014176",
    "ics" : false
  },
  {
    "name" : "CP RUDNICA",
    "unCode" : "RS014320",
    "ics" : false
  },
  {
    "name" : "CI ŠPILJANI",
    "unCode" : "RS014338",
    "ics" : false
  },
  {
    "name" : "CP BRNJAČKI MOST",
    "unCode" : "RS014346",
    "ics" : false
  },
  {
    "name" : "CR TUTIN",
    "unCode" : "RS014460",
    "ics" : false
  },
  {
    "name" : "CI LESKOVAC",
    "unCode" : "RS015024",
    "ics" : false
  },
  {
    "name" : "CR RIBARCI",
    "unCode" : "RS015032",
    "ics" : false
  },
  {
    "name" : "CR STREZIMIROVCI",
    "unCode" : "RS015040",
    "ics" : false
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA NIŠ",
    "unCode" : "RS015075",
    "ics" : false
  },
  {
    "name" : "CR POŠTA NIŠ",
    "unCode" : "RS015083",
    "ics" : false
  },
  {
    "name" : "CR KNJAŽEVAC",
    "unCode" : "RS015113",
    "ics" : false
  },
  {
    "name" : "CI VRANJE",
    "unCode" : "RS015121",
    "ics" : false
  },
  {
    "name" : "CI TERMINAL NIŠ",
    "unCode" : "RS015156",
    "ics" : false
  },
  {
    "name" : "CI PREŠEVO",
    "unCode" : "RS015172",
    "ics" : false
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA RISTOVAC",
    "unCode" : "RS015288",
    "ics" : false
  },
  {
    "name" : "CI PROKUPLJE",
    "unCode" : "RS015407",
    "ics" : false
  },
  {
    "name" : "CR DUVANSKA NIŠ",
    "unCode" : "RS015423",
    "ics" : false
  },
  {
    "name" : "CR AERODROM KONSTANTIN VELIKI",
    "unCode" : "RS015431",
    "ics" : false
  },
  {
    "name" : "CI KRAGUJEVAC",
    "unCode" : "RS017019",
    "ics" : false
  },
  {
    "name" : "CR JAGODINA",
    "unCode" : "RS017027",
    "ics" : false
  },
  {
    "name" : "CR SMEDEREVSKA PALANKA",
    "unCode" : "RS017035",
    "ics" : false
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA KRAGUJEVAC",
    "unCode" : "RS017043",
    "ics" : false
  },
  {
    "name" : "CR LAPOVO",
    "unCode" : "RS017078",
    "ics" : false
  },
  {
    "name" : "CARINSKI REFERAT VELIKA PLANA",
    "unCode" : "RS017094",
    "ics" : false
  },
  {
    "name" : "CARINSKI REFERAT SVILAJNAC",
    "unCode" : "RS017108",
    "ics" : false
  },
  {
    "name" : "CR ARANĐELOVAC",
    "unCode" : "RS017256",
    "ics" : false
  },
  {
    "name" : "CR MLADENOVAC",
    "unCode" : "RS017329",
    "ics" : false
  },
  {
    "name" : "CR POŽAREVAC",
    "unCode" : "RS017337",
    "ics" : false
  },
  {
    "name" : "CI SMEDEREVO",
    "unCode" : "RS017345",
    "ics" : false
  },
  {
    "name" : "CR ŽELEZARA SMEDEREVO",
    "unCode" : "RS017353",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA KRAGUJEVAC",
    "unCode" : "RS017370",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA SMEDEREVO",
    "unCode" : "RS017388",
    "ics" : false
  },
  {
    "name" : "CI LUKA I SKLADIŠTA NOVI SAD",
    "unCode" : "RS021016",
    "ics" : false
  },
  {
    "name" : "CI BAČKA PALANKA",
    "unCode" : "RS021024",
    "ics" : false
  },
  {
    "name" : "CR VRBAS",
    "unCode" : "RS021040",
    "ics" : false
  },
  {
    "name" : "CR POŠTA NOVI SAD",
    "unCode" : "RS021059",
    "ics" : false
  },
  {
    "name" : "CI RANŽIRNA ŽELEZ. STANICA NOVI SAD",
    "unCode" : "RS021067",
    "ics" : false
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA ŠID",
    "unCode" : "RS021083",
    "ics" : false
  },
  {
    "name" : "CI BATROVCI",
    "unCode" : "RS021091",
    "ics" : false
  },
  {
    "name" : "CI MOST BAČKA PALANKA",
    "unCode" : "RS021105",
    "ics" : false
  },
  {
    "name" : "CR NEŠTIN",
    "unCode" : "RS021156",
    "ics" : false
  },
  {
    "name" : "CR ZA POSLOVE CAR. NADZORA NOVI SAD",
    "unCode" : "RS021202",
    "ics" : false
  },
  {
    "name" : "CR SOT",
    "unCode" : "RS021270",
    "ics" : false
  },
  {
    "name" : "CR LJUBA",
    "unCode" : "RS021300",
    "ics" : false
  },
  {
    "name" : "CI ŠID",
    "unCode" : "RS021342",
    "ics" : false
  },
  {
    "name" : "CR BEČEJ",
    "unCode" : "RS021369",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA NOVI SAD",
    "unCode" : "RS021377",
    "ics" : false
  },
  {
    "name" : "CARINSKI REFERAT INĐIJA",
    "unCode" : "RS021385",
    "ics" : false
  },
  {
    "name" : "CR ZA REČNI SAOBRAĆAJ NOVI SAD",
    "unCode" : "RS021440",
    "ics" : false
  },
  {
    "name" : "CR NOVI SAD",
    "unCode" : "RS021458",
    "ics" : false
  },
  {
    "name" : "CR APATIN",
    "unCode" : "RS022012",
    "ics" : false
  },
  {
    "name" : "CI BAČKI BREG",
    "unCode" : "RS022020",
    "ics" : false
  },
  {
    "name" : "CI BEZDAN-MOHAČ",
    "unCode" : "RS022039",
    "ics" : false
  },
  {
    "name" : "CR SOMBOR",
    "unCode" : "RS022047",
    "ics" : false
  },
  {
    "name" : "CI BOGOJEVO",
    "unCode" : "RS022128",
    "ics" : false
  },
  {
    "name" : "CR BEZDAN",
    "unCode" : "RS022144",
    "ics" : false
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA BOGOJEVO",
    "unCode" : "RS022292",
    "ics" : false
  },
  {
    "name" : "CI KALUĐEROVO",
    "unCode" : "RS023019",
    "ics" : false
  },
  {
    "name" : "CI VATIN",
    "unCode" : "RS023027",
    "ics" : false
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA VRŠAC",
    "unCode" : "RS023035",
    "ics" : false
  },
  {
    "name" : "CI HEMOFARM",
    "unCode" : "RS023043",
    "ics" : false
  },
  {
    "name" : "CI KIKINDA",
    "unCode" : "RS024015",
    "ics" : false
  },
  {
    "name" : "CI ZRENJANIN",
    "unCode" : "RS024023",
    "ics" : false
  },
  {
    "name" : "CI SRPSKA CRNJA",
    "unCode" : "RS024031",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA ZRENJANIN",
    "unCode" : "RS024287",
    "ics" : false
  },
  {
    "name" : "CI TERMINAL HORGOŠ",
    "unCode" : "RS025011",
    "ics" : false
  },
  {
    "name" : "JAVNA SKLADIŠTA SUBOTICA",
    "unCode" : "RS025038",
    "ics" : false
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA SUBOTICA",
    "unCode" : "RS025046",
    "ics" : false
  },
  {
    "name" : "CI TERMINAL KELEBIJA",
    "unCode" : "RS025054",
    "ics" : false
  },
  {
    "name" : "CI SENTA",
    "unCode" : "RS025062",
    "ics" : false
  },
  {
    "name" : "CI HORGOŠ",
    "unCode" : "RS025151",
    "ics" : false
  },
  {
    "name" : "CI SLOBODNA ZONA SUBOTICA",
    "unCode" : "RS025160",
    "ics" : false
  },
  {
    "name" : "CI KELEBIJA",
    "unCode" : "RS025267",
    "ics" : false
  },
  {
    "name" : "CP MERDARE",
    "unCode" : "RS031305",
    "ics" : false
  },
  {
    "name" : "CP DEPCE",
    "unCode" : "RS031321",
    "ics" : false
  },
  {
    "name" : "CP KONČULJ",
    "unCode" : "RS031330",
    "ics" : false
  },
  {
    "name" : "CI ŠABAC",
    "unCode" : "RS042056",
    "ics" : false
  },
  {
    "name" : "CI SREMSKA MITROVICA",
    "unCode" : "RS042072",
    "ics" : false
  },
  {
    "name" : "CI SREMSKA RAČA",
    "unCode" : "RS042102",
    "ics" : false
  },
  {
    "name" : "CI VALJEVO",
    "unCode" : "RS042145",
    "ics" : false
  },
  {
    "name" : "CI MALI ZVORNIK",
    "unCode" : "RS042153",
    "ics" : false
  },
  {
    "name" : "CI BADOVINCI",
    "unCode" : "RS042188",
    "ics" : false
  },
  {
    "name" : "CI TRBUŠNICA",
    "unCode" : "RS042196",
    "ics" : false
  },
  {
    "name" : "CI LJUBOVIJA",
    "unCode" : "RS042200",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA ŠABAC",
    "unCode" : "RS042277",
    "ics" : false
  },
  {
    "name" : "CI KRUŠEVAC",
    "unCode" : "RS045047",
    "ics" : false
  },
  {
    "name" : "CR PARAĆIN",
    "unCode" : "RS045055",
    "ics" : false
  },
  {
    "name" : "CR TRSTENIK",
    "unCode" : "RS045063",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA KRUŠEVAC",
    "unCode" : "RS045110",
    "ics" : false
  },
  {
    "name" : "CI UŽICE",
    "unCode" : "RS046027",
    "ics" : false
  },
  {
    "name" : "CR POŽEGA",
    "unCode" : "RS046035",
    "ics" : false
  },
  {
    "name" : "CI PRIJEPOLJE",
    "unCode" : "RS046043",
    "ics" : false
  },
  {
    "name" : "CR JABUKA",
    "unCode" : "RS046051",
    "ics" : false
  },
  {
    "name" : "CR ŽELEZ. STAN. PRIJEPOLJE KOLOVRAT",
    "unCode" : "RS046060",
    "ics" : false
  },
  {
    "name" : "CI GOSTUN",
    "unCode" : "RS046078",
    "ics" : false
  },
  {
    "name" : "CR BAJINA BAŠTA",
    "unCode" : "RS046086",
    "ics" : false
  },
  {
    "name" : "CI KOTROMAN",
    "unCode" : "RS046094",
    "ics" : false
  },
  {
    "name" : "CI UVAC",
    "unCode" : "RS046108",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA UŽICE",
    "unCode" : "RS046124",
    "ics" : false
  },
  {
    "name" : "CR SLOBODNA ZONA PRIBOJ",
    "unCode" : "RS046159",
    "ics" : false
  },
  {
    "name" : "MALMÖ TULLVERKET",
    "unCode" : "SE000050",
    "ics" : true
  },
  {
    "name" : "HAPARANDA",
    "unCode" : "SE001033",
    "ics" : true
  },
  {
    "name" : "ARLANDA TULLVERKET",
    "unCode" : "SE003033",
    "ics" : true
  },
  {
    "name" : "NORRKÖPING TULLVERKET",
    "unCode" : "SE004134",
    "ics" : true
  },
  {
    "name" : "TÄRNABY TULLVERKET",
    "unCode" : "SE010332",
    "ics" : true
  },
  {
    "name" : "BJÖRNFJELL TOLLSTED",
    "unCode" : "SE010333",
    "ics" : true
  },
  {
    "name" : "JUNKERDAL TOLLSTED",
    "unCode" : "SE010334",
    "ics" : true
  },
  {
    "name" : "STORLIEN TULLVERKET",
    "unCode" : "SE020342",
    "ics" : true
  },
  {
    "name" : "VAULDALEN TOLLSTED",
    "unCode" : "SE020344",
    "ics" : true
  },
  {
    "name" : "IDRE",
    "unCode" : "SE020423",
    "ics" : true
  },
  {
    "name" : "HÅN TULLVERKET",
    "unCode" : "SE060335",
    "ics" : true
  },
  {
    "name" : "SVINESUND TOLLSTED",
    "unCode" : "SE060340",
    "ics" : true
  },
  {
    "name" : "ÖRJE TOLLSTED",
    "unCode" : "SE060341",
    "ics" : true
  },
  {
    "name" : "STOCKHOLM TULLVERKET",
    "unCode" : "SE303400",
    "ics" : true
  },
  {
    "name" : "GÖTEBORG TULLVERKET",
    "unCode" : "SE603303",
    "ics" : true
  },
  {
    "name" : "Tullverket Svinesund",
    "unCode" : "SE603340",
    "ics" : true
  },
  {
    "name" : "STRÖMSTAD TULLVERKET",
    "unCode" : "SE603342",
    "ics" : true
  },
  {
    "name" : "EDA TULLVERKET",
    "unCode" : "SE603360",
    "ics" : true
  },
  {
    "name" : "ÖSTBY TOLLSTED",
    "unCode" : "SE603362",
    "ics" : true
  },
  {
    "name" : "ÅSNES TOLLSTED",
    "unCode" : "SE603363",
    "ics" : true
  },
  {
    "name" : "KRANJ",
    "unCode" : "SI001026",
    "ics" : true
  },
  {
    "name" : "LETALIŠČE BRNIK",
    "unCode" : "SI001034",
    "ics" : true
  },
  {
    "name" : "POŠTNIH POŠILJK",
    "unCode" : "SI001042",
    "ics" : true
  },
  {
    "name" : "NOVO MESTO",
    "unCode" : "SI001050",
    "ics" : true
  },
  {
    "name" : "METLIKA",
    "unCode" : "SI001115",
    "ics" : true
  },
  {
    "name" : "OBREŽJE",
    "unCode" : "SI001123",
    "ics" : true
  },
  {
    "name" : "LJUBLJANA",
    "unCode" : "SI001913",
    "ics" : true
  },
  {
    "name" : "CELJE",
    "unCode" : "SI002022",
    "ics" : true
  },
  {
    "name" : "DRAVOGRAD",
    "unCode" : "SI003053",
    "ics" : true
  },
  {
    "name" : "MURSKA SOBOTA",
    "unCode" : "SI004017",
    "ics" : true
  },
  {
    "name" : "JESENICE",
    "unCode" : "SI005080",
    "ics" : true
  },
  {
    "name" : "KOPER",
    "unCode" : "SI006036",
    "ics" : true
  },
  {
    "name" : "LUKA KOPER",
    "unCode" : "SI006044",
    "ics" : true
  },
  {
    "name" : "OBMORSKI MEJNI PREHOD PIRAN",
    "unCode" : "SI006090",
    "ics" : true
  },
  {
    "name" : "MEJNI PREHOD LETALIŠČE PORTOROŽ",
    "unCode" : "SI006170",
    "ics" : true
  },
  {
    "name" : "MEJNI PREHOD LETALIŠČE MARIBOR",
    "unCode" : "SI007040",
    "ics" : true
  },
  {
    "name" : "MARIBOR",
    "unCode" : "SI007067",
    "ics" : true
  },
  {
    "name" : "GRUŠKOVJE",
    "unCode" : "SI007075",
    "ics" : true
  },
  {
    "name" : "IDRIJA",
    "unCode" : "SI008071",
    "ics" : true
  },
  {
    "name" : "VRTOJBA",
    "unCode" : "SI008128",
    "ics" : true
  },
  {
    "name" : "SEŽANA",
    "unCode" : "SI009043",
    "ics" : true
  },
  {
    "name" : "LUČENEC NS",
    "unCode" : "SK517200",
    "ics" : true
  },
  {
    "name" : "Zvolen NS",
    "unCode" : "SK517700",
    "ics" : true
  },
  {
    "name" : "BRATISLAVA - LETISKO",
    "unCode" : "SK524200",
    "ics" : true
  },
  {
    "name" : "Bratislava - Pošta",
    "unCode" : "SK525100",
    "ics" : true
  },
  {
    "name" : "BRATISLAVA - PRÍSTAV",
    "unCode" : "SK526400",
    "ics" : true
  },
  {
    "name" : "BRATISLAVA Jonáša",
    "unCode" : "SK526700",
    "ics" : true
  },
  {
    "name" : "ČIERNA NAD TISOU -ŽELEZNICA A",
    "unCode" : "SK531100",
    "ics" : true
  },
  {
    "name" : "ČIERNA NAD TISOU-ŠIROKÝ ROZCHOD 'C'",
    "unCode" : "SK531102",
    "ics" : true
  },
  {
    "name" : "ČIERNA NAD TISOU - TKD DOBRÁ",
    "unCode" : "SK531103",
    "ics" : true
  },
  {
    "name" : "MAŤOVCE - ŽELEZNICA",
    "unCode" : "SK531400",
    "ics" : true
  },
  {
    "name" : "VYŠNÉ NEMECKÉ",
    "unCode" : "SK532100",
    "ics" : true
  },
  {
    "name" : "UBĽA",
    "unCode" : "SK532300",
    "ics" : true
  },
  {
    "name" : "MICHALOVCE",
    "unCode" : "SK536100",
    "ics" : true
  },
  {
    "name" : "KOŠICE - LETISKO",
    "unCode" : "SK564100",
    "ics" : true
  },
  {
    "name" : "KOŠICE POŠTA",
    "unCode" : "SK565100",
    "ics" : true
  },
  {
    "name" : "Košice - Haniska",
    "unCode" : "SK565300",
    "ics" : true
  },
  {
    "name" : "PCÚ Košice Haniska - pracovisko ŠRT",
    "unCode" : "SK565301",
    "ics" : true
  },
  {
    "name" : "SPIŠSKÁ NOVÁ VES",
    "unCode" : "SK567100",
    "ics" : true
  },
  {
    "name" : "DUNAJSKÁ STREDA",
    "unCode" : "SK586100",
    "ics" : true
  },
  {
    "name" : "DUNAJSKÁ STREDA - METRANS",
    "unCode" : "SK586101",
    "ics" : true
  },
  {
    "name" : "TRNAVA",
    "unCode" : "SK586400",
    "ics" : true
  },
  {
    "name" : "SENICA",
    "unCode" : "SK586500",
    "ics" : true
  },
  {
    "name" : "Senica - Skalica",
    "unCode" : "SK586501",
    "ics" : true
  },
  {
    "name" : "GALANTA",
    "unCode" : "SK587100",
    "ics" : true
  },
  {
    "name" : "MARTIN",
    "unCode" : "SK606300",
    "ics" : true
  },
  {
    "name" : "ŽILINA - NS",
    "unCode" : "SK606900",
    "ics" : true
  },
  {
    "name" : "TRSTENÁ",
    "unCode" : "SK607600",
    "ics" : true
  },
  {
    "name" : "RUŽOMBEROK",
    "unCode" : "SK607700",
    "ics" : true
  },
  {
    "name" : "KOMÁRNO",
    "unCode" : "SK615500",
    "ics" : true
  },
  {
    "name" : "LEVICE",
    "unCode" : "SK615700",
    "ics" : true
  },
  {
    "name" : "NOVÉ ZÁMKY - NS",
    "unCode" : "SK615800",
    "ics" : true
  },
  {
    "name" : "TOPOĽČANY",
    "unCode" : "SK616300",
    "ics" : true
  },
  {
    "name" : "NITRA",
    "unCode" : "SK616500",
    "ics" : true
  },
  {
    "name" : "PREŠOV NS",
    "unCode" : "SK626300",
    "ics" : true
  },
  {
    "name" : "STARÁ ĽUBOVŇA",
    "unCode" : "SK627200",
    "ics" : true
  },
  {
    "name" : "POPRAD",
    "unCode" : "SK627300",
    "ics" : true
  },
  {
    "name" : "TRENČÍN KASÁRENSKÁ",
    "unCode" : "SK666100",
    "ics" : true
  },
  {
    "name" : "NOVÉ MESTO NAD VÁHOM",
    "unCode" : "SK666300",
    "ics" : true
  },
  {
    "name" : "PÚCHOV",
    "unCode" : "SK666500",
    "ics" : true
  },
  {
    "name" : "PRIEVIDZA",
    "unCode" : "SK666700",
    "ics" : true
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000001",
    "ics" : false
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000002",
    "ics" : false
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000008",
    "ics" : false
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000009",
    "ics" : false
  },
  {
    "name" : "DOĞUBEYAZIT GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041500",
    "ics" : false
  },
  {
    "name" : "GÜRBULAK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041600",
    "ics" : false
  },
  {
    "name" : "ERZURUM GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041700",
    "ics" : false
  },
  {
    "name" : "DİLUCU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041800",
    "ics" : false
  },
  {
    "name" : "KARS GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041900",
    "ics" : false
  },
  {
    "name" : "IĞDIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR042200",
    "ics" : false
  },
  {
    "name" : "ESENBOĞA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060200",
    "ics" : false
  },
  {
    "name" : "KONYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060500",
    "ics" : false
  },
  {
    "name" : "KAYSERİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060600",
    "ics" : false
  },
  {
    "name" : "ÜRGÜP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060700",
    "ics" : false
  },
  {
    "name" : "AKSARAY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061000",
    "ics" : false
  },
  {
    "name" : "KIRIKKALE O.A.R. GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061300",
    "ics" : false
  },
  {
    "name" : "ANKARA GAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061500",
    "ics" : false
  },
  {
    "name" : "ANKARA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061600",
    "ics" : false
  },
  {
    "name" : "KARAMAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062100",
    "ics" : false
  },
  {
    "name" : "KIRŞEHİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062200",
    "ics" : false
  },
  {
    "name" : "NİĞDE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062300",
    "ics" : false
  },
  {
    "name" : "KAYSERİ SERBEST BÖLGE MÜDÜRLÜĞÜ",
    "unCode" : "TR062400",
    "ics" : false
  },
  {
    "name" : "KONYA EREĞLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062500",
    "ics" : false
  },
  {
    "name" : "ANTALYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070100",
    "ics" : false
  },
  {
    "name" : "ANTALYA HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070200",
    "ics" : false
  },
  {
    "name" : "ANTALYA SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR070300",
    "ics" : false
  },
  {
    "name" : "ALANYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070400",
    "ics" : false
  },
  {
    "name" : "KAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070500",
    "ics" : false
  },
  {
    "name" : "FİNİKE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070600",
    "ics" : false
  },
  {
    "name" : "ISPARTA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070700",
    "ics" : false
  },
  {
    "name" : "DALAMAN HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070800",
    "ics" : false
  },
  {
    "name" : "FETHİYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070900",
    "ics" : false
  },
  {
    "name" : "BODRUM GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR071000",
    "ics" : false
  },
  {
    "name" : "MİLAS HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR071300",
    "ics" : false
  },
  {
    "name" : "MARMARİS GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR071400",
    "ics" : false
  },
  {
    "name" : "HOPA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080100",
    "ics" : false
  },
  {
    "name" : "SARP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080200",
    "ics" : false
  },
  {
    "name" : "AKTAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080300",
    "ics" : false
  },
  {
    "name" : "TÜRKGÖZÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080400",
    "ics" : false
  },
  {
    "name" : "RİZE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080500",
    "ics" : false
  },
  {
    "name" : "BURSA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160100",
    "ics" : false
  },
  {
    "name" : "MUDANYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160200",
    "ics" : false
  },
  {
    "name" : "GEMLİK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160400",
    "ics" : false
  },
  {
    "name" : "BANDIRMA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160600",
    "ics" : false
  },
  {
    "name" : "ESKİŞEHİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160700",
    "ics" : false
  },
  {
    "name" : "BALIKESİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161200",
    "ics" : false
  },
  {
    "name" : "YALOVA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161500",
    "ics" : false
  },
  {
    "name" : "AYVALIK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161600",
    "ics" : false
  },
  {
    "name" : "İNEGÖL GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161700",
    "ics" : false
  },
  {
    "name" : "KÜTAHYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161900",
    "ics" : false
  },
  {
    "name" : "BOZÜYÜK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR162100",
    "ics" : false
  },
  {
    "name" : "DİYARBAKIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210100",
    "ics" : false
  },
  {
    "name" : "MARDİN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210200",
    "ics" : false
  },
  {
    "name" : "NUSAYBİN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210300",
    "ics" : false
  },
  {
    "name" : "HABUR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210400",
    "ics" : false
  },
  {
    "name" : "BATMAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210500",
    "ics" : false
  },
  {
    "name" : "SİLOPİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210600",
    "ics" : false
  },
  {
    "name" : "KAPIKULE YOLCU SALONU GÜMRÜK MÜD",
    "unCode" : "TR220100",
    "ics" : false
  },
  {
    "name" : "KAPIKULE TIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220200",
    "ics" : false
  },
  {
    "name" : "KAPIKULE GAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220400",
    "ics" : false
  },
  {
    "name" : "İPSALA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220500",
    "ics" : false
  },
  {
    "name" : "UZUNKÖPRÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220600",
    "ics" : false
  },
  {
    "name" : "PAZARKULE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220700",
    "ics" : false
  },
  {
    "name" : "DEREKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220800",
    "ics" : false
  },
  {
    "name" : "HAMZABEYLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR221300",
    "ics" : false
  },
  {
    "name" : "GAZİANTEP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270100",
    "ics" : false
  },
  {
    "name" : "İSLAHİYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270200",
    "ics" : false
  },
  {
    "name" : "ÖNCÜPINAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270300",
    "ics" : false
  },
  {
    "name" : "ÇOBANBEY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270400",
    "ics" : false
  },
  {
    "name" : "AKÇAKALE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270600",
    "ics" : false
  },
  {
    "name" : "ŞANLIURFA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270900",
    "ics" : false
  },
  {
    "name" : "KARKAMIŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR271000",
    "ics" : false
  },
  {
    "name" : "GAZİANTEP HAVALİMANI GÜMRÜK MDR",
    "unCode" : "TR271100",
    "ics" : false
  },
  {
    "name" : "ADIYAMAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR271200",
    "ics" : false
  },
  {
    "name" : "NİZİP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR271300",
    "ics" : false
  },
  {
    "name" : "İSKENDERUN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310100",
    "ics" : false
  },
  {
    "name" : "CİLVEGÖZÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310400",
    "ics" : false
  },
  {
    "name" : "YAYLADAĞI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310500",
    "ics" : false
  },
  {
    "name" : "İSDEMİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310600",
    "ics" : false
  },
  {
    "name" : "ANTAKYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310800",
    "ics" : false
  },
  {
    "name" : "OSMANİYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR311200",
    "ics" : false
  },
  {
    "name" : "MERSİN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330100",
    "ics" : false
  },
  {
    "name" : "MERSİN SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR330500",
    "ics" : false
  },
  {
    "name" : "MERSİN AKARYAKIT GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330600",
    "ics" : false
  },
  {
    "name" : "TAŞUCU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330700",
    "ics" : false
  },
  {
    "name" : "ADANA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330900",
    "ics" : false
  },
  {
    "name" : "İNCİRLİK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR331000",
    "ics" : false
  },
  {
    "name" : "BOTAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR331400",
    "ics" : false
  },
  {
    "name" : "YUMURTALIK SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR331500",
    "ics" : false
  },
  {
    "name" : "GÖLOVASI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR331900",
    "ics" : false
  },
  {
    "name" : "ATATURK HAVA LİM. YOL. SAL. GÜM.MÜD",
    "unCode" : "TR340100",
    "ics" : false
  },
  {
    "name" : "ATATÜRK HAVALİMANI KARGO GÜMRÜK MDR",
    "unCode" : "TR340300",
    "ics" : false
  },
  {
    "name" : "İSTANBUL POSTA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR340600",
    "ics" : false
  },
  {
    "name" : "BEYLİKDÜZÜ AKARYAKIT GÜMRÜK MÜDÜR.",
    "unCode" : "TR340700",
    "ics" : false
  },
  {
    "name" : "KARAKÖY YOLCU SALONU GÜMRÜK MÜD",
    "unCode" : "TR340800",
    "ics" : false
  },
  {
    "name" : "HAYDARPAŞA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR340900",
    "ics" : false
  },
  {
    "name" : "ERENKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR341200",
    "ics" : false
  },
  {
    "name" : "MURATBEY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR341300",
    "ics" : false
  },
  {
    "name" : "İSTANBUL HAVALİMANI GÜMRÜK MÜDÜRLÜĞ",
    "unCode" : "TR341453",
    "ics" : false
  },
  {
    "name" : "İSTANBUL HAVALİMANI YOLCU SALONU GM",
    "unCode" : "TR341454",
    "ics" : false
  },
  {
    "name" : "TRAKYA SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR342000",
    "ics" : false
  },
  {
    "name" : "İSTANBUL END. VE TIC. SERBEST BÖLGE",
    "unCode" : "TR342200",
    "ics" : false
  },
  {
    "name" : "YEŞİLKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR342400",
    "ics" : false
  },
  {
    "name" : "İSTANBUL İHTİSAS SERBEST BÖLGE",
    "unCode" : "TR342800",
    "ics" : false
  },
  {
    "name" : "AMBARLI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343100",
    "ics" : false
  },
  {
    "name" : "SABİHA GÖKÇEN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343200",
    "ics" : false
  },
  {
    "name" : "ZEYTİNBURNU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343300",
    "ics" : false
  },
  {
    "name" : "PENDİK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343400",
    "ics" : false
  },
  {
    "name" : "HALKALI GAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343500",
    "ics" : false
  },
  {
    "name" : "İZMİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350300",
    "ics" : false
  },
  {
    "name" : "İZMİR YOLCU SALONU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350500",
    "ics" : false
  },
  {
    "name" : "ADNAN MENDERES GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350700",
    "ics" : false
  },
  {
    "name" : "DİKİLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350900",
    "ics" : false
  },
  {
    "name" : "ÇEŞME GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351000",
    "ics" : false
  },
  {
    "name" : "FOÇA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351100",
    "ics" : false
  },
  {
    "name" : "MANİSA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351700",
    "ics" : false
  },
  {
    "name" : "KUŞADASI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351800",
    "ics" : false
  },
  {
    "name" : "ALİAĞA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351900",
    "ics" : false
  },
  {
    "name" : "DENİZLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR352100",
    "ics" : false
  },
  {
    "name" : "EGE SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR352200",
    "ics" : false
  },
  {
    "name" : "UŞAK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR352800",
    "ics" : false
  },
  {
    "name" : "AFYONKARAHİSAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR352900",
    "ics" : false
  },
  {
    "name" : "İZMİR SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR353100",
    "ics" : false
  },
  {
    "name" : "İZMİR TIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR353200",
    "ics" : false
  },
  {
    "name" : "ALAŞEHİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR353300",
    "ics" : false
  },
  {
    "name" : "AYDIN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR353400",
    "ics" : false
  },
  {
    "name" : "İZMİT GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410100",
    "ics" : false
  },
  {
    "name" : "DERİNCE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410300",
    "ics" : false
  },
  {
    "name" : "DİLOVASI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410500",
    "ics" : false
  },
  {
    "name" : "SAKARYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410700",
    "ics" : false
  },
  {
    "name" : "KARASU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410800",
    "ics" : false
  },
  {
    "name" : "GEBZE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411300",
    "ics" : false
  },
  {
    "name" : "KÖRFEZ PETROKİMYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411400",
    "ics" : false
  },
  {
    "name" : "KARADENİZ EREĞLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411500",
    "ics" : false
  },
  {
    "name" : "ZONGULDAK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411600",
    "ics" : false
  },
  {
    "name" : "KARABÜK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411700",
    "ics" : false
  },
  {
    "name" : "BARTIN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411800",
    "ics" : false
  },
  {
    "name" : "BOLU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411900",
    "ics" : false
  },
  {
    "name" : "MALATYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440100",
    "ics" : false
  },
  {
    "name" : "KAHRAMANMARAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440200",
    "ics" : false
  },
  {
    "name" : "ELAZIĞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440300",
    "ics" : false
  },
  {
    "name" : "SİVAS GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440400",
    "ics" : false
  },
  {
    "name" : "BİNGÖL GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440500",
    "ics" : false
  },
  {
    "name" : "SAMSUN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550100",
    "ics" : false
  },
  {
    "name" : "ORDU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550200",
    "ics" : false
  },
  {
    "name" : "ÜNYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550300",
    "ics" : false
  },
  {
    "name" : "ÇORUM GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550700",
    "ics" : false
  },
  {
    "name" : "AMASYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR551000",
    "ics" : false
  },
  {
    "name" : "İNEBOLU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR551100",
    "ics" : false
  },
  {
    "name" : "SİNOP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR551200",
    "ics" : false
  },
  {
    "name" : "ORDU-GİRESUN HAVALİMANI GÜM. MÜD.",
    "unCode" : "TR551300",
    "ics" : false
  },
  {
    "name" : "TEKİRDAĞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590100",
    "ics" : false
  },
  {
    "name" : "ÇORLU HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590200",
    "ics" : false
  },
  {
    "name" : "AVRUPA SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR590300",
    "ics" : false
  },
  {
    "name" : "ÇERKEZKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590400",
    "ics" : false
  },
  {
    "name" : "ÇANAKKALE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590500",
    "ics" : false
  },
  {
    "name" : "BİGA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590800",
    "ics" : false
  },
  {
    "name" : "MARMARAEREĞLİSİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590900",
    "ics" : false
  },
  {
    "name" : "TRABZON GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR610100",
    "ics" : false
  },
  {
    "name" : "GİRESUN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR610400",
    "ics" : false
  },
  {
    "name" : "VAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR650800",
    "ics" : false
  },
  {
    "name" : "ESENDERE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR650900",
    "ics" : false
  },
  {
    "name" : "KAPIKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR651000",
    "ics" : false
  },
  {
    "name" : "YÜKSEKOVA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR651300",
    "ics" : false
  },
  {
    "name" : "ÜZÜMLÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR651500",
    "ics" : false
  },
  {
    "name" : "BCP Boryspil CP Boryspil",
    "unCode" : "UA100040",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Vіshneve",
    "unCode" : "UA100060",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Vіshneve",
    "unCode" : "UA100070",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Zakhidnyi",
    "unCode" : "UA100100",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Zakhidnyi",
    "unCode" : "UA100110",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Zakhidnyi",
    "unCode" : "UA100120",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Zakhidnyi",
    "unCode" : "UA100130",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Kyiv-tsentralnyi",
    "unCode" : "UA100140",
    "ics" : false
  },
  {
    "name" : "BCP Richport CP Kyiv-tsentralnyi",
    "unCode" : "UA100150",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Kyiv-tsentralnyi",
    "unCode" : "UA100160",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Lisky",
    "unCode" : "UA100180",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Lisky",
    "unCode" : "UA100190",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Lisky",
    "unCode" : "UA100200",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Lisky",
    "unCode" : "UA100210",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Рivdennyi",
    "unCode" : "UA100230",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Рivdennyi",
    "unCode" : "UA100240",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Рivdennyi",
    "unCode" : "UA100250",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Рivdennyi",
    "unCode" : "UA100260",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Рivdennyi",
    "unCode" : "UA100270",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Spetsializovanyi",
    "unCode" : "UA100290",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Spetsializovanyi",
    "unCode" : "UA100300",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Spetsializovanyi",
    "unCode" : "UA100310",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Stolychnyi",
    "unCode" : "UA100320",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Stolychnyi",
    "unCode" : "UA100330",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Skhidnyi",
    "unCode" : "UA100340",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Skhidnyi",
    "unCode" : "UA100350",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Skhidnyi",
    "unCode" : "UA100360",
    "ics" : false
  },
  {
    "name" : "CP UkrРoshta",
    "unCode" : "UA100370",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Chaiky",
    "unCode" : "UA100380",
    "ics" : false
  },
  {
    "name" : "CCD 2 Chaiky",
    "unCode" : "UA100390",
    "ics" : false
  },
  {
    "name" : "CCS 1CP Chaiky",
    "unCode" : "UA100400",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Chaiky",
    "unCode" : "UA100410",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Vishneve",
    "unCode" : "UA100430",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Vishneve",
    "unCode" : "UA100440",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Lisky",
    "unCode" : "UA100450",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Zhytomyr",
    "unCode" : "UA101020",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Zhytomyr",
    "unCode" : "UA101030",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Zhytomyr",
    "unCode" : "UA101040",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Pivnichnyi",
    "unCode" : "UA101070",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Pivnichnyi",
    "unCode" : "UA101080",
    "ics" : false
  },
  {
    "name" : "CP Zviahel",
    "unCode" : "UA101090",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Pivnichniy",
    "unCode" : "UA101130",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Pivnichniy",
    "unCode" : "UA101150",
    "ics" : false
  },
  {
    "name" : "CP Kozelets",
    "unCode" : "UA102020",
    "ics" : false
  },
  {
    "name" : "CCS CP Kozelets",
    "unCode" : "UA102030",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Pryluky",
    "unCode" : "UA102080",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Pryluky",
    "unCode" : "UA102090",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Pryluky",
    "unCode" : "UA102100",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Pryluky",
    "unCode" : "UA102110",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Snovsk",
    "unCode" : "UA102160",
    "ics" : false
  },
  {
    "name" : "ContrPt At Chernihiv Station",
    "unCode" : "UA102170",
    "ics" : false
  },
  {
    "name" : "CP Chernihiv",
    "unCode" : "UA102210",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Snovsk",
    "unCode" : "UA102220",
    "ics" : false
  },
  {
    "name" : "CP Kamianske",
    "unCode" : "UA110020",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Kamianske",
    "unCode" : "UA110030",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Kamianske",
    "unCode" : "UA110040",
    "ics" : false
  },
  {
    "name" : "CP Samar",
    "unCode" : "UA110050",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Samar",
    "unCode" : "UA110060",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Kryvyi Rih",
    "unCode" : "UA110070",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Kryvyi Rih",
    "unCode" : "UA110080",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Kryvyi Rih",
    "unCode" : "UA110090",
    "ics" : false
  },
  {
    "name" : "CP Lisky",
    "unCode" : "UA110110",
    "ics" : false
  },
  {
    "name" : "CP Nikopol",
    "unCode" : "UA110120",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Slobozhans'kyi",
    "unCode" : "UA110130",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Slobozhans'kyi",
    "unCode" : "UA110140",
    "ics" : false
  },
  {
    "name" : "CP Dnipro-Pravoberezhnyi",
    "unCode" : "UA110150",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Slobozhans`kyi",
    "unCode" : "UA110180",
    "ics" : false
  },
  {
    "name" : "CP Zaporizhzhia-Aeroport",
    "unCode" : "UA112030",
    "ics" : false
  },
  {
    "name" : "CP Zaporizhzhia",
    "unCode" : "UA112080",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Rivne",
    "unCode" : "UA204020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Rivne",
    "unCode" : "UA204030",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Rivne",
    "unCode" : "UA204040",
    "ics" : false
  },
  {
    "name" : "CP Sarny",
    "unCode" : "UA204060",
    "ics" : false
  },
  {
    "name" : "CP Dubno",
    "unCode" : "UA204080",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Rivne",
    "unCode" : "UA204130",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Rivne",
    "unCode" : "UA204140",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Rivne",
    "unCode" : "UA204150",
    "ics" : false
  },
  {
    "name" : "BCP Yahodyn-Dorohusk CCD 3-6",
    "unCode" : "UA205020",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Yahodyn",
    "unCode" : "UA205030",
    "ics" : false
  },
  {
    "name" : "BCP Yahodyn-Dorohusk CCD 2",
    "unCode" : "UA205040",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Kovel",
    "unCode" : "UA205050",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Volodymyr",
    "unCode" : "UA205080",
    "ics" : false
  },
  {
    "name" : "BCP Volodymyr-Volynskyi-Khrubeshuv",
    "unCode" : "UA205090",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Volodymyr",
    "unCode" : "UA205100",
    "ics" : false
  },
  {
    "name" : "BCP Ustyluh-Zosin CCD 1-4",
    "unCode" : "UA205110",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Lutsk",
    "unCode" : "UA205140",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Lutsk",
    "unCode" : "UA205150",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Lutsk",
    "unCode" : "UA205170",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Kovel",
    "unCode" : "UA205180",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Kovel",
    "unCode" : "UA205190",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Prykarpattia",
    "unCode" : "UA206020",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Prykarpattia",
    "unCode" : "UA206030",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Prykarpattia",
    "unCode" : "UA206050",
    "ics" : false
  },
  {
    "name" : "CP Kalush",
    "unCode" : "UA206060",
    "ics" : false
  },
  {
    "name" : "CP Dolyna",
    "unCode" : "UA206070",
    "ics" : false
  },
  {
    "name" : "CP Kolomyia",
    "unCode" : "UA206080",
    "ics" : false
  },
  {
    "name" : "BCP Krakivets-Korchova",
    "unCode" : "UA209030",
    "ics" : false
  },
  {
    "name" : "BCP Shehyni-Medyka CP Mostyska",
    "unCode" : "UA209040",
    "ics" : false
  },
  {
    "name" : "BCP Mostyska-Pshemysl",
    "unCode" : "UA209050",
    "ics" : false
  },
  {
    "name" : "BCP Rava-Ruska-Khrebenne",
    "unCode" : "UA209060",
    "ics" : false
  },
  {
    "name" : "BCP Rava-Ruska-Khrebenne, Werchrata",
    "unCode" : "UA209070",
    "ics" : false
  },
  {
    "name" : "BCP Smilnytsia-Krostsenko",
    "unCode" : "UA209080",
    "ics" : false
  },
  {
    "name" : "BCP Hrushiv-Budomiezh",
    "unCode" : "UA209090",
    "ics" : false
  },
  {
    "name" : "BCP Uhryniv-Dolhobychuv CP Uhryniv",
    "unCode" : "UA209100",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Lviv-Pivdennyi",
    "unCode" : "UA209110",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Lviv-Pivnichnyi",
    "unCode" : "UA209130",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Lviv-Pivnichnyi",
    "unCode" : "UA209140",
    "ics" : false
  },
  {
    "name" : "CCD 5 CP Lviv-Pivnichnyi",
    "unCode" : "UA209150",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Lviv-Pivnichnyi",
    "unCode" : "UA209160",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Horodok",
    "unCode" : "UA209170",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Horodok",
    "unCode" : "UA209180",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Horodok",
    "unCode" : "UA209190",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Horodok",
    "unCode" : "UA209200",
    "ics" : false
  },
  {
    "name" : "CP Lviv-Poshtovyi",
    "unCode" : "UA209210",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Lviv-Pivnichnyi",
    "unCode" : "UA209230",
    "ics" : false
  },
  {
    "name" : "CCD CP Mostyska",
    "unCode" : "UA209250",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Lviv-Pivdennyi",
    "unCode" : "UA209260",
    "ics" : false
  },
  {
    "name" : "CCD 5 CP Horodok",
    "unCode" : "UA209270",
    "ics" : false
  },
  {
    "name" : "BCP Chop-Zakhon",
    "unCode" : "UA305020",
    "ics" : false
  },
  {
    "name" : "BCP Chop - Zakhon",
    "unCode" : "UA305030",
    "ics" : false
  },
  {
    "name" : "ContrP Batieve BCP Salovka-Eperjes.",
    "unCode" : "UA305050",
    "ics" : false
  },
  {
    "name" : "BCP Chop-Zakhon CP Tysa",
    "unCode" : "UA305060",
    "ics" : false
  },
  {
    "name" : "BCP Uzhhorod-Vyshnie-Niemetske",
    "unCode" : "UA305090",
    "ics" : false
  },
  {
    "name" : "BCP Malyi Bereznyi-Ubl'a",
    "unCode" : "UA305100",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Vynohradiv",
    "unCode" : "UA305110",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Vynohradiv",
    "unCode" : "UA305120",
    "ics" : false
  },
  {
    "name" : "CCD 1,4 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305130",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305140",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305150",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Mukachevo",
    "unCode" : "UA305160",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Mukachevo",
    "unCode" : "UA305170",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Mukachevo",
    "unCode" : "UA305180",
    "ics" : false
  },
  {
    "name" : "BCP Pavlove-Matiovtse",
    "unCode" : "UA305190",
    "ics" : false
  },
  {
    "name" : "BCP Luzhanka-Berehshuran CP Astei",
    "unCode" : "UA305200",
    "ics" : false
  },
  {
    "name" : "BCP Vylok-Tisabech CCD 1-4 CP Vylok",
    "unCode" : "UA305230",
    "ics" : false
  },
  {
    "name" : "BCP Diakove-Halmeu CCD 1-4",
    "unCode" : "UA305240",
    "ics" : false
  },
  {
    "name" : "BCP Diakove-Halmeu CCD 5 CP Diakove",
    "unCode" : "UA305250",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Vynohradiv",
    "unCode" : "UA305270",
    "ics" : false
  },
  {
    "name" : "CCD 5 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305290",
    "ics" : false
  },
  {
    "name" : "BCP Velyka Palad-Nadhodosh",
    "unCode" : "UA305350",
    "ics" : false
  },
  {
    "name" : "CP Kamianets-Podilskyi",
    "unCode" : "UA400020",
    "ics" : false
  },
  {
    "name" : "CP Slavuta",
    "unCode" : "UA400030",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Khmelnytskyi",
    "unCode" : "UA400040",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Khmelnytskyi",
    "unCode" : "UA400050",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Khmelnytskyi",
    "unCode" : "UA400070",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Vinnytsia",
    "unCode" : "UA401020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Vinnytsia",
    "unCode" : "UA401030",
    "ics" : false
  },
  {
    "name" : "CCD CP Vinnytsia",
    "unCode" : "UA401050",
    "ics" : false
  },
  {
    "name" : "CP Haisyn",
    "unCode" : "UA401060",
    "ics" : false
  },
  {
    "name" : "BCP Mohyliv-Podilskyi-Otach",
    "unCode" : "UA401080",
    "ics" : false
  },
  {
    "name" : "BCP Mohyliv-Podilskyi-Volchynets",
    "unCode" : "UA401090",
    "ics" : false
  },
  {
    "name" : "BCP Bronnytsia-Ungur CCD 4",
    "unCode" : "UA401100",
    "ics" : false
  },
  {
    "name" : "CP Pishchanka",
    "unCode" : "UA401110",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Dnister",
    "unCode" : "UA401160",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Ternopil",
    "unCode" : "UA403020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Ternopil",
    "unCode" : "UA403030",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Ternopil",
    "unCode" : "UA403040",
    "ics" : false
  },
  {
    "name" : "CP Chortkiv",
    "unCode" : "UA403060",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Ternopil",
    "unCode" : "UA403070",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Chernivtsi",
    "unCode" : "UA408020",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Chernivtsi",
    "unCode" : "UA408040",
    "ics" : false
  },
  {
    "name" : "BCP Porubne-Siret CCD 1-2",
    "unCode" : "UA408050",
    "ics" : false
  },
  {
    "name" : "BCP Vadyl-Siret-Vikshany CCD 3",
    "unCode" : "UA408060",
    "ics" : false
  },
  {
    "name" : "BCP Mamalyha-Кryva CCD 1",
    "unCode" : "UA408070",
    "ics" : false
  },
  {
    "name" : "BCP Mamalyha-Кryva CCD 2",
    "unCode" : "UA408080",
    "ics" : false
  },
  {
    "name" : "BCP Кelmentsi-Larha CCD 1",
    "unCode" : "UA408090",
    "ics" : false
  },
  {
    "name" : "BCP Larha BCP Кеlmetsi-Larha CCD 2",
    "unCode" : "UA408100",
    "ics" : false
  },
  {
    "name" : "BCP Rossoshany-Brichen CCD 3",
    "unCode" : "UA408110",
    "ics" : false
  },
  {
    "name" : "BCP Sokyriany-Oknytsia CCD 4",
    "unCode" : "UA408120",
    "ics" : false
  },
  {
    "name" : "BCP Sokyriany-Oknytsia CCD 5",
    "unCode" : "UA408130",
    "ics" : false
  },
  {
    "name" : "BCP Vashkivtsi-Hrimenkeuts CCD 6",
    "unCode" : "UA408140",
    "ics" : false
  },
  {
    "name" : "BCP Diakivtsi-Rakovets CP Diakivtsi",
    "unCode" : "UA408150",
    "ics" : false
  },
  {
    "name" : "BCP Krasnoilsk-Vikovu de Sus",
    "unCode" : "UA408160",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Chernivtsi",
    "unCode" : "UA408170",
    "ics" : false
  },
  {
    "name" : "BCP Odeskyi Morskyi Port CCD 1",
    "unCode" : "UA500020",
    "ics" : false
  },
  {
    "name" : "BCP Odeskyi Morskyi Port CCD 3",
    "unCode" : "UA500040",
    "ics" : false
  },
  {
    "name" : "BCP Odesa Morskyi Port CCD 4",
    "unCode" : "UA500050",
    "ics" : false
  },
  {
    "name" : "BCP Odeskyi Morskyi Port CCD 2",
    "unCode" : "UA500060",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Chornomorsk",
    "unCode" : "UA500080",
    "ics" : false
  },
  {
    "name" : "BCP Chornomorskyi Port CCD 3",
    "unCode" : "UA500090",
    "ics" : false
  },
  {
    "name" : "BCP Chornomorskyi Port CCD 2",
    "unCode" : "UA500100",
    "ics" : false
  },
  {
    "name" : "BCP Chornomorskyi Rybnyi Port",
    "unCode" : "UA500110",
    "ics" : false
  },
  {
    "name" : "BCP Chornomorskyi Sudnorem. Zavod",
    "unCode" : "UA500120",
    "ics" : false
  },
  {
    "name" : "ContrP Vyzyrka CCD 1",
    "unCode" : "UA500130",
    "ics" : false
  },
  {
    "name" : "BCP Morskyi port Pivdennyi CCD 2",
    "unCode" : "UA500140",
    "ics" : false
  },
  {
    "name" : "BCP Starokozache-Tudora",
    "unCode" : "UA500160",
    "ics" : false
  },
  {
    "name" : "BCP Maiaky-Udobne-Palanka CCD 1",
    "unCode" : "UA500170",
    "ics" : false
  },
  {
    "name" : "BCP Serpneve 1-Basarabiaska CCD 2",
    "unCode" : "UA500180",
    "ics" : false
  },
  {
    "name" : "BCP Bilhorod-Dnistrovskyi Port",
    "unCode" : "UA500190",
    "ics" : false
  },
  {
    "name" : "BCP Maloiaroslavets 1-Chadur-Lunha",
    "unCode" : "UA500200",
    "ics" : false
  },
  {
    "name" : "BCP Lisne-Seits CCD 2",
    "unCode" : "UA500210",
    "ics" : false
  },
  {
    "name" : "CCD 4 CP Dnistrovskyi",
    "unCode" : "UA500220",
    "ics" : false
  },
  {
    "name" : "BCP Kuchurhan-Novosavytske",
    "unCode" : "UA500310",
    "ics" : false
  },
  {
    "name" : "CCD 5 CP Dnistrovskyi",
    "unCode" : "UA500350",
    "ics" : false
  },
  {
    "name" : "BCP Izmailskyi Morskyi Port CCD 1",
    "unCode" : "UA500370",
    "ics" : false
  },
  {
    "name" : "BCP Reni-Dzhiurdzhiulesht CCD 4",
    "unCode" : "UA500380",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Prydunaiskiy",
    "unCode" : "UA500390",
    "ics" : false
  },
  {
    "name" : "BCP Tabaky-Myrne CCD 2",
    "unCode" : "UA500400",
    "ics" : false
  },
  {
    "name" : "BCP Ust-Dunaiskyi Morskyi Port",
    "unCode" : "UA500410",
    "ics" : false
  },
  {
    "name" : "BCP Orlivka CCD 5 CP Prydunaiskiy",
    "unCode" : "UA500420",
    "ics" : false
  },
  {
    "name" : "BCP Vynohradivka-Vulcanesti CCD 2",
    "unCode" : "UA500430",
    "ics" : false
  },
  {
    "name" : "BCP Dolynske-Chishmikioi CCD 4",
    "unCode" : "UA500440",
    "ics" : false
  },
  {
    "name" : "BCP Reni-Dzhiurdzhiulesht CCD 3",
    "unCode" : "UA500450",
    "ics" : false
  },
  {
    "name" : "BCP Reniiskyi Morskyi Port CCD 3",
    "unCode" : "UA500460",
    "ics" : false
  },
  {
    "name" : "BCP Novi Troiany-Chadyr-Lunga CCD 2",
    "unCode" : "UA500470",
    "ics" : false
  },
  {
    "name" : "BCP Frikatsey-Etulia CCD 3",
    "unCode" : "UA500480",
    "ics" : false
  },
  {
    "name" : "ContrP Odesa-Lisky CCD 1 CP",
    "unCode" : "UA500490",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Odesa-vnutrishnyi",
    "unCode" : "UA500500",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Odesa-vnutrishnyi",
    "unCode" : "UA500520",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Prydunaiskiy",
    "unCode" : "UA500530",
    "ics" : false
  },
  {
    "name" : "CCD 5 CP Chornomorsk",
    "unCode" : "UA500540",
    "ics" : false
  },
  {
    "name" : "CP Podilsk",
    "unCode" : "UA500550",
    "ics" : false
  },
  {
    "name" : "BCP Serpneve 1-Basarabiaska CCD 2",
    "unCode" : "UA500570",
    "ics" : false
  },
  {
    "name" : "CCD 6 CP Chornomorsk",
    "unCode" : "UA500580",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Odesa-vnutrishnyi",
    "unCode" : "UA500590",
    "ics" : false
  },
  {
    "name" : "CP Mizhnarodnyi Aeroport Odesa",
    "unCode" : "UA500600",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Pervomaisk",
    "unCode" : "UA504070",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Pervomaisk",
    "unCode" : "UA504080",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Kostiantynivka",
    "unCode" : "UA504170",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Kostiantynivka",
    "unCode" : "UA504180",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Kostiantynivka",
    "unCode" : "UA504190",
    "ics" : false
  },
  {
    "name" : "CP Pervomaisk",
    "unCode" : "UA504210",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Sumy",
    "unCode" : "UA805020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Sumy",
    "unCode" : "UA805030",
    "ics" : false
  },
  {
    "name" : "CP Romny",
    "unCode" : "UA805090",
    "ics" : false
  },
  {
    "name" : "CP Shostka",
    "unCode" : "UA805170",
    "ics" : false
  },
  {
    "name" : "CP Konotop",
    "unCode" : "UA805200",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Poltava",
    "unCode" : "UA806020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Poltava",
    "unCode" : "UA806030",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Poltava",
    "unCode" : "UA806040",
    "ics" : false
  },
  {
    "name" : "CCS 2 CP Poltava",
    "unCode" : "UA806050",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Kremenchuk",
    "unCode" : "UA806070",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Kremenchuk",
    "unCode" : "UA806080",
    "ics" : false
  },
  {
    "name" : "CCS 3 CP Poltava",
    "unCode" : "UA806090",
    "ics" : false
  },
  {
    "name" : "CCD 3 CP Poltava",
    "unCode" : "UA806100",
    "ics" : false
  },
  {
    "name" : "ContrP Kharkiv-Sortuvalnyi",
    "unCode" : "UA807090",
    "ics" : false
  },
  {
    "name" : "CP Kharkiv-tovarnyi",
    "unCode" : "UA807180",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Barabashovo",
    "unCode" : "UA807190",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Barabashovo",
    "unCode" : "UA807200",
    "ics" : false
  },
  {
    "name" : "CP Babai",
    "unCode" : "UA807210",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Aeroport Kharkiv",
    "unCode" : "UA807230",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Kropyvnytskyi",
    "unCode" : "UA901020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Kropyvnytskyi",
    "unCode" : "UA901030",
    "ics" : false
  },
  {
    "name" : "CP Oleksandriia",
    "unCode" : "UA901050",
    "ics" : false
  },
  {
    "name" : "CCS 1 CP Oleksandriia",
    "unCode" : "UA901060",
    "ics" : false
  },
  {
    "name" : "CCD 1 CP Cherkasy",
    "unCode" : "UA902020",
    "ics" : false
  },
  {
    "name" : "CCD 2 CP Cherkasy",
    "unCode" : "UA902040",
    "ics" : false
  },
  {
    "name" : "CCS Smila CP Cherkasy",
    "unCode" : "UA902050",
    "ics" : false
  },
  {
    "name" : "CCS Bogdan Logystyc CP Cherkasy",
    "unCode" : "UA902060",
    "ics" : false
  },
  {
    "name" : "CCS Korsun-Shevchenkyvskyi",
    "unCode" : "UA902070",
    "ics" : false
  },
  {
    "name" : "CP Uman",
    "unCode" : "UA902080",
    "ics" : false
  },
  {
    "name" : "CCS Zvenygorodka CP Uman",
    "unCode" : "UA902090",
    "ics" : false
  },
  {
    "name" : "CCD Kyiv CP Tsentralnyi",
    "unCode" : "UA903020",
    "ics" : false
  },
  {
    "name" : "CCD Korosten CP Tsentralnyi",
    "unCode" : "UA903040",
    "ics" : false
  },
  {
    "name" : "CCD Lviv CP Zakhidnyi",
    "unCode" : "UA903050",
    "ics" : false
  },
  {
    "name" : "CCD Kalush CP Pivdenno-Zakhidnyi",
    "unCode" : "UA903060",
    "ics" : false
  },
  {
    "name" : "CCD Mukachevo CP Zakhidnyi",
    "unCode" : "UA903070",
    "ics" : false
  },
  {
    "name" : "CCD Novohrad-Volynskyi CP Zakhidnyi",
    "unCode" : "UA903080",
    "ics" : false
  },
  {
    "name" : "CCD Odesa CP Pivdennyi",
    "unCode" : "UA903110",
    "ics" : false
  },
  {
    "name" : "BCP Odeskyi Port CP Pivdennyi",
    "unCode" : "UA903120",
    "ics" : false
  },
  {
    "name" : "CCD Izmail CP Pivdennyi",
    "unCode" : "UA903150",
    "ics" : false
  },
  {
    "name" : "BCP Mykolaivskyi Port CP Pivdennyi",
    "unCode" : "UA903170",
    "ics" : false
  },
  {
    "name" : "CCD Poltava CP Tsentralnyi",
    "unCode" : "UA903180",
    "ics" : false
  },
  {
    "name" : "CCD Chernivtsy",
    "unCode" : "UA903200",
    "ics" : false
  },
  {
    "name" : "CCD Reni CP Pivdennyi",
    "unCode" : "UA903210",
    "ics" : false
  },
  {
    "name" : "CCD Kovel CP Zakhidnyi",
    "unCode" : "UA903220",
    "ics" : false
  },
  {
    "name" : "CCS Vinnytsia CP Pivdenno-Zakhidnyi",
    "unCode" : "UA903230",
    "ics" : false
  },
  {
    "name" : "CCD Uzhhorod CP Zakhidnyi",
    "unCode" : "UA903240",
    "ics" : false
  },
  {
    "name" : "CCD Boryspil CP Tsentralnyi",
    "unCode" : "UA903250",
    "ics" : false
  },
  {
    "name" : "CCD Odesa Vantazhnyi CP Pivdennyi",
    "unCode" : "UA903260",
    "ics" : false
  },
  {
    "name" : "NI Auth Consignor/nees",
    "unCode" : "XI000081",
    "ics" : true
  },
  {
    "name" : "Belfast",
    "unCode" : "XI000142",
    "ics" : true
  },
  {
    "name" : "Warrenpoint",
    "unCode" : "XI005160",
    "ics" : true
  },
  {
    "name" : "Larne",
    "unCode" : "XI005220",
    "ics" : true
  }
]
